/*
  Turkish interface strings. Keys are the English source (see ./index.js);
  a key missing here falls back to English. Generated from the Russian/Spanish key set
  and checked for placeholders and markup; edit by hand like any other map.
*/

const tr = {
  "White pages": "White pages",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Botlar/reklam incelemesi için statik sayfalar — burada barındırılır, kendi alan adınızda aynı origin'den sunulur (Google güvenli cloaking)",
  "White pages (hosted, same-origin)": "White pages (barındırılmış, aynı origin)",
  "Safe page URL (external)": "Güvenli sayfa URL'si (harici)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Harici güvenli sayfa — tracker aynı origin'den proxy'ler (kimlik etiketleri kaldırılır). Hiçbir white page seçilmediğinde kullanılır. Mutlak bir http(s) URL'si olmalıdır. Bu yöntem tek başına Google incelemesini geçer; barındırılmış white page, tamamen kendi alan adınızdan sunulan daha sağlam bir alternatiftir.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "İsteğe bağlı — Google/Facebook için en sağlam seçenek: kampanya alan adınızdan (/wp/…) sunulur, böylece nihai URL alan adında kalır. Her istekte rastgele döndürmek için birkaç tane seçin; böylece tek bir white yüzlerce reklamda tekrar kullanılmaz. White pages bölümünden yönetin.",
  "selected — rotated per request": "seçili — her istekte döndürülür",
  "No white pages yet. Upload some under White pages, then pick them here.": "Henüz white page yok. White pages bölümünden ekleyin, ardından buradan seçin.",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Select several to rotate a random one per request — so one white isn’t reused across hundreds of ads. Manage under White pages.": "Google/Facebook için önerilir: kampanya alan adınızdan (/wp/…) sunulur, böylece reklamın nihai URL'si alan adında kalır ve incelemeyi geçer. Her istekte rastgele döndürmek için birkaç tane seçin — böylece tek bir white yüzlerce reklamda tekrar kullanılmaz. White pages bölümünden yönetin.",
  "Static pages for bots & ad review": "Botlar ve reklam incelemesi için statik sayfalar",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Botlara ve reklam inceleyicilerine sunulan uyumlu statik sayfalar — kampanya alan adınızla aynı origin'den.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Bu sayfalar burada barındırılır ve doğrulanmış alan adlarınızdan herhangi birinde /wp/<slug>/ yolunda aynı origin'den sunulur. Kampanyanın Cloaking ayarlarından birini seçin — botlar ve Google/Facebook inceleyicileri bu sayfayı görür, gerçek kullanıcılar teklifi görür.",
  "Upload white page": "White page yükle",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Statik bir ZIP dosyası yükleyin (index.html + varlıklar). PHP'ye izin verilmez. Maks. 50 MB.",
  "My white page": "White page'im",
  "What this white page is for": "Bu white page'in amacı",
  "Static files only (.html/.css/.js/images). No .php.": "Yalnızca statik dosyalar (.html/.css/.js/görseller). .php yok.",
  "Please enter a name for the white page": "White page için bir ad girin",
  "White page uploaded successfully": "White page başarıyla yüklendi",
  "Error uploading white page": "White page yüklenirken hata oluştu",
  "Error loading white pages": "White pages yüklenirken hata oluştu",
  "Error deleting white page": "White page silinirken hata oluştu",
  "White page deleted": "White page silindi",
  "No white pages": "White page yok",
  "Upload a static white page to use for campaign cloaking": "Kampanya cloaking'inde kullanmak için statik bir white page yükleyin",
  "Search white pages…": "White page ara…",
  "Same-origin path": "Aynı origin yolu",
  "Delete white page": "White page'i sil",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "Bu işlem \"{name}\" ve dosyalarını kalıcı olarak siler. Hâlâ bu sayfayı işaret eden kampanyalar, Güvenli sayfa URL'sine (yoksa doğrudan teklife) yönlendirilir.",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Birden fazla HTML sayfası tespit edildi. Botların yönlendirileceği ana sayfayı seçin.",
  "White page (hosted, same-origin)": "White page (barındırılmış, aynı origin)",
  "None — use Safe page URL below": "Yok — aşağıdaki Güvenli sayfa URL'sini kullan",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Manage these under White pages.": "Google/Facebook için önerilir: kendi kampanya alan adınızdan (/wp/…) sunulur, böylece reklamın nihai URL'si alan adında kalır ve incelemeyi geçer. White pages bölümünden yönetin.",
  "Safe page URL (external fallback)": "Güvenli sayfa URL'si (harici fallback)",
  "Optional fallback, used only when no white page is selected above. Must be an absolute http(s) URL. Note: an external URL lives on another domain — exactly what triggers Google’s “destination mismatch”, so prefer a white page for paid search.": "İsteğe bağlı fallback; yalnızca yukarıda hiçbir white page seçilmediğinde kullanılır. Mutlaka geçerli bir http(s) URL'si olmalıdır. Not: harici bir URL farklı bir domain üzerinde bulunur — bu durum Google'ın \"destination mismatch\" hatasını tetikler; bu nedenle ücretli arama için white page tercih edin.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Cloaking için bir white page seçin veya geçerli bir http(s) güvenli sayfa URL'si girin",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "Bu kampanya için kopyalamaya hazır takip linki. Birden fazla domain'i tek kampanyada kullanmak için domain'i doğrulanmış herhangi bir workspace domain'iyle değiştirin; reklam ağı, tıklama anında placeholder'ları otomatik olarak doldurur.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Bu kampanyaya gelen postback'leri doğrulayan gizli anahtar. Ağa verdiğiniz postback URL'lerine &token=… olarak ekleyin. Gizli tutun; bu anahtara sahip olan herkes dönüşüm kaydedebilir.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Ağın gönderdiği ham durum değerlerini kendi kategorilerimize çevirin. Öncelik sırası: URL'deki inline parametre > bu kampanya haritası > affiliate ağı ön ayarı > özel tipler > yerleşik varsayılanlar.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Bir dönüşüm geldiğinde başka bir sistemi (trafik kaynağınız, başka bir tracker, Telegram) bilgilendiren giden çağrılar. Facebook/Google/TikTok gibi reklam platformlarının CAPI'si için bunun yerine Conversion forwarders kullanın — hashlenmiş kişisel veri ve yeniden deneme desteği sunar.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Takip linkinizdeki sorgu dizisi parametre adı — URL-güvenli tutun: harf, rakam ve _ (boşluk kullanmayın). Boşluklar otomatik olarak _'ye dönüştürülür; bu sayede linkte %20 görünmez.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "UA örüntüsüyle tespit edilen botlar ve arama motoru crawler'ı kimliğine bürünen UA'lar (başarısız DNS doğrulaması) güvenli sayfaya yönlendirilir.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "DNS ile doğrulanmış arama motoru crawler'ları (Googlebot/Bingbot/…) güvenli sayfaya yönlendirilir. Gerçek teklifi indekslemelerine izin vermek için kapatın.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "Datacenter veya Tor çıkış IP'lerinden gelen ziyaretçiler güvenli sayfaya yönlendirilir.",
  "Visitors behind a proxy/VPN get the safe page.": "Proxy/VPN arkasındaki ziyaretçiler güvenli sayfaya yönlendirilir.",
  "Works only when an active Google Ads forwarder exists (simple mode or with a conversion tag). The AW-…/label can be passed per click via the tm parameter, so one campaign credits conversions to different accounts.": "Yalnızca aktif bir Google Ads forwarder mevcut olduğunda çalışır (basit mod veya dönüşüm etiketiyle). AW-…/label, tm parametresi aracılığıyla tıklama başına iletilebilir; böylece tek bir kampanya farklı hesaplara dönüşüm atayabilir.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Yönlendirmede Google Ads gtag tetikle (tıklama anında dönüşüm)",
  "Fires a Google Ads conversion at the click moment (on /r/, before the offer) from the AW-…/label in the {tm} parameter — no forwarder needed. This optimizes Google on CLICKS, not on registrations/deposits.": "{tm} parametresindeki AW-…/label'a göre tıklama anında (/r/ üzerinde, tekliften önce) Google Ads dönüşümü tetikler — forwarder gerekmez. Bu, Google'ı TIKLAMA üzerine optimize eder; kayıt/depozito üzerine değil.",
  "Click-time signal: the conversion fires for every clean click, so Google optimizes on clicks. To optimize on real registrations/deposits keep this OFF and use the \"Google Ads\" button under Forwarding — S2S postbacks (fires on the broker postback by {gclid}). Leaving both on double-counts.": "Tıklama anı sinyali: dönüşüm her temiz tıklama için tetiklenir, dolayısıyla Google tıklamalar üzerine optimize eder. Gerçek kayıt/depozito üzerine optimize etmek için bunu KAPALI bırakın ve Forwarding bölümündeki \"Google Ads\" butonunu kullanın — S2S postback'ler ({gclid} ile broker postback'i geldiğinde tetiklenir). Her ikisini birden açmak dönüşümleri çift sayar.",
  "Bot model": "Bot modeli",
  "Member access": "Üye erişimi",
  "Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.": "Her ekip üyesinin neler görebileceğini ve düzenleyebileceğini belirleyin — varlık bazında ve hangi rapor metriklerini okuyabileceklerini kapsayacak şekilde. Sahipler ve yöneticiler hiçbir zaman kısıtlanmaz.",
  "Member": "Üye",
  "Choose a member…": "Bir üye seçin…",
  "Failed to load members": "Üyeler yüklenemedi",
  "Retry": "Tekrar dene",
  "No team members yet": "Henüz takım üyesi yok",
  "Invite teammates from the Workspace page, then configure their access here.": "Workspace sayfasından takım arkadaşlarınızı davet edin, ardından erişimlerini burada yapılandırın.",
  "Pick a member to configure": "Yapılandırmak için bir üye seçin",
  "Their entity access and allowed report metrics will show up here.": "Üyenin varlık erişimi ve izin verilen rapor metrikleri burada görünecek.",
  "Failed to load member access": "Üye erişimi yüklenemedi",
  "Owners and admins have full, unrestricted access": "Sahipler ve yöneticiler tam, kısıtsız erişime sahiptir",
  "You can still save these rules, but they stay inert unless the role changes to manager or viewer.": "Bu kuralları yine de kaydedebilirsiniz; ancak rol yönetici veya görüntüleyici olarak değişmedikçe etkisiz kalırlar.",
  "Entity access": "Varlık erişimi",
  "Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.": "Tam varsayılandır: kısıtlama yok. Salt okunur düzenlemeleri engeller. Seçilenlere, üyeyi yalnızca belirtilen ID'lerle sınırlar. Oluşturulan ve seçilenler, üyenin kendisinin oluşturduğu her şeyi ekler.",
  "Entity": "Varlık",
  "Access mode": "Erişim modu",
  "Allowed IDs": "İzin verilen ID'ler",
  "Full": "Tam",
  "Read-only": "Salt okunur",
  "To selected": "Seçilenlere",
  "Created and selected": "Oluşturulan ve seçilenler",
  "IDs, comma or space separated": "ID'ler, virgül veya boşlukla ayrılmış",
  "IDs of the specific items this member may access": "Bu üyenin erişebileceği belirli öğelerin ID'leri",
  "No IDs yet — the member will only see items they created themselves.": "Henüz ID yok — üye yalnızca kendisinin oluşturduğu öğeleri görecek.",
  "No IDs yet — the member will not see any items of this type.": "Henüz ID yok — üye bu türde hiçbir öğeyi göremeyecek.",
  "All items": "Tüm öğeler",
  "Allowed report metrics": "İzin verilen rapor metrikleri",
  "Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.": "Bu üyenin rapor ve panolarda görebileceği metrikleri açın veya kapatın. Hiçbir metrik seçili değilse kısıtlama uygulanmaz.",
  "All metrics (no restriction)": "Tüm metrikler (kısıtlama yok)",
  "metrics allowed": "metriğe izin verildi",
  "Clear (allow all)": "Temizle (tümüne izin ver)",
  "Save access": "Erişimi kaydet",
  "Member access saved": "Üye erişimi kaydedildi",
  "Failed to save member access": "Üye erişimi kaydedilemedi",
  "Click traces": "Tıklama izleri",
  "Diagnostics": "Tanılama",
  "Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.": "Her birinin arkasındaki tam yönlendirme kararıyla birlikte örneklenmiş gerçek tıklamalar — hangi akışların değerlendirildiği ve kazananın neden eşleştiği.",
  "Pick a campaign above to inspect where its real clicks were routed and why.": "Gerçek tıklamaların nereye yönlendirildiğini ve nedenini incelemek için yukarıdan bir kampanya seçin.",
  "Live-click tracing": "Canlı tıklama izleme",
  "Enable live-click tracing": "Canlı tıklama izlemeyi etkinleştir",
  "Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.": "Varsayılan olarak kapalıdır. Etkinleştirildiğinde, gerçek tıklamaların örneklenmiş bir kısmı tam yönlendirme izini kaydeder. Gizlilik açısından güvenlidir: IP adresi veya user agent saklanmaz ve izler otomatik olarak sona erer.",
  "Sample rate (%)": "Örnekleme oranı (%)",
  "Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.": "İzlenecek tıklama payı, 0 ile 100% arasında. Örnek: %10, yaklaşık her on tıklamadan birini izler.",
  "Sample rate must be between 0 and 100": "Örnekleme oranı 0 ile 100 arasında olmalıdır",
  "Trace settings saved": "İzleme ayarları kaydedildi",
  "Error loading click traces": "Tıklama izleri yüklenirken hata oluştu",
  "Could not load traces": "İzler yüklenemedi",
  "Something went wrong while loading click traces for this campaign.": "Bu kampanya için tıklama izleri yüklenirken bir hata oluştu.",
  "No traces yet": "Henüz iz yok",
  "Enable tracing above; traces of sampled real clicks will appear here.": "Yukarıdan izlemeyi etkinleştirin; örneklenen gerçek tıklamaların izleri burada görünecek.",
  "Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.": "İzleme açık — trafik geldikçe örneklenen gerçek tıklamaların izleri burada görünecek. Hiçbir şey görünmüyorsa örnekleme oranını kontrol edin.",
  "Flags": "Bayraklar",
  "Show routing trace": "Routing izini göster",
  "Hide routing trace": "Routing izini gizle",
  "Per-stream verdicts": "Stream başına kararlar",
  "No per-stream verdicts were recorded for this click.": "Bu tıklama için stream başına karar kaydedilmedi.",
  "Not matched": "Eşleşme yok",
  "Filters evaluated": "Değerlendirilen filtreler",
  "Relation": "İlişki",
  "Page": "Sayfa",
  "entries": "kayıt",
  "just now": "az önce",
  "{n}m ago": "{n}dk önce",
  "{n}h ago": "{n}s önce",
  "ML bot model": "ML bot modeli",
  "Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.": "Zayıf denetimli bot sınıflandırıcısı: son tıklamalar üzerinde eğitin, metrikleri inceleyin ve anlık payload'ları puanlayın. Yalnızca gölge modunda çalışır — canlı routing'i hiçbir zaman etkilemez.",
  "Admin access required": "Yönetici erişimi gerekli",
  "The ML bot-model panel is only available to workspace admins.": "ML bot modeli paneli yalnızca workspace yöneticilerine açıktır.",
  "Error loading bot-model status": "Bot modeli durumu yüklenirken hata oluştu",
  "Model status": "Model durumu",
  "Trained": "Eğitildi",
  "Not trained": "Eğitilmedi",
  "Inference": "Çıkarım",
  "Degenerate": "Bozuk",
  "Trained on a single class or too few samples — metrics are not meaningful.": "Tek sınıf veya çok az örnekle eğitildi — metrikler anlamlı değil.",
  "Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.": "Çıkarım varsayılan olarak kapalıdır ve yalnızca gölge modunda çalışır — etkinleştirilse bile puanlar yalnızca analiz için tıklamalara kaydedilir ve routing'i hiçbir zaman etkilemez.",
  "Accuracy": "Doğruluk",
  "Positive rate": "Pozitif oran",
  "Log loss": "Log loss",
  "AUC": "AUC",
  "Training samples": "Eğitim örnekleri",
  "Trained at": "Eğitim tarihi",
  "No bot model trained yet. Train one on recent clicks below.": "Henüz eğitilmiş bot modeli yok. Aşağıda son tıklamalar üzerinde bir model eğitin.",
  "Train model": "Modeli eğit",
  "Training…": "Eğitiliyor…",
  "Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.": "Eğitim, en fazla 5.000 son tıklamayı çeker, mevcut bot buluşsal yöntemleriyle (user agent, benzersizlik, davranış puanı) zayıf etiketler ve küçük bir lojistik regresyon modeli uydurur. Yeniden eğitim, kayıtlı modelin yerini alır.",
  "Model trained on {n} clicks — accuracy {acc}": "{n} tıklama üzerinde eğitilen model — doğruluk {acc}",
  "Model trained on {n} clicks": "{n} tıklama üzerinde eğitilen model",
  "No click data to train on yet.": "Henüz eğitim için tıklama verisi yok.",
  "Training finished": "Eğitim tamamlandı",
  "Training failed": "Eğitim başarısız oldu",
  "Score a sample": "Örnek puanla",
  "Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.": "Geliştirici aracı: tıklama biçiminde bir JSON payload yapıştırın ve eğitilmiş modelden geçirin. Hiçbir şey kaydedilmez ve canlı trafik etkilenmez.",
  "Click payload (JSON)": "Tıklama payload'ı (JSON)",
  "Score": "Puan",
  "Scoring…": "Puanlanıyor…",
  "Reset example": "Örneği sıfırla",
  "Invalid JSON — check the payload and try again.": "Geçersiz JSON — payload'ı kontrol edip tekrar deneyin.",
  "Payload must be a JSON object.": "Payload bir JSON nesnesi olmalıdır.",
  "No trained model — train one first.": "Eğitilmiş model yok — önce bir model eğitin.",
  "Scoring failed": "Puanlama başarısız",
  "Likely bot": "Muhtemelen bot",
  "Likely human": "Muhtemelen insan",
  "Threshold 0.5 — scores above are flagged as bots.": "Eşik 0.5 — bu değerin üzerindeki skorlar bot olarak işaretlenir.",
  "Heuristic weak label": "Sezgisel zayıf etiket",
  "Human": "İnsan",
  "Feature": "Özellik",
  "{n} min ago": "{n} dk önce",
  "{n} h ago": "{n} sa önce",
  "{n} d ago": "{n} gün önce",
  "Archive & restore": "Arşivle ve geri yükle",
  "Access control": "Erişim kontrolü",
  "Offer rotation on daily cap": "Günlük kap dolduğunda offer rotasyonu",
  "No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.": "Eşik ayarlamaya gerek yok. Bu kural, kampanyada kullanılan herhangi bir offer günlük kapasitesine ulaştığında tetiklenir ve trafiğin yedek / kalan offer'lara yönlendirildiğini bildirir. Kap ve yedek offer'ı her offer için ayrı ayrı ayarlayın.",
  "Connection types": "Bağlantı türleri",
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Ağ bağlantı türüne göre filtrele. 'hosting' (datacenter/bulut) kutudan çıktığı gibi çalışır; cellular veya wifi gibi diğer değerler için edge proxy'nin X-Connection-Type başlığı göndermesi gerekir.",
  "Status mapping": "Durum eşleştirme",
  "Add status": "Durum ekle",
  "No status mappings added": "Durum eşleştirmesi eklenmedi",
  "Network status (e.g. ftd)": "Ağ durumu (örn. ftd)",
  "Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.": "Bu ağın gönderdiği ham durumu standart bir bucket'a eşleştirin. Kampanya durum haritası eşleşmediğinde gelen postback'lere uygulanır.",
  "Lead": "Lead",
  "Sale": "Satış",
  "Reject": "Reddet",
  "Upsell": "Upsell",
  "Ignore": "Yoksay",
  "Split testing": "Split testing",
  "Parameter filters": "Parametre filtreleri",
  "Params": "Parametreler",
  "Split testing enabled": "Split testing etkin",
  "Split testing disabled": "Split testing devre dışı",
  "Failed to update campaign": "Kampanya güncellenemedi",
  "Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.": "Akış rotasyonu. Açık: Normal akışlar ağırlığa göre döner, konum dikkate alınmaz. Kapalı: akışlar konuma göre yukarıdan aşağıya kontrol edilir ve ilk eşleşen tüm trafiği alır. Catch akışları her zaman önce devreye girer ve ağırlığa göre hiçbir zaman rotasyon yapmaz.",
  "Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.": "URL alt parametrelerine göre yönlendir. Satır başına bir kural: name=value1, value2 listelenen değerlere izin verir; name!=value1, value2 bunları engeller (eksik parametre engelleme kuralını geçer). Değersiz bir kural hiçbir kısıtlama eklemez.",
  "Regions": "Bölgeler",
  "GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.": "GeoIP bölge / eyalet / oblast adları (örn. California, Bavaria). Maskeler, /regex/ ve @empty desteklenir.",
  "IP addresses": "IP adresleri",
  "Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.": "Tam IP'ler, CIDR blokları (10.0.0.0/8) veya maskeler (192.168.*). Kendi test IP'lerinizi izin listesine eklemek veya bir datacenter aralığını engellemek için kullanışlıdır.",
  "User agents": "User agent'lar",
  "Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.": "Ham User-Agent'a karşı eşleştirilen alt dizeler, maskeler veya /regex/ — örn. *Chrome/12* Chrome 120+ hedefler, HeadlessChrome headless tarayıcıları yakalar.",
  "Clicks per hour": "Saatte tıklama sayısı",
  "Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.": "Kayan pencere limiti: son bir saat içinde bu kadar tıklama alındıktan sonra akış YENİ tıklamaları kabul etmeyi durdurur, trafik bir sonraki akışa geçer. Boş = limit yok.",
  "Clicks per 24h": "24 saatte tıklama sayısı",
  "Rolling-window limit over the last 24 hours. Empty = no limit.": "Son 24 saat üzerindeki kayan pencere limiti. Boş = limit yok.",
  "Filter relation": "Filtre ilişkisi",
  "AND: the click must pass every configured filter. OR: any single passing filter admits the click.": "AND: tıklama yapılandırılmış her filtreyi geçmelidir. OR: herhangi bir filtreyi geçmesi tıklamayı kabul ettirir.",
  "AND (all)": "AND (tümü)",
  "OR (any)": "OR (herhangi biri)",
  "Is": "Eşittir",
  "Is not": "Eşit değil",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Akışın aktif olduğu haftanın günleri ve saatler. Saat, kampanya sahibinin saat dilimine göredir. 'Eşit değil' zamanlamayı tersine çevirir: akış belirtilen saatler DIŞINDA tıklamaları kabul eder.",
  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Yalnızca notlar ve filtreler için serbest metin ağ etiketi — hiçbir etkisi yoktur. Gerçek bir bağlantı için aşağıdaki Affiliate network alanını veya Affiliate routing bloğunu kullanın.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Affiliate networks bölümünden yeniden kullanılabilir bir partner ağı: postback şablonu, teklif parametreleri ve ağ bazlı raporlar. İsteğe bağlı.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Düz yönlendirmeli bir teklifte tıklamanın gideceği yer. Makrolar çalışır: {click_id}, {country_code}, {gclid} ve daha fazlası. Form tekliflerinde (CRM'e lead) URL herhangi bir şey olabilir.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Teklif başına günlük maksimum dönüşüm sayısı. Limite ulaşıldığında trafik yedek teklife yönlendirilir. Boş = limit yok.",
  "Time zone in which the daily cap is counted and the counter resets.": "Günlük limitin sayıldığı ve sayacın sıfırlandığı saat dilimi.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Yedek teklif: ana teklif günlük limitine ulaştığında trafik buraya yönlendirilir.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "Leadın gönderildiği partner/CRM. Integrations bölümünde bir kez yapılandırın (TrackBox veya Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "Partnerdeki teklifin Box/Goal ID'si — hangi ürün/box leadi alır. Değeri partner sağlar (örn. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Birden fazla partner olduğunda bu partnere düşen lead payı (split/rotasyon). Örn. 70 ve 30 = %70 ve %30.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Kapalı = partner geçici olarak atlanır (örn. başlangıç kararlaştırılana kadar); ayarları korunur.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Yalnızca BU teklife ait form endpoint'i. Genellikle GEREKLİ DEĞİLDİR — ortak /api/lead'i kullanın (belgelere bakın). Yalnızca bir formu belirli bir teklife bağlamak için kullanılır.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Her form gönderiminde (kabul edildi/reddedildi/test) Telegram bildirimi. Kampanya Telegram postback'inden ayrıdır (o, onaylanan bir dönüşümde tetiklenir). Bot token'ı @BotFather'dan alınır; grup Chat ID'si -100… ile başlar.",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "Hiçbir akış eşleşmediğinde kullanılan varsayılan URL. Yönlendirme genellikle akışlar tarafından yönetilir — bu alan bir güvenlik ağıdır.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "Reklam platformu (Google Ads, Facebook…). Tıklama verilerini iletmek için takip bağlantısına eklenen makro/sub ID setini tanımlar.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Maliyet nasıl hesaplanır: CPC — tıklama başına, CPM — 1000 gösterim başına, CPA — dönüşüm başına. Raporlardaki Maliyet / ROI / CPC / CPA değerlerini etkiler.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "Tracker'ın teklif URL'sine click_id eklemek için kullandığı GET parametre adı (örn. click_id → ?click_id=…). Partnerin postback'te bu click_id'yi geri gönderebilmesi için gereklidir. Form snippet'leri hem click_id hem de clickid parametrelerini okur.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "xpnsr_vid cookie'sini ayarlama (cookie'yi yasaklayan ağlar için). Tekil ziyaret tespiti IP+User Agent üzerinden yapılır; click_id ise URL aracılığıyla iletilir — yukarıdaki Click ID forward parameter alanı.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "IP'yi kaydetmeden önce hashle (GDPR için). GEO, hashleme işleminden ÖNCE çözümlenir; dolayısıyla ülke/şehir hedeflemesi etkilenmez.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Yönlendirme yöntemi: 302 — hızlı standart yönlendirme; Meta refresh / JS — ağ 302'yi takip etmediğinde veya gtag gerektiğinde; Cloaked (iframe) — teklif URL'sini adres çubuğundan gizler.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — filtreli standart akış; Catch — hiçbir Normal akışla eşleşmeyen trafiği yakalar; Default — hiçbir şey eşleşmediğinde son çare akışı.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Kontrol önceliği. Sayı ne kadar düşükse akış o kadar erken kontrol edilir. Trafik ilk eşleşen akışa yönlendirilir.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Aynı türde birden fazla akış varsa aralarındaki trafik dağılımı (split). Örn. 70 ve 30 = %70 ve %30.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Bu akış için maksimum tıklama sayısı. Limite ulaşıldığında akış trafik almayı durdurur. Boş bırakılırsa limit yoktur.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — akışın landing page/teklifine yönlendir; Action — özel yanıt (örn. fraud önleme için 404 / boş yanıt); Split test — varyantlar arasında trafik böl.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Ziyaret tekliğine göre filtrele: yalnızca tekil / yalnızca tekrarlayan / filtreleme.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Bot'lar nasıl ele alınsın (User-Agent ile tespit edilir): filtreleme / yalnızca bot'lar / bot'ları hariç tut. Fraud önleme akışı için kullanışlıdır.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Proxy/VPN filtresi (datacenter/Tor): filtreleme / yalnızca proxy / proxy'yi hariç tut.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Yalnızca IPv4 veya yalnızca IPv6'ya izin ver ya da filtreleme.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Akışın aktif olduğu haftanın günleri ve saatler. Saat, kampanya sahibinin saat dilimine göredir.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Hazır platform şablonu (Google Ads, Facebook…) — bu kaynak için adı, standart makro/sub'ları ve S2S postback'i otomatik doldurur.",
  "Search templates…": "Şablon ara…",
  "All categories": "Tüm kategoriler",
  "Templates in catalog": "Katalogdaki şablonlar",
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "İsteğe bağlı. Dönüşümde reklam ağına gönderilen giden postback — platformun kendi tarafında kampanyaları optimize edebilmesi için (örn. eski Facebook CAPI).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Platformun tıklamada ilettiği parametreler (sub1…subN, gclid, tm vb.). Bunlar makroya dönüşür, raporlarda görünür ve takip bağlantısına eklenir.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — kendi API'leri için yazılmış bir adaptör. Custom API — diğer tüm CRM'ler için: isteği kendiniz yapılandırırsınız (URL, header'lar, body, redirect'in nereden okunacağı).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "Partnerin gizli Push/Registration anahtarı. Partner panelinde (API / API Testing bölümü) bulabilir veya affiliate manager'ınızdan talep edebilirsiniz.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Partnerdeki Affiliate ID'niz. Partner tarafından sağlanır.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Partnerdeki Campaign ID. Aksi belirtilmedikçe genellikle 1'dir.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "LEAD (kayıt) olarak değerlendirilecek ham ağ statüleri. Virgülle ayırın. Örn. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "SALE/depozit olarak değerlendirilecek ham statüler. Örn. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Red/kötü kalite statüleri. Örn. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Bu statüler sessizce düşürülür — dönüşüm olarak kaydedilmez. Örn. spam, junk, test.",
  "Dashboard": "Dashboard",
  "Campaigns": "Kampanyalar",
  "Landing pages": "Landing page'ler",
  "Offers": "Offer'lar",
  "Sources": "Trafik kaynakları",
  "Report": "Rapor",
  "Group clicks and conversions by any dimension with full metrics.": "Tıklamaları ve dönüşümleri istediğiniz boyuta göre tam metriklerle gruplayın.",
  "Grouped by": "Gruplama ölçütü",
  "No data for this period.": "Bu dönem için veri yok.",
  "Empty ref.": "Boş ref.",
  "Group": "Grup",
  "— no level —": "— seviye yok —",
  "Click a row to drill in": "Detayları görmek için satıra tıklayın",
  "Expand": "Genişlet",
  "Collapse": "Daralt",
  "Open in clicks log": "Tıklama logunda aç",
  "Failed to load": "Yüklenemedi",
  "Card view": "Kart görünümü",
  "Table view": "Tablo görünümü",
  "Save view": "Görünümü kaydet",
  "Save current view": "Mevcut görünümü kaydet",
  "Saved views": "Kayıtlı görünümler",
  "Delete view": "Görünümü sil",
  "View saved": "Görünüm kaydedildi",
  "View name": "Görünüm adı",
  "Remember the current filters, sort and layout under a name for one-click recall.": "Mevcut filtreler, sıralama ve düzeni tek tıkla geri çağırmak için bir isim altında kaydedin.",
  "e.g. Tier-1 by revenue": "örn. Tier-1 gelire göre",
  "Upload pre-landing (ZIP)": "Pre-landing yükle (ZIP)",
  "Upload a ZIP with your warm-up page. index.html is auto-detected.": "Ön ısınma sayfanızı içeren bir ZIP yükleyin. index.html otomatik olarak algılanır.",
  "ZIP file": "ZIP dosyası",
  "Pre-landing uploaded": "Pre-landing yüklendi",
  "Upload failed": "Yükleme başarısız",
  "Choose a ZIP file": "Bir ZIP dosyası seçin",
  "Uploaded": "Yüklendi",
  "Uploading…": "Yükleniyor…",
  "Columns": "Sütunlar",
  "Receiving conversions (incoming postback)": "Dönüşüm alma (gelen postback)",
  "Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.": "Bu URL'leri affiliate ağınıza (örn. TrackBox) yapıştırın; böylece ağ, dönüşümlerde bu kampanyayı bilgilendirir. click_id'nizi ağın parametresine geçirin, buraya geri döner.",
  "Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.": "Ağın ham durumlarını bizimkilere eşleyin (virgülle ayrılmış). Her ağ için çalışır ve bu kampanyanın gelen tüm postback'lerine uygulanır. URL'deki inline parametreler önceliklidir.",
  "Forwarding — S2S postbacks": "Yönlendirme — S2S postback'ler",
  "Landing click": "Landing page tıklaması",
  "Time on landing": "Landing page'de geçirilen süre",
  "sec": "sn",
  "OS": "İşletim Sistemi",
  "ISP / provider": "ISP / sağlayıcı",
  "Proxy": "Proxy",
  "Empty referrer": "Boş referrer",
  "Bots": "Bot'lar",
  "Only bots": "Yalnızca bot'lar",
  "Exclude bots": "Bot'ları hariç tut",
  "Proxy / VPN": "Proxy / VPN",
  "Only proxy": "Yalnızca proxy",
  "Exclude proxy": "Proxy'yi hariç tut",
  "IP version": "IP versiyonu",
  "Show 404": "404 göster",
  "Do nothing": "Hiçbir şey yapma",
  "Schedule": "Zamanlama",
  "Add interval": "Aralık ekle",
  "Every day, all day": "Her gün, tüm gün",
  "Every day": "Her gün",
  "Error loading affiliate networks": "Affiliate ağları yüklenirken hata oluştu",
  "Quick start from preset": "Hazır şablondan hızlı başlangıç",
  "Affiliate network name": "Affiliate ağı adı",
  "Vertical": "Dikey",
  "Postback URL template": "Postback URL şablonu",
  "Outbound postback the tracker calls to notify this network.": "Tracker'ın bu ağı bilgilendirmek için çağırdığı giden postback.",
  "Offer parameters": "Teklif parametreleri",
  "Key": "Anahtar",
  "Notes": "Notlar",
  "Internal notes": "Dahili notlar",
  "Affiliate networks": "Affiliate ağları",
  "Reusable partner networks: postback template, offer params and inbound URL.": "Yeniden kullanılabilir partner ağları: postback şablonu, teklif parametreleri ve gelen URL.",
  "Create network": "Ağ oluştur",
  "Create affiliate network": "Affiliate ağı oluştur",
  "Pick a preset or configure a partner network from scratch.": "Bir hazır şablon seçin veya partner ağını sıfırdan yapılandırın.",
  "Search networks": "Ağlarda ara",
  "No affiliate networks yet": "Henüz hiç affiliate ağı yok",
  "Create one from a preset like TrackBox or Adcombo.": "TrackBox veya Adcombo gibi bir hazır şablondan oluşturun.",
  "Postback copied": "Postback kopyalandı",
  "Inbound postback URL (paste in the network)": "Gelen postback URL'si (ağa yapıştırın)",
  "Inbound URL copied": "Gelen URL kopyalandı",
  "conv.": "dön.",
  "offer parameter(s)": "teklif parametresi/parametreleri",
  "Edit affiliate network": "Affiliate ağını düzenle",
  "Update partner network settings": "Partner ağı ayarlarını güncelle",
  "Delete affiliate network": "Affiliate ağını sil",
  "This permanently deletes the network. Offers linked to it keep their other settings.": "Bu işlem ağı kalıcı olarak siler. Ağa bağlı teklifler diğer ayarlarını korur.",
  "Affiliate network created": "Affiliate ağı oluşturuldu",
  "Error creating affiliate network": "Affiliate ağı oluşturulurken hata",
  "Affiliate network updated": "Affiliate ağı güncellendi",
  "Error updating affiliate network": "Affiliate ağı güncellenirken hata",
  "Affiliate network deleted": "Affiliate ağı silindi",
  "Cannot delete: network is linked to offers": "Silinemez: ağ tekliflere bağlı",
  "Error deleting affiliate network": "Affiliate ağı silinirken hata",
  "Copy failed": "Kopyalama başarısız",
  "Network (text label)": "Ağ (metin etiketi)",
  "Traffic": "Trafik",
  "A/B Tests": "A/B Testleri",
  "Anti-fraud": "Anti-fraud",
  "Analytics": "Analitik",
  "Automation": "Otomasyon",
  "Integrations": "Entegrasyonlar",
  "Settings": "Ayarlar",
  "Account": "Hesap",
  "My account": "Hesabım",
  "Profile": "Profil",
  "Sign out": "Çıkış yap",
  "User": "Kullanıcı",
  "Welcome, {name}.": "Hoş geldiniz, {name}.",
  "Welcome,": "Hoş geldiniz,",
  "Real-time overview of your campaigns and stats": "Kampanyalarınızın ve istatistiklerinizin gerçek zamanlı özeti",
  "Create campaign": "Kampanya oluştur",
  "Clicks": "Tıklamalar",
  "Unique visitors": "Tekil ziyaretçiler",
  "Conversions": "Dönüşümler",
  "Total active campaigns": "Toplam aktif kampanya",
  "Total clicks": "Toplam tıklama",
  "Unique clicks": "Tekil tıklamalar",
  "{rate}% conversion": "{rate}% dönüşüm",
  "Recent campaigns": "Son kampanyalar",
  "Your latest campaigns": "En son kampanyalarınız",
  "You have no campaigns yet": "Henüz hiç kampanyanız yok",
  "Create your first campaign": "İlk kampanyanızı oluşturun",
  "Quick actions": "Hızlı işlemler",
  "Commonly used features": "Sık kullanılan özellikler",
  "Add a new ad campaign": "Yeni reklam kampanyası ekle",
  "View detailed statistics": "Ayrıntılı istatistikleri görüntüle",
  "Manage campaigns": "Kampanyaları yönet",
  "Edit existing campaigns": "Mevcut kampanyaları düzenle",
  "Show all campaigns": "Tüm kampanyaları göster",
  "More details": "Daha fazla ayrıntı",
  "Active": "Aktif",
  "Paused": "Duraklatıldı",
  "No description": "Açıklama yok",
  "{n} clicks": "{n} tıklama",
  "{n} unique": "{n} tekil",
  "{n} conversions": "{n} dönüşüm",
  "Loading workspace": "Çalışma alanı yükleniyor",
  "Loading your data…": "Verileriniz yükleniyor…",
  "Sign in": "Giriş yap",
  "Sign up": "Kayıt ol",
  "Email": "E-posta",
  "Work email": "İş e-postası",
  "Password": "Şifre",
  "Full name": "Ad Soyad",
  "Jane Doe": "Ad Soyad",
  "Create account": "Hesap oluştur",
  "Create new account": "Yeni hesap oluştur",
  "Already have an account?": "Zaten hesabınız var mı?",
  "Don't have an account?": "Hesabınız yok mu?",
  "Welcome back": "Tekrar hoş geldiniz",
  "Sign in to your xpnsr account": "xpnsr hesabınıza giriş yapın",
  "Attribution,": "Atıf,",
  "honest": "dürüst",
  "Create": "Hesap",
  "account": "oluştur",
  "S2S postback · bot shield": "S2S postback · bot koruması",
  "Remember this device": "Bu cihazı hatırla",
  "Reset": "Sıfırla",
  "Access tracker": "Tracker'a gir",
  "Hide password": "Şifreyi gizle",
  "Show password": "Şifreyi göster",
  "At least 6 characters": "En az 6 karakter",
  "Signing in…": "Giriş yapılıyor…",
  "Creating account…": "Hesap oluşturuluyor…",
  "Invalid email or password": "Geçersiz e-posta veya şifre",
  "Registration failed. Please try again.": "Kayıt başarısız oldu. Lütfen tekrar deneyin.",
  "New registrations are disabled. Contact your workspace admin for an invitation.": "Yeni kayıtlar devre dışı. Davet almak için çalışma alanı yöneticinizle iletişime geçin.",
  "Home": "Ana Sayfa",
  "Auth": "Kimlik Doğrulama",
  "Book Demo": "Demo Rezervasyonu",
  "Search campaigns, streams…": "Kampanya, akış ara…",
  "One visual language for the xpnsr.tech family.": "xpnsr.tech ailesi için tek bir görsel dil.",
  "Control": "Kontrol",
  "Operations": "Operasyonlar",
  "Precise tracking": "Hassas tracking",
  "KPIs, sources and leads in one panel.": "KPI'lar, trafik kaynakları ve lead'ler tek panelde.",
  "Readable reports": "Okunabilir raporlar",
  "Data visualization for fast decisions.": "Hızlı kararlar için veri görselleştirme.",
  "Scale your team": "Ekibini ölçeklendir",
  "Organize teams, campaigns and sources without friction.": "Ekipleri, kampanyaları ve kaynakları sorunsuz yönet.",
  "Enter your credentials to continue.": "Devam etmek için giriş bilgilerinizi girin.",
  "Create a new xpnsr.tech account.": "Yeni bir xpnsr.tech hesabı oluşturun.",
  "Campaign management": "Kampanya yönetimi",
  "Create, edit and track your ad campaigns in real time": "Reklam kampanyalarınızı gerçek zamanlı oluşturun, düzenleyin ve takip edin",
  "Search campaigns…": "Kampanya ara…",
  "Create new campaign": "Yeni kampanya oluştur",
  "Edit campaign": "Kampanyayı düzenle",
  "Fill in the details of your new ad campaign": "Yeni reklam kampanyanızın ayrıntılarını doldurun",
  "Update campaign details": "Kampanya ayrıntılarını güncelle",
  "Campaign name": "Kampanya adı",
  "Description (optional)": "Açıklama (isteğe bağlı)",
  "Target URL": "Hedef URL",
  "Traffic source": "Trafik kaynağı",
  "Cost model": "Maliyet modeli",
  "Select a traffic source (optional)": "Trafik kaynağı seçin (isteğe bağlı)",
  "CPC (per click)": "CPC (tıklama başına)",
  "CPM (per impression)": "CPM (gösterim başına)",
  "CPA (per action)": "CPA (aksiyon başına)",
  "Cancel": "İptal",
  "Save changes": "Değişiklikleri kaydet",
  "Edit": "Düzenle",
  "Copy link": "Linki kopyala",
  "Delete": "Sil",
  "Are you sure you want to delete this campaign?": "Bu kampanyayı silmek istediğinizden emin misiniz?",
  "Campaign created successfully!": "Kampanya başarıyla oluşturuldu!",
  "Campaign updated successfully!": "Kampanya başarıyla güncellendi!",
  "Campaign deleted successfully!": "Kampanya başarıyla silindi!",
  "No campaigns": "Kampanya yok",
  "Campaigns not found": "Kampanya bulunamadı",
  "Create your first campaign to start tracking traffic": "Trafiği takip etmeye başlamak için ilk kampanyanızı oluşturun",
  "Try adjusting search criteria": "Arama kriterlerini değiştirmeyi deneyin",
  "Tracking ID": "Tracking ID",
  "Link copied to clipboard!": "Link panoya kopyalandı!",
  "Failed to copy link": "Link kopyalanamadı",
  "Error loading campaigns": "Kampanyalar yüklenirken hata oluştu",
  "Error creating campaign": "Kampanya oluşturulurken hata oluştu",
  "Error updating campaign": "Kampanya güncellenirken hata",
  "Error deleting campaign": "Kampanya silinirken hata",
  "For example: Product A ad": "Örneğin: A Ürünü reklamı",
  "Short campaign description": "Kısa kampanya açıklaması",
  "New landing page": "Yeni landing page",
  "Add landing page": "Landing page ekle",
  "Add a landing page for use in campaigns and A/B tests": "Kampanyalarda ve A/B testlerinde kullanmak için landing page ekleyin",
  "Edit landing page": "Landing page düzenle",
  "Edit landing page settings": "Landing page ayarlarını düzenle",
  "Search landing pages…": "Landing page ara…",
  "Create landing pages for use in campaigns": "Kampanyalarda kullanmak için landing page oluşturun",
  "No landing pages": "Landing page yok",
  "Nothing found": "Hiçbir şey bulunamadı",
  "Landing page created": "Landing page oluşturuldu",
  "Landing page updated": "Landing page güncellendi",
  "Landing page deleted": "Landing page silindi",
  "Delete this landing page?": "Bu landing page silinsin mi?",
  "Error loading landing pages": "Landing page'ler yüklenirken hata",
  "Error creating landing page": "Landing page oluşturulurken hata",
  "Error updating landing page": "Landing page güncellenirken hata",
  "Error deleting landing page": "Landing page silinirken hata",
  "Please fill in name and URL": "Lütfen ad ve URL alanlarını doldurun",
  "URL copied": "URL kopyalandı",
  "My landing": "Benim landing page'im",
  "Landing page description": "Landing page açıklaması",
  "Lead generation": "Lead toplama",
  "Subscription": "Abonelik",
  "Download": "İndirme",
  "Other": "Diğer",
  "Category": "Kategori",
  "Select category": "Kategori seçin",
  "Description": "Açıklama",
  "Tags": "Etiketler",
  "Add tag": "Etiket ekle",
  "Status": "Durum",
  "Inactive": "Pasif",
  "Visits": "Ziyaretler",
  "CR": "CR",
  "Actions": "İşlemler",
  "Name": "Ad",
  "URL": "URL",
  "Save": "Kaydet",
  "Unique": "Tekil",
  "Add offer": "Teklif ekle",
  "New offer": "Yeni teklif",
  "Edit offer": "Teklifi düzenle",
  "Add an offer to use in campaigns": "Kampanyalarda kullanmak için teklif ekle",
  "Change offer parameters": "Teklif parametrelerini değiştir",
  "Search offers…": "Teklifleri ara…",
  "No offers": "Teklif yok",
  "Create offers to monetize your traffic": "Trafiğinizi monetize etmek için teklifler oluşturun",
  "Offer created": "Teklif oluşturuldu",
  "Offer updated": "Teklif güncellendi",
  "Offer deleted": "Teklif silindi",
  "Delete this offer?": "Bu teklif silinsin mi?",
  "Error loading offers": "Teklifler yüklenirken hata oluştu",
  "Error creating offer": "Teklif oluşturulurken hata oluştu",
  "Error updating offer": "Teklif güncellenirken hata oluştu",
  "Error deleting offer": "Teklif silinirken hata oluştu",
  "My offer": "Teklifim",
  "Offer URL": "Teklif URL",
  "Offer description": "Teklif açıklaması",
  "Affiliate network": "Affiliate ağı",
  "Network": "Ağ",
  "Payout": "Payout",
  "Currency": "Para birimi",
  "Geo": "Geo",
  "Countries (ISO codes, e.g. US, RU)": "Ülkeler (ISO kodları, örn. US, RU)",
  "Nutra": "Nutra",
  "Gambling": "Gambling",
  "Dating": "Dating",
  "Finance": "Finans",
  "Crypto": "Crypto",
  "Sweepstakes": "Sweepstakes",
  "Back": "Geri",
  "Streams": "Akışlar",
  "Open target URL": "Hedef URL'yi aç",
  "Copy tracking link": "Takip linkini kopyala",
  "Tracking link copied!": "Takip linki kopyalandı!",
  "Campaign not found": "Kampanya bulunamadı",
  "Successful conversions": "Başarılı dönüşümler",
  "Conversion rate": "Dönüşüm oranı",
  "Conversion percentage": "Dönüşüm yüzdesi",
  "Campaign info": "Kampanya bilgisi",
  "Tracking link": "Takip linki",
  "Created": "Oluşturuldu",
  "Updated": "Güncellendi",
  "Recent clicks": "Son tıklamalar",
  "Recent activity for this campaign": "Bu kampanyanın son aktivitesi",
  "No clicks for this campaign yet": "Bu kampanya için henüz tıklama yok",
  "Showing latest 10 clicks": "Son 10 tıklama gösteriliyor",
  "Device breakdown": "Cihaz dağılımı",
  "Browser breakdown": "Tarayıcı dağılımı",
  "No data to display": "Gösterilecek veri yok",
  "Unknown": "Bilinmiyor",
  "Traffic sources": "Trafik kaynakları",
  "Create source": "Kaynak oluştur",
  "Create traffic source": "Trafik kaynağı oluştur",
  "Edit traffic source": "Trafik kaynağını düzenle",
  "Update traffic source settings": "Trafik kaynağı ayarlarını güncelle",
  "Configure a traffic source for UTM tags and conversion postbacks": "UTM etiketleri ve dönüşüm postback'leri için trafik kaynağı yapılandırın",
  "Source template": "Kaynak şablonu",
  "Pick a template or create your own": "Bir şablon seçin veya kendinizinkini oluşturun",
  "Traffic source name": "Trafik kaynağı adı",
  "Traffic source description": "Trafik kaynağı açıklaması",
  "Postback URL": "Postback URL",
  "Postback URL copied": "Postback URL kopyalandı",
  "UTM parameters": "UTM parametreleri",
  "Add parameter": "Parametre ekle",
  "Enter parameter name:": "Parametre adını girin:",
  "Parameter": "Parametre",
  "Alias": "Alias",
  "Placeholder": "Yer Tutucu",
  "Action": "İşlem",
  "Source macro": "Kaynak makrosu",
  "No parameters added": "Parametre eklenmedi",
  "Search traffic sources…": "Trafik kaynaklarında ara…",
  "Sources not found": "Kaynak bulunamadı",
  "No traffic sources": "Trafik kaynağı yok",
  "Create sources to integrate with ad networks": "Reklam ağlarıyla entegrasyon için kaynak oluşturun",
  "Spend": "Harcama",
  "Parameters configured:": "Yapılandırılmış parametreler:",
  "Traffic source created": "Trafik kaynağı oluşturuldu",
  "Traffic source updated": "Trafik kaynağı güncellendi",
  "Traffic source deleted": "Trafik kaynağı silindi",
  "Are you sure you want to delete this traffic source?": "Bu trafik kaynağını silmek istediğinizden emin misiniz?",
  "Cannot delete: source is in use by campaigns": "Silinemez: kaynak kampanyalar tarafından kullanılıyor",
  "Error loading traffic sources": "Trafik kaynakları yüklenirken hata oluştu",
  "Error creating traffic source": "Trafik kaynağı oluşturulurken hata oluştu",
  "Error updating traffic source": "Trafik kaynağı güncellenirken hata oluştu",
  "Error deleting traffic source": "Trafik kaynağı silinirken hata oluştu",
  "Preferences": "Tercihler",
  "Notifications": "Bildirimler",
  "System": "Sistem",
  "Profile information": "Profil bilgileri",
  "Manage your basic account information": "Temel hesap bilgilerinizi yönetin",
  "Enter your full name": "Tam adınızı girin",
  "Enter your email": "E-posta adresinizi girin",
  "Save profile": "Profili kaydet",
  "Change password": "Şifre değiştir",
  "Update your password to keep your account secure": "Hesabınızı güvende tutmak için şifrenizi güncelleyin",
  "Current password": "Mevcut şifre",
  "New password": "Yeni şifre",
  "Confirm new password": "Yeni şifreyi onayla",
  "Enter current password": "Mevcut şifreyi girin",
  "Enter new password": "Yeni şifreyi girin",
  "New passwords do not match": "Yeni şifreler eşleşmiyor",
  "New password must be at least 6 characters": "Yeni şifre en az 6 karakter olmalıdır",
  "Password changed successfully": "Şifre başarıyla değiştirildi",
  "Profile updated successfully": "Profil başarıyla güncellendi",
  "Error updating profile": "Profil güncellenirken hata oluştu",
  "Error changing password": "Şifre değiştirilirken hata oluştu",
  "Error loading settings": "Ayarlar yüklenirken hata oluştu",
  "Error saving settings": "Ayarlar kaydedilirken hata oluştu",
  "Error saving system settings": "Sistem ayarları kaydedilirken hata oluştu",
  "User settings saved": "Kullanıcı ayarları kaydedildi",
  "System settings saved": "Sistem ayarları kaydedildi",
  "Interface preferences": "Arayüz tercihleri",
  "Customize the look and behavior of the app": "Uygulamanın görünümünü ve davranışını özelleştirin",
  "Timezone": "Saat dilimi",
  "Moscow (UTC+3)": "Moskova (UTC+3)",
  "Kyiv (UTC+2)": "Kyiv (UTC+2)",
  "New York (UTC-5)": "New York (UTC-5)",
  "Language": "Dil",
  "Date format": "Tarih formatı",
  "Dashboard refresh rate (sec)": "Dashboard yenileme sıklığı (sn)",
  "Save settings": "Ayarları kaydet",
  "Configure how you receive notifications": "Bildirimleri nasıl alacağınızı yapılandırın",
  "Email notifications": "E-posta bildirimleri",
  "SMS notifications": "SMS bildirimleri",
  "Get email notifications about important events": "Önemli olaylar hakkında e-posta bildirimi alın",
  "Get SMS for critical events": "Kritik olaylarda SMS alın",
  "Save notification settings": "Bildirim ayarlarını kaydet",
  "Tracking domains": "Tracking domainleri",
  "Configure domains for campaign tracking": "Kampanya tracking'i için domainleri yapılandırın",
  "Primary tracking domain": "Birincil tracking domaini",
  "Additional domains": "Ek domainler",
  "Add domain": "Domain ekle",
  "Add": "Ekle",
  "Save domain settings": "Domain ayarlarını kaydet",
  "Security": "Güvenlik",
  "Security and access settings": "Güvenlik ve erişim ayarları",
  "Security settings": "Güvenlik ayarları",
  "Coming in upcoming releases": "Yaklaşan sürümlerde gelecek",
  "Active campaigns": "Aktif kampanyalar",
  "Clicks today": "Bugünkü tıklamalar",
  "For the current day": "Geçerli gün için",
  "Confirmed": "Onaylandı",
  "Refresh": "Yenile",
  "Export": "Dışa aktar",
  "Report exported": "Rapor dışa aktarıldı",
  "Period:": "Dönem:",
  "Today": "Bugün",
  "7 days": "7 gün",
  "14 days": "14 gün",
  "30 days": "30 gün",
  "90 days": "90 gün",
  "Campaign:": "Kampanya:",
  "All campaigns": "Tüm kampanyalar",
  "Overview": "Genel bakış",
  "Devices": "Cihazlar",
  "Clicks and conversions": "Tıklamalar ve dönüşümler",
  "No data for the selected period": "Seçilen dönem için veri yok",
  "No data": "Veri yok",
  "Hourly activity": "Saatlik aktivite",
  "CR% by day": "Güne göre CR%",
  "Campaign stats": "Kampanya istatistikleri",
  "Revenue": "Gelir",
  "No campaign data": "Kampanya verisi yok",
  "Total revenue": "Toplam gelir",
  "Total spend": "Toplam harcama",
  "Profit": "Kâr",
  "Net positive": "Net kâr",
  "Net loss": "Net zarar",
  "Advanced notification preferences": "Gelişmiş bildirim tercihleri",
  "Push notifications, webhook URL, alert categories": "Push bildirimleri, webhook URL, uyarı kategorileri",
  "Configure": "Yapılandır",
  "All values shown in": "Tüm değerler şu para biriminde gösteriliyor:",
  "FX rates unavailable — non-USD revenue is excluded from the totals.": "Döviz kurları kullanılamıyor — USD dışı gelir toplamlardan hariç tutulmuştur.",
  "ROI by campaigns": "Kampanyalara göre ROI",
  "No ROI data": "ROI verisi yok",
  "Clicks by country": "Ülkeye göre tıklamalar",
  "Geo table": "GEO tablosu",
  "No geo data": "GEO verisi yok",
  "Country": "Ülke",
  "Devices table": "Cihazlar tablosu",
  "Device type": "Cihaz türü",
  "Share": "Pay",
  "No device data": "Cihaz verisi yok",
  "Failed to load campaign": "Kampanya yüklenemedi",
  "Failed to load streams": "Akışlar yüklenemedi",
  "Stream created": "Akış oluşturuldu",
  "Failed to create stream": "Akış oluşturulamadı",
  "Stream updated": "Akış güncellendi",
  "Failed to update stream": "Akış güncellenemedi",
  "Delete this stream?": "Bu akış silinsin mi?",
  "Stream deleted": "Akış silindi",
  "Failed to delete stream": "Akış silinemedi",
  "Catch": "Catch",
  "Fallback": "Fallback",
  "Normal": "Normal",
  "Stream name": "Akış adı",
  "Stream type": "Akış türü",
  "Position": "Konum",
  "Weight (%)": "Ağırlık (%)",
  "Click limit": "Tıklama limiti",
  "No limit": "Limitsiz",
  "Stream action": "Akış eylemi",
  "Action type": "Eylem türü",
  "Redirect": "Yönlendirme",
  "Split test": "Split test",
  "Redirect URL": "Yönlendirme URL",
  "Landings and offers": "Landing page'ler ve offer'lar",
  "Landings": "Landing page'ler",
  "No landings available": "Kullanılabilir landing page yok",
  "No offers available": "Kullanılabilir offer yok",
  "Traffic filters": "Trafik filtreleri",
  "Countries (ISO codes)": "Ülkeler (ISO kodları)",
  "Cities": "Şehirler",
  "Browsers": "Tarayıcılar",
  "Operating systems": "İşletim sistemleri",
  "Languages": "Diller",
  "Don't filter": "Filtreleme",
  "Accept only unique": "Yalnızca tekil kabul et",
  "Filter unique": "Tekilleri filtrele",
  "Campaign streams": "Kampanya akışları",
  "Create stream": "Akış oluştur",
  "Configure stream for traffic distribution by conditions": "Koşullara göre trafik dağıtımı için akış yapılandır",
  "No streams": "Akış yok",
  "Create streams to distribute traffic by conditions": "Koşullara göre trafik dağıtmak için akış oluşturun",
  "Weight": "Ağırlık",
  "Bots filtered": "Filtrelenen botlar",
  "Countries": "Ülkeler",
  "Limit": "Limit",
  "Edit stream": "Akışı düzenle",
  "Modify stream settings": "Akış ayarlarını değiştir",
  "Failed to load data": "Veriler yüklenemedi",
  "Failed to load traffic rules": "Trafik kuralları yüklenemedi",
  "Select a campaign": "Bir kampanya seçin",
  "Traffic rule created": "Trafik kuralı oluşturuldu",
  "Failed to create rule": "Kural oluşturulamadı",
  "Rule updated": "Kural güncellendi",
  "Failed to update rule": "Kural güncellenemedi",
  "Rule deleted": "Kural silindi",
  "Failed to delete rule": "Kural silinemedi",
  "Landing created": "Landing page oluşturuldu",
  "Failed to create landing": "Landing page oluşturulamadı",
  "Failed to create offer": "Teklif oluşturulamadı",
  "Traffic management": "Trafik yönetimi",
  "Select campaign": "Kampanya seçin",
  "Traffic rules": "Trafik kuralları",
  "Traffic distribution rules": "Trafik dağıtım kuralları",
  "Create rule": "Kural oluştur",
  "Create traffic rule": "Trafik kuralı oluştur",
  "Edit rule": "Kuralı düzenle",
  "Configure conditions and actions for traffic distribution": "Trafik dağıtımı için koşulları ve eylemleri yapılandırın",
  "Rule name": "Kural adı",
  "Priority": "Öncelik",
  "Rule description": "Kural açıklaması",
  "Conditions (leave empty for any value)": "Koşullar (herhangi bir değer için boş bırakın)",
  "Update": "Güncelle",
  "No traffic rules": "Trafik kuralı yok",
  "Create rules to distribute traffic by conditions": "Trafiği koşullara göre dağıtmak için kurallar oluşturun",
  "Stopped": "Durduruldu",
  "Any": "Herhangi",
  "Redirects": "Yönlendirmeler",
  "Select a campaign to manage traffic rules": "Trafik kurallarını yönetmek için bir kampanya seçin",
  "Add landing": "Landing page ekle",
  "Add a new landing to the library": "Kütüphaneye yeni bir landing page ekle",
  "Landing name": "Landing page adı",
  "Landing description": "Landing page açıklaması",
  "No landings": "Landing page yok",
  "Add landings to use in traffic rules": "Trafik kurallarında kullanmak için landing page ekleyin",
  "Add a new offer to monetize traffic": "Trafiği monetize etmek için yeni bir teklif ekleyin",
  "Offer name": "Teklif adı",
  "Add offers to monetize traffic": "Trafiği monetize etmek için offer ekleyin",
  "A/B Testing": "A/B Testi",
  "Create A/B test": "A/B testi oluştur",
  "Set up split testing to optimize conversions": "Dönüşümleri optimize etmek için split test kurun",
  "Test name": "Test adı",
  "Landing page test": "Landing page testi",
  "Test description": "Test açıklaması",
  "Test type": "Test türü",
  "Traffic paths": "Trafik yolları",
  "Confidence level (%)": "Güven düzeyi (%)",
  "Minimum sample size": "Minimum örnek boyutu",
  "Test variants": "Test varyantları",
  "Add variant": "Varyant ekle",
  "Variant {n}": "Varyant {n}",
  "Variant name": "Varyant adı",
  "URL (or pick below)": "URL (veya aşağıdan seçin)",
  "Pick landing page": "Landing page seç",
  "Pick offer": "Offer seç",
  "Traffic weight (%)": "Trafik ağırlığı (%)",
  "Total weight": "Toplam ağırlık",
  "Create test": "Test oluştur",
  "No A/B tests": "A/B testi yok",
  "Create split tests to optimize conversions": "Dönüşümleri optimize etmek için split test oluşturun",
  "Visitors": "Ziyaretçiler",
  "Significance": "Anlamlılık",
  "Variants": "Varyantlar",
  "Progress to minimum sample": "Minimum örneğe ilerleme",
  "A/B test results": "A/B testi sonuçları",
  "Variant performance analysis": "Varyant performans analizi",
  "Conversion": "Dönüşüm",
  "Confidence interval": "Güven aralığı",
  "Not enough data for analysis": "Analiz için yeterli veri yok",
  "Close": "Kapat",
  "Running": "Çalışıyor",
  "Completed": "Tamamlandı",
  "Draft": "Taslak",
  "Delete this A/B test?": "Bu A/B testi silinsin mi?",
  "A/B test deleted": "A/B testi silindi",
  "Failed to delete test": "Test silinemedi",
  "A/B test created": "A/B testi oluşturuldu",
  "Failed to create A/B test": "A/B testi oluşturulamadı",
  "A/B test started": "A/B testi başlatıldı",
  "Failed to start test": "Test başlatılamadı",
  "A/B test paused": "A/B testi duraklatıldı",
  "Failed to pause test": "Test duraklatılamadı",
  "Failed to load results": "Sonuçlar yüklenemedi",
  "Failed to load A/B tests": "A/B testleri yüklenemedi",
  "At least 2 variants required": "En az 2 varyant gerekli",
  "Webhooks": "Webhooklar",
  "Import costs and conversions": "Maliyet ve dönüşümleri içe aktar",
  "Sync campaigns and conversions": "Kampanya ve dönüşümleri senkronize et",
  "Import ad statistics": "Reklam istatistiklerini içe aktar",
  "VKontakte integration": "VKontakte entegrasyonu",
  "Automatic traffic import": "Otomatik trafik içe aktarma",
  "Server-to-server postbacks": "Sunucudan sunucuya postbackler",
  "Custom API integration": "Özel API entegrasyonu",
  "Telegram notifications": "Telegram bildirimleri",
  "Click": "Tıklama",
  "Campaign paused": "Kampanya duraklatıldı",
  "Campaign started": "Kampanya başlatıldı",
  "Fraud detected": "Fraud tespit edildi",
  "Threshold reached": "Eşiğe ulaşıldı",
  "Fill in type and name": "Tür ve adı doldurun",
  "Integration created": "Entegrasyon oluşturuldu",
  "Error creating": "Oluşturma hatası",
  "Integration updated": "Entegrasyon güncellendi",
  "Error updating": "Güncelleme hatası",
  "Delete integration?": "Entegrasyon silinsin mi?",
  "Integration deleted": "Entegrasyon silindi",
  "Error deleting": "Silme hatası",
  "Fill in name and URL": "Ad ve URL'yi doldurun",
  "Webhook created": "Webhook oluşturuldu",
  "Error creating webhook": "Webhook oluşturma hatası",
  "Webhook updated": "Webhook güncellendi",
  "Delete webhook?": "Webhook silinsin mi?",
  "Webhook deleted": "Webhook silindi",
  "Test succeeded (HTTP {code})": "Test başarılı (HTTP {code})",
  "Test error: {detail}": "Test hatası: {detail}",
  "Error testing webhook": "Webhook test hatası",
  "Integration type": "Entegrasyon türü",
  "Select type": "Tür seçin",
  "Configuration (key-value)": "Yapılandırma (anahtar-değer)",
  "Key (e.g. api_key)": "Anahtar (örn. api_key)",
  "Value": "Değer",
  "My webhook": "Webhookum",
  "Secret (optional)": "Gizli anahtar (isteğe bağlı)",
  "Events": "Olaylar",
  "Retry attempts": "Yeniden deneme sayısı",
  "Timeout (sec)": "Zaman aşımı (sn)",
  "Add integration": "Entegrasyon ekle",
  "New integration": "Yeni entegrasyon",
  "Configure connection to an external service": "Harici bir servise bağlantıyı yapılandır",
  "No integrations": "Entegrasyon yok",
  "Connect external services to automate workflows": "İş akışlarını otomatikleştirmek için harici servisleri bağlayın",
  "Connected": "Bağlandı",
  "Disconnected": "Bağlantı kesildi",
  "Last sync": "Son senkronizasyon",
  "Add webhook": "Webhook ekle",
  "New webhook": "Yeni webhook",
  "Configure a webhook to receive notifications": "Bildirim almak için bir webhook yapılandırın",
  "No webhooks": "Webhook yok",
  "Create webhooks to send events to external systems": "Harici sistemlere olay göndermek için webhook oluşturun",
  "Success": "Başarılı",
  "Errors": "Hatalar",
  "Test": "Test",
  "Edit integration": "Entegrasyonu düzenle",
  "Edit webhook": "Webhook'u düzenle",
  "Anti-fraud system": "Anti-fraud sistemi",
  "Filter created": "Filtre oluşturuldu",
  "Failed to create filter": "Filtre oluşturulamadı",
  "Filter updated": "Filtre güncellendi",
  "Failed to update filter": "Filtre güncellenemedi",
  "Filter deleted": "Filtre silindi",
  "Failed to delete filter": "Filtre silinemedi",
  "IP added to blacklist": "IP kara listeye eklendi",
  "IP added to whitelist": "IP beyaz listeye eklendi",
  "Failed to add IP": "IP eklenemedi",
  "IP removed from blacklist": "IP kara listeden kaldırıldı",
  "IP removed from whitelist": "IP beyaz listeden kaldırıldı",
  "Failed to remove IP": "IP kaldırılamadı",
  "Activity marked as resolved": "Aktivite çözümlendi olarak işaretlendi",
  "Failed to update activity": "Aktivite güncellenemedi",
  "Filters": "Filtreler",
  "IP lists": "IP listeleri",
  "Suspicious activity": "Şüpheli aktivite",
  "Statistics": "İstatistikler",
  "Fraud filters": "Anti-fraud filtreleri",
  "Create filter": "Filtre oluştur",
  "Edit filter": "Filtreyi düzenle",
  "Create fraud filter": "Anti-fraud filtresi oluştur",
  "Configure automatic filters to block suspicious traffic": "Şüpheli trafiği engellemek için otomatik filtreler yapılandırın",
  "Filter name": "Filtre adı",
  "Filter type": "Filtre türü",
  "Bot detection": "Bot tespiti",
  "Click frequency": "Tıklama sıklığı",
  "Country block": "Ülke engeli",
  "ASN block": "ASN engeli",
  "Datacenter / hosting block": "Datacenter / hosting engeli",
  "Proxy / VPN / Tor block": "Proxy / VPN / Tor engeli",
  "External risk score": "Harici risk skoru",
  "Filter description": "Filtre açıklaması",
  "Max clicks per minute": "Dakika başına maks. tıklama",
  "Blocked countries (ISO codes)": "Engellenen ülkeler (ISO kodları)",
  "ASN numbers": "ASN numaraları",
  "ASN name substrings": "ASN adı alt dizeleri",
  "Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).": "Virgülle ayrılmış AS numaraları (ör. 16509 = AWS, 24940 = Hetzner).",
  "Case-insensitive substring match against the ASN label.": "ASN etiketiyle büyük/küçük harf duyarsız alt dize eşleşmesi.",
  "Allowed ASNs (whitelist)": "İzin verilen ASN'ler (whitelist)",
  "Optional. Datacenter IPs that match these ASNs / labels are not blocked.": "İsteğe bağlı. Bu ASN'lerle / etiketlerle eşleşen datacenter IP'leri engellenmez.",
  "Block Tor exit nodes": "Tor çıkış düğümlerini engelle",
  "Block proxies (requires API key)": "Proxy'leri engelle (API anahtarı gerektirir)",
  "Block VPNs (requires API key)": "VPN'leri engelle (API anahtarı gerektirir)",
  "External provider": "Harici sağlayıcı",
  "Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.": "Backend ortamında IPQS_API_KEY veya FRAUDSCORE_API_KEY değerini ayarlayın.",
  "Risk score threshold (0-100)": "Risk skoru eşiği (0-100)",
  "Block when the provider returns a score >= this threshold (default 85).": "Sağlayıcı bu eşiğe >= bir skor döndürdüğünde engelle (varsayılan 85).",
  "Block": "Engelle",
  "Log only": "Yalnızca logla",
  "No active filters": "Aktif filtre yok",
  "Create filters for automatic fraud protection": "Otomatik fraud koruması için filtre oluşturun",
  "Blocked": "Engellendi",
  "False positives": "Yanlış pozitifler",
  "IP blacklist": "IP kara listesi",
  "IP whitelist": "IP beyaz listesi",
  "Blacklist is empty": "Kara liste boş",
  "Whitelist is empty": "Beyaz liste boş",
  "Blocked: {n} times": "Engellendi: {n} kez",
  "View blocked samples": "Engellenen örnekleri görüntüle",
  "Blocked samples": "Engellenen örnekler",
  "Blocked samples: {name}": "Engellenen örnekler: {name}",
  "Most recent traffic caught by this filter. Use it to spot false positives.": "Bu filtre tarafından yakalanan en son trafik. Yanlış pozitifleri tespit etmek için kullanın.",
  "No blocked samples yet": "Henüz engellenen örnek yok",
  "Failed to load blocked samples": "Engellenen örnekler yüklenemedi",
  "(empty UA)": "(boş UA)",
  "Add IP to blacklist": "IP'yi kara listeye ekle",
  "Add IP to whitelist": "IP'yi beyaz listeye ekle",
  "IP address": "IP adresi",
  "Reason": "Neden",
  "Reason for adding": "Ekleme nedeni",
  "Notes (optional)": "Notlar (isteğe bağlı)",
  "Additional information": "Ek bilgi",
  "No suspicious activity detected": "Şüpheli aktivite tespit edilmedi",
  "The system automatically tracks suspicious actions": "Sistem şüpheli eylemleri otomatik olarak takip eder",
  "Resolved": "Çözüldü",
  "Mark as resolved": "Çözüldü olarak işaretle",
  "User Agent": "User Agent",
  "Time": "Zaman",
  "Details": "Ayrıntılar",
  "Active filters": "Aktif filtreler",
  "Blocked IPs": "Engellenen IP'ler",
  "Failed to load automation rules": "Otomasyon kuralları yüklenemedi",
  "Automation rule created": "Otomasyon kuralı oluşturuldu",
  "Failed to create automation rule": "Otomasyon kuralı oluşturulamadı",
  "Automation rule updated": "Otomasyon kuralı güncellendi",
  "Failed to update automation rule": "Otomasyon kuralı güncellenemedi",
  "Are you sure you want to delete this rule?": "Bu kuralı silmek istediğinizden emin misiniz?",
  "Automation rule deleted": "Otomasyon kuralı silindi",
  "Failed to delete automation rule": "Otomasyon kuralı silinemedi",
  "Rule activated": "Kural etkinleştirildi",
  "Rule deactivated": "Kural devre dışı bırakıldı",
  "Failed to change rule status": "Kural durumu değiştirilemedi",
  "Notification settings saved": "Bildirim ayarları kaydedildi",
  "Failed to save notification settings": "Bildirim ayarları kaydedilemedi",
  "Pause campaign": "Kampanyayı duraklat",
  "Budget alert": "Bütçe uyarısı",
  "Performance alert": "Performans uyarısı",
  "Rules": "Kurallar",
  "Automation rules": "Otomasyon kuralları",
  "Create automation rule": "Otomasyon kuralı oluştur",
  "Configure automatic actions based on conditions": "Koşullara göre otomatik eylemleri yapılandırın",
  "Rule type": "Kural türü",
  "Trigger conditions": "Tetikleyici koşullar",
  "Maximum cost per click": "Maksimum CPC",
  "Minimum CR (%)": "Minimum CR (%)",
  "Budget percentage for alert": "Uyarı için bütçe yüzdesi",
  "Execution settings": "Yürütme ayarları",
  "Interval between executions (min)": "Yürütmeler arası aralık (dk)",
  "Maximum executions per day": "Günlük maksimum yürütme sayısı",
  "No automation rules": "Otomasyon kuralı yok",
  "Create rules to automatically manage campaigns": "Kampanyaları otomatik yönetmek için kurallar oluşturun",
  "Executions": "Yürütmeler",
  "Interval": "Aralık",
  "{n} min": "{n} dk",
  "Daily limit": "Günlük limit",
  "Last execution": "Son yürütme",
  "Notification channels": "Bildirim kanalları",
  "Receive notifications by email": "E-posta ile bildirim al",
  "Receive SMS for critical events": "Kritik olaylar için SMS al",
  "Push notifications": "Push bildirimleri",
  "Browser notifications": "Tarayıcı bildirimleri",
  "Webhook URL": "Webhook URL",
  "Manage how and when you receive alerts": "Uyarıları nasıl ve ne zaman alacağınızı yönetin",
  "Save preferences": "Tercihleri kaydet",
  "Saving…": "Kaydediliyor…",
  "Delivery channels": "Teslimat kanalları",
  "Choose how to receive notifications": "Bildirimleri nasıl almak istediğinizi seçin",
  "Receive alerts via email": "E-posta ile uyarı al",
  "Critical alerts via SMS": "SMS ile kritik uyarılar",
  "In-app and browser push": "Uygulama içi ve tarayıcı push",
  "POST JSON payloads to your endpoint": "Endpoint'inize POST JSON payload gönderin",
  "Alert categories": "Uyarı kategorileri",
  "Choose which types of events trigger notifications": "Hangi olay türlerinin bildirim tetikleyeceğini seçin",
  "Campaign alerts": "Kampanya uyarıları",
  "Paused, resumed, daily cap reached": "Duraklatıldı, devam ettirildi, günlük limit doldu",
  "Performance alerts": "Performans uyarıları",
  "ROI drop, conversion rate change, EPC decline": "ROI düşüşü, CR değişimi, EPC düşüşü",
  "Fraud alerts": "Fraud uyarıları",
  "Suspicious clicks, bot traffic, IP blacklist hits": "Şüpheli tıklamalar, bot trafiği, IP kara liste eşleşmeleri",
  "System alerts": "Sistem uyarıları",
  "Domain verification, TLS expiry, billing": "Domain doğrulama, TLS süresi dolumu, faturalandırma",
  "Notification preferences saved": "Bildirim tercihleri kaydedildi",
  "Failed to load notification settings": "Bildirim ayarları yüklenemedi",
  "CSV exported": "CSV dışa aktarıldı",
  "Export campaigns to CSV": "Kampanyaları CSV olarak dışa aktar",
  "Export offers to CSV": "Teklifleri CSV olarak dışa aktar",
  "No domains yet": "Henüz domain yok",
  "Add a custom domain to serve tracking links from your own branded URL.": "Kendi markalı URL'nizden takip linkleri sunmak için özel bir domain ekleyin.",
  "Create streams to split traffic by geo, device, OS, or custom conditions.": "GEO, cihaz, işletim sistemi veya özel koşullara göre trafiği bölmek için akışlar oluşturun.",
  "Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.": "Performans eşiklerine göre kampanyaları otomatik olarak duraklatmak, devam ettirmek veya ayarlamak için kurallar oluşturun.",
  "No members yet": "Henüz üye yok",
  "Invite teammates above to collaborate.": "İşbirliği yapmak için yukarıdan takım arkadaşlarınızı davet edin.",
  "URL for receiving notifications in JSON format": "JSON formatında bildirim almak için URL",
  "Alert types": "Uyarı türleri",
  "Campaign start, pause, completion": "Kampanya başlangıcı, duraklatma, tamamlanma",
  "Changes in CR, ROI, cost": "CR, ROI, maliyet değişimleri",
  "Suspicious traffic detection": "Şüpheli trafik tespiti",
  "Updates and technical information": "Güncellemeler ve teknik bilgiler",
  "Execution history": "Çalıştırma geçmişi",
  "Execution history is empty": "Çalıştırma geçmişi boş",
  "Records of automatic rule executions will appear here": "Otomatik kural çalıştırma kayıtları burada görünecek",
  "Edit automation rule": "Otomasyon kuralını düzenle",
  "Change automation rule settings": "Otomasyon kuralı ayarlarını değiştir",
  "Geographic statistics": "Coğrafi istatistikler",
  "Loading geographic data...": "Coğrafi veriler yükleniyor...",
  "By country": "Ülkeye göre",
  "By city": "Şehre göre",
  "No country data": "Ülke verisi yok",
  "No city data": "Şehir verisi yok",
  "Click map": "Tıklama haritası",
  "No data to display on map": "Haritada gösterilecek veri yok",
  "Geographic data will appear after the first clicks with resolvable coordinates": "Coğrafi veriler, koordinatları çözümlenebilen ilk tıklamalardan sonra görünecektir",
  "Signed in successfully!": "Giriş başarılı!",
  "Sign in failed": "Giriş başarısız",
  "Registration successful!": "Kayıt başarılı!",
  "Registration failed": "Kayıt başarısız",
  "Signed out": "Çıkış yapıldı",
  "One moment…": "Bir saniye…",
  "Documentation": "Dokümantasyon",
  "Help": "Yardım",
  "Step-by-step guide for every feature": "Her özellik için adım adım kılavuz",
  "Search sections...": "Bölümlerde ara...",
  "Loading documentation...": "Dokümantasyon yükleniyor...",
  "Back to top": "Başa dön",
  "Domains": "Domainler",
  "Tracker domains": "Tracker domainleri",
  "Custom domains": "Özel domainler",
  "Bind your own domain to mask tracking links. Point a CNAME to our edge and verify ownership via TXT record.": "Takip linklerini gizlemek için kendi domaininizi bağlayın. Bir CNAME'i edge sunucumuza yönlendirin ve TXT kaydıyla sahipliği doğrulayın.",
  "After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.": "Ekledikten sonra domaininizin DNS ayarlarını yapılandırın (doğrulama için TXT kaydı, trafik yönlendirmesi için CNAME veya A kaydı), ardından Doğrula'ya basın.",
  "Verified": "Doğrulandı",
  "Failed": "Başarısız",
  "Pending": "Beklemede",
  "Default": "Varsayılan",
  "Set default": "Varsayılan olarak ayarla",
  "Verify": "Doğrula",
  "TXT verification record": "TXT doğrulama kaydı",
  "Routing record (CNAME)": "Yönlendirme kaydı (CNAME)",
  "Copy value": "Değeri kopyala",
  "Copied": "Kopyalandı",
  "Tracking links will use": "Takip linkleri şunu kullanacak:",
  "Domain added": "Domain eklendi",
  "Failed to add domain": "Domain eklenemedi",
  "Domain verified": "Domain doğrulandı",
  "Verification failed": "Doğrulama başarısız",
  "Default domain updated": "Varsayılan domain güncellendi",
  "Domain deleted": "Domain silindi",
  "Delete this domain?": "Bu alan adı silinsin mi?",
  "Enable HTTPS": "HTTPS'yi Etkinleştir",
  "HTTPS active": "HTTPS aktif",
  "Check TLS": "TLS Kontrol Et",
  "TLS validation records": "TLS doğrulama kayıtları",
  "TLS provisioning started": "TLS sağlama başlatıldı",
  "TLS provisioning failed": "TLS sağlama başarısız oldu",
  "Action failed": "İşlem başarısız",
  "Loading…": "Yükleniyor…",
  "Conversion API": "Conversion API",
  "Conversion forwarders": "Dönüşüm yönlendiricileri",
  "Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.": "Dönüşümleri sunucudan sunucuya reklam ağlarına iletin (FB CAPI, Google Ads, TikTok). Her postback'te otomatik olarak tetiklenir.",
  "New forwarder": "Yeni yönlendirici",
  "Edit forwarder": "Yönlendiriciyi düzenle",
  "No forwarders yet": "Henüz yönlendirici yok",
  "Forwarder created": "Yönlendirici oluşturuldu",
  "Forwarder updated": "Yönlendirici güncellendi",
  "Forwarder deleted": "Yönlendirici silindi",
  "Delete forwarder?": "Yönlendirici silinsin mi?",
  "Send test": "Test gönder",
  "Test event sent": "Test eventi gönderildi",
  "Test failed": "Test başarısız",
  "No events yet": "Henüz event yok",
  "Provider": "Sağlayıcı",
  "Event name": "Event adı",
  "Name is required": "Ad zorunludur",
  "Missing fields": "Eksik alanlar",
  "Sent": "Gönderildi",
  "Event": "Event",
  "Last sent": "Son gönderim",
  "Public API": "Public API",
  "API keys": "API anahtarları",
  "New key": "Yeni anahtar",
  "New API key": "Yeni API anahtarı",
  "Use API keys to call the public /v1 REST API. Pass the key as": "Public /v1 REST API'yi çağırmak için API anahtarlarını kullanın. Anahtarı şu şekilde iletin:",
  "or": "veya",
  "Copy your key now — it will not be shown again": "Anahtarınızı şimdi kopyalayın — bir daha gösterilmeyecek",
  "Copy": "Kopyala",
  "Dismiss": "Kapat",
  "Quick start": "Hızlı başlangıç",
  "Docs": "Dökümanlar",
  "No API keys yet": "Henüz API anahtarı yok",
  "Scopes": "Kapsamlar",
  "Delete this key?": "Bu anahtar silinsin mi?",
  "Key deleted": "Anahtar silindi",
  "last used": "son kullanılan",
  "never used": "hiç kullanılmadı",
  "Team": "Ekip",
  "Workspace": "Workspace",
  "Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.": "Üyeleri rollerle davet edin. Owner her şeyi görür; manager/admin düzenleyebilir; viewer yalnızca görüntüleyebilir.",
  "Invite member": "Üye davet et",
  "Invite": "Davet et",
  "Invite sent": "Davet gönderildi",
  "Share this link with the invitee:": "Bu bağlantıyı davet ettiğiniz kişiyle paylaşın:",
  "Role": "Rol",
  "Members": "Üyeler",
  "Revoke access?": "Erişim iptal edilsin mi?",
  "Revoke access": "Erişimi iptal et",
  "Access revoked": "Erişim iptal edildi",
  "Reset 2FA": "2FA'yı sıfırla",
  "Reset this member's 2FA?": "Bu üyenin 2FA'sı sıfırlansın mı?",
  "2FA reset — member can re-enrol": "2FA sıfırlandı — üye yeniden kaydolabilir",
  "Member had no 2FA configured": "Bu üyenin yapılandırılmış 2FA'sı yoktu",
  "2FA reset failed": "2FA sıfırlama başarısız oldu",
  "Workspace currency": "Workspace para birimi",
  "Display currency": "Görüntüleme para birimi",
  "Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.": "Raporlar ve dashboard'lar bu para birimine normalize edilecektir. Döviz kurları saatlik olarak güncellenir.",
  "Workspace currency saved": "Workspace para birimi kaydedildi",
  "Could not save currency": "Para birimi kaydedilemedi",
  "Invited": "Davet edildi",
  "Shared with me": "Benimle paylaşılanlar",
  "No shared workspaces": "Paylaşılan workspace yok",
  "Audit log": "Denetim günlüğü",
  "Workspace-scoped trail of privileged actions. Retained for 90 days.": "Workspace kapsamındaki ayrıcalıklı işlemlerin kaydı. 90 gün boyunca saklanır.",
  "Target type": "Hedef türü",
  "Actor ID": "Aktör ID",
  "Since": "Başlangıç",
  "Until": "Bitiş",
  "Apply": "Uygula",
  "Actor": "Aktör",
  "Target": "Hedef",
  "Payload": "Payload",
  "IP": "IP",
  "Load more": "Daha fazla yükle",
  "No audit entries match the current filters.": "Mevcut filtrelere uyan denetim kaydı bulunamadı.",
  "Failed to load audit log": "Denetim günlüğü yüklenemedi",
  "CAPI DLQ": "CAPI DLQ",
  "CAPI dead-letter queue": "CAPI dead-letter kuyruğu",
  "Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.": "Yeniden deneme limitini aşan dönüşümler. Replay, forwarder'a tekrar gönderim yapar; discard kaydı kalıcı olarak siler.",
  "Forwarder ID": "Forwarder ID",
  "Conversion ID": "Dönüşüm ID",
  "Since (ISO)": "Başlangıç (ISO)",
  "Until (ISO)": "Bitiş (ISO)",
  "Apply filters": "Filtreleri uygula",
  "No DLQ entries match these filters.": "Bu filtrelere uyan DLQ kaydı bulunamadı.",
  "Forwarder": "Forwarder",
  "Attempts": "Denemeler",
  "Last error": "Son hata",
  "Replay": "Tekrarla",
  "Discard": "Sil",
  "CAPI replay succeeded": "CAPI tekrarı başarılı",
  "Replay failed:": "Tekrar başarısız:",
  "Replay failed": "Tekrar başarısız",
  "DLQ entry discarded": "DLQ kaydı silindi",
  "Discard failed": "Silme başarısız",
  "Permanently discard this DLQ entry?": "Bu DLQ kaydı kalıcı olarak silinsin mi?",
  "Failed to load CAPI DLQ": "CAPI DLQ yüklenemedi",
  "Activated {n}": "{n} aktifleştirildi",
  "Paused {n}": "{n} duraklatıldı",
  "Deleted {n}": "{n} silindi",
  "Skipped {n} (no access or not found)": "{n} atlandı (erişim yok veya bulunamadı)",
  "Bulk update failed": "Toplu güncelleme başarısız",
  "Bulk delete failed": "Toplu silme başarısız",
  "System health": "Sistem sağlığı",
  "System status": "Sistem durumu",
  "S2S log": "S2S log",
  "TLS fingerprints": "TLS parmak izleri",
  "Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.": "Yönettiğiniz workspace'lerdeki CAPI / postback / FX / maliyet senkronizasyonu durumunun özeti.",
  "CAPI delivery": "CAPI iletimi",
  "Conversion API dispatches in the last window.": "Son zaman dilimindeki Conversion API gönderimleri.",
  "Total": "Toplam",
  "Success rate": "Başarı oranı",
  "No CAPI events in window.": "Bu zaman diliminde CAPI olayı yok.",
  "Retry queue": "Yeniden deneme kuyruğu",
  "Pending CAPI re-attempts.": "Bekleyen CAPI yeniden denemeleri.",
  "Due now": "Şimdi yapılacak",
  "Oldest": "En eski",
  "Dead-letter queue": "Dead-letter kuyruğu",
  "Conversions that exhausted the retry budget.": "Yeniden deneme limitini aşan dönüşümler.",
  "Postback delivery": "Postback iletimi",
  "S2S postback callouts in the last window.": "Son zaman dilimindeki S2S postback çağrıları.",
  "FX cache": "FX önbelleği",
  "Per-base exchange-rate snapshot freshness.": "Her baz döviz için kur anlık görüntüsü güncelliği.",
  "Base": "Baz",
  "Refreshed": "Güncellendi",
  "FX cache is empty.": "FX önbelleği boş.",
  "stale": "eski",
  "fresh": "güncel",
  "Ad cost sync": "Reklam maliyeti senkronizasyonu",
  "Active connections, last sync time, and recent errors.": "Aktif bağlantılar, son senkronizasyon zamanı ve son hatalar.",
  "No active ad-cost connections.": "Aktif reklam maliyeti bağlantısı yok.",
  "error": "hata",
  "ok": "tamam",
  "Generated at": "Oluşturulma zamanı",
  "Window": "Zaman penceresi",
  "Failed to load admin health": "Admin sağlık durumu yüklenemedi",
  "Export CSV": "CSV Dışa Aktar",
  "Audit log exported": "Denetim logu dışa aktarıldı",
  "Audit export failed": "Denetim logu dışa aktarılamadı",
  "Billing": "Faturalandırma",
  "Plans & usage": "Planlar ve kullanım",
  "Current plan": "Mevcut plan",
  "Current": "Mevcut",
  "Clicks this month": "Bu ayki tıklamalar",
  "Plans & billing": "Planlar ve faturalandırma",
  "Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.": "Beş sürüm: her plan tam tracker'ı içerir — ekip büyüklüğünüzü, domain ölçeğinizi ve otomasyon kapsamınızı seçin. Tıklamalar hiçbir zaman sınırlandırılmaz.",
  "Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.": "Bu sunucuda faturalandırma henüz etkinleştirilmedi — tüm özellikler açık. Aşağıdaki planlar, ödemeler devreye girdiğinde geçerli olacakları göstermektedir.",
  "Trial": "Deneme süresi",
  "day(s) left": "gün kaldı",
  "choose a plan to keep your traffic flowing without interruption.": "trafiğinizin kesintisiz akması için bir plan seçin.",
  "Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.": "Aboneliğiniz aktif değil: tıklama işleme ve öğe oluşturma duraklatıldı. Hemen devam etmek için bir plan seçin.",
  "Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.": "Son ödeme başarısız oldu — Stripe yeniden denerken tracker çalışmaya devam ediyor. Kartınızı Faturalandırmayı Yönet bölümünden güncelleyin.",
  "cancels at period end": "dönem sonunda iptal edilir",
  "unlimited": "sınırsız",
  "months": "ay",
  "month": "ay",
  "billed every": "her şu kadar faturalama:",
  "user(s)": "kullanıcı",
  "domain(s)": "domain",
  "Choose plan": "Plan seç",
  "Full tracker core": "Tam tracker çekirdeği",
  "Unlimited clicks": "Sınırsız tıklama",
  "Landing page editor": "Landing page editörü",
  "Online support": "Çevrimiçi destek",
  "Click API + API keys": "Click API + API anahtarları",
  "Facebook CAPI": "Facebook CAPI",
  "All 8 CAPI providers": "Tüm 8 CAPI sağlayıcısı",
  "Report by conversion date": "Dönüşüm tarihine göre rapor",
  "White label branding": "White label markalaşma",
  "Personal manager": "Kişisel hesap yöneticisi",
  "Priority support": "Öncelikli destek",
  "Onboarding call": "Onboarding görüşmesi",
  "trialing": "deneme",
  "active": "aktif",
  "past_due": "gecikmiş ödeme",
  "expired": "süresi dolmuş",
  "canceled": "iptal edildi",
  "exempt": "muaf",
  "Manage billing": "Faturalamayı yönet",
  "Manage": "Yönet",
  "Upgrade": "Yükselt",
  "Free forever": "Sonsuza kadar ücretsiz",
  "clicks/mo": "tıklama/ay",
  "campaigns": "kampanya",
  "team members": "ekip üyesi",
  "Campaign parameters": "Kampanya parametreleri",
  "Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.": "Reklam ağları üzerinden ilettiğiniz URL parametrelerini tanımlayın. Her satır, postback'lerde ve CAPI payload'larında kullanılabilen {key} gibi bir makroya dönüşür.",
  "URL key": "URL anahtarı",
  "Placeholder / default": "Placeholder / varsayılan değer",
  "Google Ads tag": "Google Ads etiketi",
  "No parameters yet": "Henüz parametre yok",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "Parametrelerde kaydedilmemiş değişiklikler var — siz kaydedinceye kadar tıklamalar mevcut kaydedilmiş seti kullanmaya devam eder.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Bu anahtar için tracking link'e yazılan değer: {campaignid} gibi bir reklam ağı makrosu ya da MCLV gibi sabit bir değer. Sabit değer, anahtarsız gelen tıklamalarda da saklanır; süslü parantez içindeki makro saklanmaz. tm ve tml gibi reklam ağının hesap bazında ayarladığı anahtarlar için boş bırakın.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Makro: reklam ağı tarafından doldurulur, bu anahtarı içermeyen tıklamalarda saklanmaz",
  "Google Ads conversion keys": "Google Ads dönüşüm anahtarları",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Tıklamaları ve dönüşümleri sub1–sub30 veya bir kampanyada tanımlanan herhangi bir parametreye göre grupla",
  "Sub slot": "Sub slot",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "İsteğe bağlı: değer aynı zamanda sub1…sub30 veya adlandırılmış bir alan (external_id, creative_id…) olarak saklanır. Her kampanyada aynı şeyi aynı slota eşleyin (örn. team -> sub8); böylece tek bir rapor sütunu ve {sub_id_8} makrosu tüm media buyer'ları kapsar. external_id, kaynak postback'indeki {external_id} makrosunu besler.",
  "Source postback": "Kaynak postback",
  "This source postback is already added": "Bu kaynak postback zaten eklenmiş",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Kaynak postback eklendi — placeholder'larını (REPLACE, XXXX…) kontrol edin ve Kaydet'e tıklayın",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Sale, depozitolar için de tetiklenir (ftd, dep, deposit); Lead ise kayıtlar için (reg, signup) — broker bunlara ne ad verirse versin.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Varsayılan değeri olmayan anahtarlar (tm, tml, a…) link'e dahil edilmez: bunları reklamda iletin, örneğin Google Ads Final URL son ekinde.",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= Submit Lead Form etiketi — bu dönüşümü Primary olarak ayarlayın. Başarılı bir lead'in ardından ziyaretçinin tarayıcısından tetiklenir.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= Purchase / deposit etiketi — bu dönüşümü Secondary olarak ayarlayın. \"Deposit → Purchase\" S2S kuralı tarafından gönderilir; lead için S2S kuralı eklemeyin.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Her ikisini de her Google Ads hesabının Final URL son ekine ekleyin (tml=AW-…/lead-label&tm=AW-…/purchase-label) ve buradaki varsayılan değerlerini boş bırakın.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "Anahtarlar büyük/küçük harfe duyarlıdır. Her anahtar (a, b, s, c…) tıklamada saklanır, {key} makrosu olarak çalışır ve Raporlar ile Sub-ID raporlarında sub1…sub30'un yanı sıra gruplama olarak seçilebilir. Kampanyalar arasında tutarlılık sağlamak için bir sub slota eşleyin.",
  "Use lowercase keys — the tracker does not read:": "Anahtarlarda küçük harf kullanın — tracker şunu okuyamaz:",
  "Tracking URL preview": "Tracking URL önizlemesi",
  "Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.": "Bunu Final URL (Google Ads) veya tracking link (Facebook) olarak yapıştırın. Gerekirse {key} placeholder'larını gerçek reklam ağı makrolarıyla değiştirin.",
  "Fire Google Ads gtag on redirect": "Yönlendirmede Google Ads gtag'ini tetikle",
  "When on, /r/ returns a tiny HTML page that calls gtag(\"event\",\"conversion\", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.": "Etkinleştirildiğinde, /r/ yönlendirmeden önce basit mod etiketinizle gtag(\"event\",\"conversion\", …) çağrısı yapan küçük bir HTML sayfası döndürür. Google Ads tarafında Final URL son ekini yapılandırmıyorsanız bunu kullanın.",
  "S2S postbacks": "S2S postback'ler",
  "Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.": "Bir dönüşüm postback'i alındığında tetiklenen giden HTTP çağrıları. {click_id}, {payout} gibi makroları ve yukarıda tanımlanan tüm kampanya parametrelerini destekler.",
  "No postbacks yet": "Henüz postback yok",
  "Method": "Metot",
  "Statuses": "Durumlar",
  "Add postback": "Postback ekle",
  "Show recent log": "Son logu göster",
  "Available macros": "Kullanılabilir makrolar",
  "Campaign saved": "Kampanya kaydedildi",
  "Postback fired": "Postback gönderildi",
  "Mode": "Mod",
  "Simple": "Basit",
  "Advanced": "Gelişmiş",
  "Conversion tag": "Dönüşüm etiketi",
  "Conversion tag is required": "Dönüşüm etiketi zorunludur",
  "Paste the \"send_to\" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.": "Google Ads dönüşüm snippet'inizdeki \"send_to\" değerini yapıştırın (ör. AW-123456789/AbCdEf). OAuth gerekmez. Tracker bunu kaydeder ve Final URL son eki veya yönlendirme sırasında gtag aracılığıyla iletir.",
  "OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.": "OAuth tabanlı Tıklama Dönüşümü Yükleme — developer token, customer ID ve refresh token gerektirir. Yalnızca gclid ile sunucu taraflı yükleme yapmanız gerekiyorsa kullanın.",
  "Campaign": "Kampanya",
  "Create a new xpnsr.tech account": "Yeni bir xpnsr.tech hesabı oluştur",
  "Already have an account? Sign in": "Zaten hesabınız var mı? Giriş yapın",
  "Only ZIP files are supported": "Yalnızca ZIP dosyaları desteklenir",
  "Please enter a name for the landing page": "Landing page için bir ad girin",
  "Please select a ZIP file": "Bir ZIP dosyası seçin",
  "Landing page uploaded successfully": "Landing page başarıyla yüklendi",
  "Error uploading landing page": "Landing page yüklenirken hata oluştu",
  "Upload ZIP": "ZIP yükle",
  "Upload Landing Page": "Landing Page Yükle",
  "Upload a ZIP file containing your landing page files (max 50MB)": "Landing page dosyalarınızı içeren bir ZIP dosyası yükleyin (maks. 50 MB)",
  "My landing page": "Benim landing page'im",
  "tag1, tag2, tag3": "etiket1, etiket2, etiket3",
  "Separate tags with commas": "Etiketleri virgülle ayırın",
  "ZIP File": "ZIP Dosyası",
  "Drag & drop or click to select": "Sürükleyip bırakın veya seçmek için tıklayın",
  "Select ZIP File": "ZIP Dosyası Seç",
  "Uploading...": "Yükleniyor...",
  "Upload": "Yükle",
  "History": "Geçmiş",
  "Notification settings": "Bildirim ayarları",
  "Please fill in name and select ZIP file": "Ad girin ve ZIP dosyası seçin",
  "Offer uploaded successfully": "Teklif başarıyla yüklendi",
  "Error uploading offer": "Teklif yüklenirken hata oluştu",
  "Upload Offer ZIP": "Teklif ZIP'i Yükle",
  "Upload a ZIP file containing offer files": "Teklif dosyalarını içeren bir ZIP dosyası yükleyin",
  "Countries (comma-separated ISO codes, e.g. US,RU,DE)": "Ülkeler (virgülle ayrılmış ISO kodları, ör. US,RU,DE)",
  "ZIP File (max 100MB)": "ZIP Dosyası (maks. 100MB)",
  "Change": "Değiştir",
  "Select ZIP file": "ZIP dosyası seç",
  "Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.": "HTML sayfaları, görseller ve diğer dosyaları içeren bir ZIP dosyası yükleyin. Desteklenenler: önizleme için _preview.png, işleme için PHP betikleri.",
  "Upload Offer": "Teklif Yükle",
  "pages": "sayfalar",
  "Choose entry point": "Giriş noktası seç",
  "Multiple HTML pages detected. Select the main page visitors will land on.": "Birden fazla HTML sayfası tespit edildi. Ziyaretçilerin ulaşacağı ana sayfayı seçin.",
  "Skip (use auto-detected)": "Atla (otomatik tespit edileni kullan)",
  "Confirm": "Onayla",
  "Edit files": "Dosyaları düzenle",
  "File editor": "Dosya editörü",
  "Edit HTML, CSS, JS and other text files inside the uploaded archive": "Yüklenen arşiv içindeki HTML, CSS, JS ve diğer metin dosyalarını düzenleyin",
  "Files": "Dosyalar",
  "Select a file from the sidebar to edit": "Düzenlemek için kenar çubuğundan bir dosya seçin",
  "Binary file — not editable": "İkili dosya — düzenlenemez",
  "File saved": "Dosya kaydedildi",
  "Error loading files": "Dosyalar yüklenirken hata oluştu",
  "Error loading file": "Dosya yüklenirken hata oluştu",
  "Error saving file": "Dosya kaydedilirken hata oluştu",
  "Discard unsaved changes?": "Kaydedilmemiş değişiklikler iptal edilsin mi?",
  "Saving...": "Kaydediliyor...",
  "Bulk create": "Toplu oluştur",
  "Bulk create Google Ads forwarders": "Google Ads forwarder'larını toplu oluştur",
  "Conversion tags (one per line)": "Dönüşüm etiketleri (her satıra bir tane)",
  "Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.": "AW-XXX/YYY etiketlerini yapıştırın, her satıra bir tane. Her biri ayrı bir forwarder oluşturur.",
  "Bind to campaigns": "Kampanyalara bağla",
  "Leave empty to fire on all campaigns": "Tüm kampanyalar için çalışması adına boş bırakın",
  "Add campaign…": "Kampanya ekle…",
  "Create all": "Tümünü oluştur",
  "Creating…": "Oluşturuluyor…",
  "{count} forwarders created": "{count} forwarder oluşturuldu",
  "campaign": "kampanya",
  "Linked forwarders": "Bağlı forwarder'lar",
  "Conversion forwarders that fire for this campaign": "Bu kampanya için çalışan dönüşüm forwarder'ları",
  "Heatmap": "Isı haritası",
  "Funnel": "Huni",
  "Activity heatmap": "Aktivite ısı haritası",
  "Day-of-week x hour-of-day breakdown": "Haftanın günü x günün saati dağılımı",
  "Less": "Daha az",
  "More": "Daha fazla",
  "Peak": "Zirve",
  "No heatmap data": "Isı haritası verisi yok",
  "Conversion funnel": "Dönüşüm hunisi",
  "Click-to-conversion pipeline with status breakdown": "Durum dağılımıyla birlikte tıklamadan dönüşüme giden yol",
  "Status breakdown": "Durum dağılımı",
  "No funnel data": "Huni verisi yok",
  "Mon": "Pzt",
  "Tue": "Sal",
  "Wed": "Çar",
  "Thu": "Per",
  "Fri": "Cum",
  "Sat": "Cmt",
  "Sun": "Paz",
  "Ad-Account Connections": "Reklam Hesabı Bağlantıları",
  "Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.": "Maliyet verilerinin kampanyalara otomatik aktarılması için FB / Google Ads hesaplarınızı bağlayın.",
  "Connect with Facebook": "Facebook ile Bağlan",
  "Connect with Google Ads": "Google Ads ile Bağlan",
  "Ad account connected via OAuth": "Reklam hesabı OAuth ile bağlandı",
  "OAuth error: ": "OAuth hatası: ",
  "Failed to start OAuth": "OAuth başlatılamadı",
  "Token refreshed": "Token yenilendi",
  "Refresh failed": "Yenileme başarısız",
  "Refresh token": "Token'ı yenile",
  "Connect ad account": "Reklam hesabı bağla",
  "Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.": "Token'lar şifreli olarak saklanır. FB / Google için yukarıdaki OAuth düğmelerini kullanın ya da token'ları aşağıya manuel olarak girin.",
  "Sync now": "Şimdi senkronize et",
  "Connect": "Bağlan",
  "Failed to load connections": "Bağlantılar yüklenemedi",
  "Connection created": "Bağlantı oluşturuldu",
  "Connection deleted": "Bağlantı silindi",
  "Delete this connection?": "Bu bağlantı silinsin mi?",
  "Delete failed": "Silme başarısız",
  "Sync complete": "Senkronizasyon tamamlandı",
  "Sync failed": "Senkronizasyon başarısız",
  "No connections yet. Connect FB or Google Ads to start importing cost.": "Henüz bağlantı yok. Maliyet içe aktarmaya başlamak için FB veya Google Ads'i bağlayın.",
  "Refresh token (optional)": "Yenileme token'ı (isteğe bağlı)",
  "Display name": "Görünen ad",
  "Account ID": "Hesap ID",
  "Access token": "Erişim token'ı",
  "Save failed": "Kaydetme başarısız",
  "Permissions": "İzinler",
  "Permission matrix": "İzin matrisi",
  "Permission matrix saved": "İzin matrisi kaydedildi",
  "Failed to load permission matrix": "İzin matrisi yüklenemedi",
  "Failed to save permission matrix": "İzin matrisi kaydedilemedi",
  "Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.": "Bu workspace'teki her işlem için gereken minimum rolü geçersiz kılın. Yalnızca varsayılandan farklı hücreler kaydedilir.",
  "overrides": "geçersiz kılmalar",
  "Read-only — only the workspace owner can edit the matrix.": "Salt okunur — matrisi yalnızca workspace sahibi düzenleyebilir.",
  "Reset all to defaults": "Tümünü varsayılana sıfırla",
  "Custom": "Özel",
  "Reset to default": "Varsayılana sıfırla",
  "owner": "sahip",
  "admin": "admin",
  "manager": "yönetici",
  "viewer": "izleyici",
  "Landings & offers": "Landing page'ler ve teklifler",
  "Reports": "Raporlar",
  "Audit": "Denetim",
  "Toggle navigation hints": "Gezinme ipuçlarını aç/kapat",
  "Show hints": "İpuçlarını göster",
  "Hide hints": "İpuçlarını gizle",
  "Tools": "Araçlar",
  "Admin": "Yönetici",
  "Resources": "Kaynaklar",
  "Pre-landings": "Pre-landing'ler",
  "Book demo": "Demo rezervasyonu yap",
  "Overview of clicks, conversions and active campaigns": "Tıklama, dönüşüm ve aktif kampanyalara genel bakış",
  "Create ad campaigns and get tracking links": "Reklam kampanyaları oluştur ve takip linkleri al",
  "Upload landing pages (ZIP) or set a URL for split-tests": "Landing page yükle (ZIP) veya split-test için URL gir",
  "Warm-up pages shown before the offer": "Tekliften önce gösterilen ısınma sayfaları",
  "Connect Facebook, Google, TikTok ad accounts": "Facebook, Google, TikTok reklam hesaplarını bağla",
  "Two-factor auth, sessions and password": "2FA, oturumlar ve şifre",
  "Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms": "Yüklenen teklifler/funneller + API routing (ağırlıklar, failover) + lead formları",
  "Traffic sources with presets (Google Ads with tm & macros, etc.)": "Hazır presetli trafik kaynakları (Google Ads tm ve makrolar vb.)",
  "Manage flows and traffic distribution rules": "Akışları ve trafik dağıtım kurallarını yönet",
  "Split-test landings and offers with auto-distribution": "Landing page ve teklifleri otomatik dağıtımlı split-test ile dene",
  "Block bots, fraud and suspicious clicks": "Bot, fraud ve şüpheli tıklamaları engelle",
  "Detailed reports: charts, geo, devices, ROI": "Detaylı raporlar: grafikler, GEO, cihazlar, ROI",
  "Full click log with IP, UserAgent, GEO and time": "IP, UserAgent, GEO ve zaman içeren tam tıklama logu",
  "Auto-rules: pause campaigns on low ROI, etc.": "Otomatik kurallar: düşük ROI'de kampanyaları duraklat vb.",
  "Partner CRMs (TrackBox, Custom API) for API lead injection + notifications": "Partner CRM'ler (TrackBox, Custom API) — API ile lead gönderimi + bildirimler",
  "Add your own domains for tracking links": "Takip linkleri için kendi domainlerini ekle",
  "Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth": "Google/FB/TikTok'a online dönüşümler (S2S). Google — basit mod, OAuth gerektirmez",
  "Keys to access the tracker REST API": "Tracker REST API erişim anahtarları",
  "Invite your team, assign roles and permissions": "Ekibini davet et, rol ve izin ata",
  "Action log of all users for 90 days": "Tüm kullanıcıların 90 günlük işlem logu",
  "Cookie consent banner for GDPR compliance": "GDPR uyumlu çerez onay banner'ı",
  "Ready-made templates and integrations": "Hazır şablonlar ve entegrasyonlar",
  "Swagger REST API docs (opens in new tab)": "Swagger REST API dokümantasyonu (yeni sekmede açılır)",
  "Failed conversion dispatches — can be retried": "Başarısız dönüşüm gönderimleri — yeniden denenebilir",
  "Server, queue and database status": "Sunucu, kuyruk ve veritabanı durumu",
  "Plan, payment and usage limits": "Plan, ödeme ve kullanım limitleri",
  "Profile, language, timezone and notifications": "Profil, dil, saat dilimi ve bildirimler",
  "(no label)": "(etiket yok)",
  "180 days": "180 gün",
  "2FA disabled": "2FA devre dışı",
  "2FA enabled": "2FA etkin",
  "2FA is currently enabled": "2FA şu anda etkin",
  "302 redirect (default)": "302 yönlendirme (varsayılan)",
  "365 days": "365 gün",
  "A campaign groups your traffic sources and tracking links under one name.": "Bir kampanya, trafik kaynaklarınızı ve takip bağlantılarınızı tek bir ad altında gruplar.",
  "AI Optimizer": "AI Optimizer",
  "Accept button label": "Kabul butonu etiketi",
  "Accepted": "Kabul edildi",
  "Accepting invitation…": "Davet kabul ediliyor…",
  "Action on trigger": "Tetikleyici sonrası aksiyon",
  "Activate": "Etkinleştir",
  "Activate 2FA": "2FA'yı Etkinleştir",
  "Add a forwarder to push conversions to ad networks automatically.": "Dönüşümleri reklam ağlarına otomatik iletmek için bir forwarder ekleyin.",
  "Add forwarder": "Forwarder ekle",
  "Add the CNAME record shown on the Domains page, then click verify.": "Domains sayfasında gösterilen CNAME kaydını ekleyin, ardından doğrula'ya tıklayın.",
  "Add vendor": "Vendor ekle",
  "Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.": "Agresif: JA3/JA4 eksik veya henüz sınıflandırılmamış her tıklamayı engeller. Kurumsal proxy hash'lerini önce Workspace Overrides ile etiketleyin.",
  "Alert if ROI drops below this %": "ROI bu %'nin altına düşerse uyar",
  "Algorithm": "Algoritma",
  "All groups": "Tüm gruplar",
  "All statuses": "Tüm durumlar",
  "Allowed metrics": "İzin verilen metrikler",
  "Always block these JA3 / JA4 hashes regardless of classification.": "Sınıflandırmadan bağımsız olarak bu JA3 / JA4 hash'lerini her zaman engelle.",
  "Anonymous": "Anonim",
  "Any type": "Herhangi bir tür",
  "Anyone with this link will lose access to the shared dashboard immediately.": "Bu bağlantıya sahip herkes paylaşılan panele erişimini hemen kaybedecek.",
  "Applied {n} weight changes": "{n} ağırlık değişikliği uygulandı",
  "Archive": "Arşivle",
  "Archived": "Arşivlendi",
  "Auto": "Otomatik",
  "Auto-refresh every 30s": "Her 30 saniyede otomatik yenile",
  "Available on enterprise plans. Hides the \"Powered by xpnsr\" footer.": "Kurumsal planlarda kullanılabilir. \"Powered by xpnsr\" alt bilgisini gizler.",
  "Back to sign-in": "Girişe geri dön",
  "Backup codes (save now)": "Yedek kodlar (şimdi kaydedin)",
  "Bangkok (UTC+7)": "Bangkok (UTC+7)",
  "Banned": "Yasaklandı",
  "Banner copy": "Banner metni",
  "Banner status": "Banner durumu",
  "Berlin (UTC+1)": "Berlin (UTC+1)",
  "Best cohort": "En iyi kohort",
  "Block classification": "Engelleme sınıflandırması",
  "Block fingerprints classified as bad": "Kötü olarak sınıflandırılan parmak izlerini engelle",
  "Block unknown fingerprints": "Bilinmeyen parmak izlerini engelle",
  "Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.": "Karışık TLS+UA+IP risk skoru bu eşiği aştığında engelle. Varsayılan 0.7.",
  "Body": "Gövde",
  "Body (JSON)": "Gövde (JSON)",
  "Body copied to clipboard.": "Gövde panoya kopyalandı.",
  "Body must be valid JSON.": "Gövde geçerli bir JSON olmalıdır.",
  "Branding": "Branding",
  "Branding cleared": "Branding temizlendi",
  "Branding saved": "Branding kaydedildi",
  "Break down clicks and conversions by sub-ID parameters (sub1–sub15)": "Tıklamaları ve dönüşümleri sub ID parametrelerine göre ayır (sub1–sub15)",
  "Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.": "Topluluk tarafından katkıda bulunulan postback, makro, anti-fraud kuralı ve pre-landing şablonlarına göz atın ve yükleyin. Gönderiler otomatik yayınlanır — topluluk silme işlemi aracılığıyla kendini denetler.",
  "Browser": "Tarayıcı",
  "Build traffic rules, rotate landings and split-test offers for any campaign.": "Herhangi bir kampanya için trafik kuralları oluşturun, landing page'leri döndürün ve teklifleri split-test edin.",
  "Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.": "Doğrulanmış domainleri bir havuzda toplayın ve takip linklerini aralarında döndürün. Yasaklanan bir domaini reklam kopyalarını yeniden dağıtmadan tek tıkla rotasyondan çıkarın.",
  "By browser": "Tarayıcıya göre",
  "By device": "Cihaza göre",
  "By {author}": "{author} tarafından",
  "CR %": "CR %",
  "CR%": "CR%",
  "Campaign ID": "Kampanya ID",
  "Campaign activated": "Kampanya etkinleştirildi",
  "Campaign archived": "Kampanya arşivlendi",
  "Campaign cloned successfully!": "Kampanya başarıyla klonlandı!",
  "Campaign comparison": "Kampanya karşılaştırması",
  "Campaign created": "Kampanya oluşturuldu",
  "Campaign dashboard": "Kampanya paneli",
  "Campaign restored": "Kampanya geri yüklendi",
  "Cap": "Cap",
  "Cap timezone": "Cap saat dilimi",
  "Catalog": "Katalog",
  "Chicago (UTC-6)": "Chicago (UTC-6)",
  "Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).": "Bir ön ayar seçin ve isteğe bağlı olarak ek ISO-3166 ülke kodlarıyla genişletin (virgülle ayrılmış, örn. BR, MX, AR).",
  "Clear": "Temizle",
  "Click ID forward parameter": "Click ID iletme parametresi",
  "Click detail": "Tıklama detayı",
  "Click to activate": "Etkinleştirmek için tıklayın",
  "Click to pause": "Duraklatmak için tıklayın",
  "Clicks log": "Tıklama logu",
  "Clipboard unavailable — copy the URL manually": "Pano kullanılamıyor — URL'yi manuel olarak kopyalayın",
  "Cloaked (iframe)": "Cloaked (iframe)",
  "Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.": "Cloaked iframe, adres çubuğunda tracker domainini korur — yalnızca çerçevelemeye izin veren hedefler için çalışır.",
  "Clone": "Klonla",
  "Close navigation": "Navigasyonu kapat",
  "Cohort": "Kohort",
  "Cohort retention": "Kohort tutma oranı",
  "Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.": "Postback gönderme yetkisi olan IP'lerin virgülle ayrılmış listesi. Tümüne izin vermek için boş bırakın.",
  "Compare": "Karşılaştır",
  "Compare current to proposed weights. Apply persists the proposed column to the streams.": "Mevcut ağırlıkları önerilen ağırlıklarla karşılaştırın. Uygula, önerilen sütunu akışlara kaydeder.",
  "Comparing…": "Karşılaştırılıyor…",
  "Compliance": "Uyumluluk",
  "Configure UTM templates and conversion postbacks for every ad network you run.": "Her reklam ağı için UTM şablonlarını ve dönüşüm postback'lerini yapılandırın.",
  "Configure offers, payouts and target geos. Upload ZIPs or link external networks.": "Teklif/offer'ları, ödemeleri ve hedef GEO'ları yapılandırın. ZIP dosyaları yükleyin veya harici ağlara bağlanın.",
  "Configure stream": "Akışı yapılandır",
  "Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.": "Tracker'ınızın landing page'lerinde çalışan GDPR / CCPA çerez banner'ını yapılandırın. Banner bölgeye duyarlıdır — yapılandırılan bölgeler dışındaki ziyaretçiler bunu hiçbir zaman görmez.",
  "Confirm action": "İşlemi onayla",
  "Connect external services and webhooks": "Harici servisleri ve webhook'ları bağlayın",
  "Connect external services and webhooks to automate workflows.": "İş akışlarını otomatikleştirmek için harici servisleri ve webhook'ları bağlayın.",
  "Connection restored": "Bağlantı yeniden kuruldu",
  "Connections": "Bağlantılar",
  "Consent banner": "Onay banner'ı",
  "Consent banner saved": "Onay banner'ı kaydedildi",
  "Conv": "Dön",
  "Conv.": "Dön.",
  "Conversion rate comparison": "Dönüşüm oranı karşılaştırması",
  "Cookieless mode (skip xpnsr_vid first-party cookie)": "Cookie'siz mod (xpnsr_vid first-party cookie'sini atla)",
  "Copied to clipboard.": "Panoya kopyalandı.",
  "Copy link (/r/)": "Linki kopyala (/r/)",
  "Copy link (/{alias}/)": "Linki kopyala (/{alias}/)",
  "Cost": "Maliyet",
  "Cost value": "Maliyet değeri",
  "Could not accept invitation": "Davet kabul edilemedi",
  "Could not copy — please copy the link manually.": "Kopyalanamadı — lütfen linki manuel olarak kopyalayın.",
  "Could not create public link": "Herkese açık link oluşturulamadı",
  "Could not load branding": "Marka kimliği yüklenemedi",
  "Could not load marketplace templates.": "Marketplace şablonları yüklenemedi.",
  "Could not load template detail.": "Şablon detayı yüklenemedi.",
  "Could not load the shared dashboard.": "Paylaşılan dashboard yüklenemedi.",
  "Could not reset branding": "Marka kimliği sıfırlanamadı",
  "Could not save branding": "Marka kimliği kaydedilemedi",
  "Country (ISO-2)": "Ülke (ISO-2)",
  "Create a campaign first": "Önce bir kampanya oluşturun",
  "Create key": "Anahtar oluştur",
  "Create landing page": "Landing page oluştur",
  "Create link": "Link oluştur",
  "Create new landing page": "Yeni landing page oluştur",
  "Create new offer": "Yeni teklif oluştur",
  "Create offer": "Teklif oluştur",
  "Create pool": "Pool oluştur",
  "Custom domain": "Özel domain",
  "Custom range": "Özel aralık",
  "Customise the dashboard for your agency or sub-account": "Dashboard'u ajansınız veya alt hesabınız için özelleştirin",
  "Daily cap": "Günlük limit",
  "Dashboard hostname": "Dashboard hostname",
  "Decision": "Karar",
  "Default offer URL": "Varsayılan offer URL",
  "Defense": "Savunma",
  "Delete A/B test": "A/B testini sil",
  "Delete API key": "API anahtarını sil",
  "Delete automation rule": "Otomasyon kuralını sil",
  "Delete campaign": "Kampanyayı sil",
  "Delete campaigns": "Kampanyaları sil",
  "Delete connection": "Bağlantıyı sil",
  "Delete domain": "Domaini sil",
  "Delete domain pool": "Domain havuzunu sil",
  "Delete failed.": "Silme başarısız.",
  "Delete forwarder": "Forwarder'ı sil",
  "Delete integration": "Entegrasyonu sil",
  "Delete landing page": "Landing page'i sil",
  "Delete offer": "Offer'ı sil",
  "Delete pre-landing": "Pre-landing'i sil",
  "Delete stream": "Akışı sil",
  "Delete traffic source": "Trafik kaynağını sil",
  "Delete webhook": "Webhook'u sil",
  "Delete {n} selected campaign(s)? This cannot be undone.": "{n} seçili kampanya silinsin mi? Bu işlem geri alınamaz.",
  "Denver (UTC-7)": "Denver (UTC-7)",
  "Deselect all": "Tümünü seç",
  "Device": "Cihaz",
  "Disable 2FA": "2FA'yı devre dışı bırak",
  "Disable 2FA — enter a current code": "2FA'yı devre dışı bırak — mevcut kodu girin",
  "Disable auto-refresh": "Otomatik yenilemeyi devre dışı bırak",
  "Disable failed": "Devre dışı bırakma başarısız",
  "Disabled": "Devre dışı",
  "Discard DLQ entry": "DLQ girişini at",
  "Dismissed": "Reddedildi",
  "Do not block by classification": "Sınıflandırmaya göre engelleme",
  "Domain marked healthy": "Domain sağlıklı olarak işaretlendi",
  "Domain not verified yet — check the DNS record.": "Domain henüz doğrulanmadı — DNS kaydını kontrol edin.",
  "Domain pool created": "Domain havuzu oluşturuldu",
  "Domain pool deleted": "Domain havuzu silindi",
  "Domain pools": "Domain havuzları",
  "Domain pulled from rotation": "Domain rotasyondan çıkarıldı",
  "Domain registered. Add the DNS record, then verify.": "Domain kaydedildi. DNS kaydını ekleyin, ardından doğrulayın.",
  "Done": "Tamam",
  "Dubai (UTC+4)": "Dubai (UTC+4)",
  "EPC": "EPC",
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": "Her satır, o günün ilk kez gelen ziyaretçilerini gösterir. Sütunlar, gün farkına göre kümülatif CR'yi takip eder.",
  "Earnings per click": "Tıklama başına kazanç",
  "Edit pre-landing": "Pre-landing'i düzenle",
  "Enable 2FA": "2FA'yı etkinleştir",
  "Enabled": "Etkin",
  "Enter a code from the app to confirm": "Onaylamak için uygulamadan kodu girin",
  "Enter a hostname": "Bir hostname girin",
  "Enter an offer URL": "Bir teklif URL'si girin",
  "Enter the 6-digit code from your authenticator app, or one of your backup codes.": "Kimlik doğrulama uygulamanızdaki 6 haneli kodu veya yedek kodlarınızdan birini girin.",
  "Epsilon (ε)": "Epsilon (ε)",
  "Error archiving campaign": "Kampanya arşivlenirken hata oluştu",
  "Error cloning campaign": "Kampanya kopyalanırken hata oluştu",
  "Expires": "Son kullanma tarihi",
  "Expires after (days)": "Süre sonu (gün)",
  "Explicit blocked fingerprints (comma-separated)": "Açıkça engellenen parmak izleri (virgülle ayrılmış)",
  "Export JSON": "JSON olarak dışa aktar",
  "Export XLSX": "XLSX olarak dışa aktar",
  "Extra countries (ISO-3166 alpha-2)": "Ek ülkeler (ISO-3166 alpha-2)",
  "Failed to accept invite": "Davet kabul edilemedi",
  "Failed to apply optimization": "Optimizasyon uygulanamadı",
  "Failed to compare": "Karşılaştırma başarısız",
  "Failed to copy tracking link": "Takip bağlantısı kopyalanamadı",
  "Failed to create campaign": "Kampanya oluşturulamadı",
  "Failed to create pool": "Havuz oluşturulamadı",
  "Failed to delete key": "Anahtar silinemedi",
  "Failed to load campaigns": "Kampanyalar yüklenemedi",
  "Failed to load clicks log": "Tıklama günlüğü yüklenemedi",
  "Failed to load consent config": "Onay yapılandırması yüklenemedi",
  "Failed to load conversions": "Dönüşümler yüklenemedi",
  "Failed to load pre-landings": "Pre-landing'ler yüklenemedi",
  "Failed to load profile": "Profil yüklenemedi",
  "Failed to load sub-ID report": "Sub ID raporu yüklenemedi",
  "Failed to preview optimization": "Optimizasyon önizlemesi yüklenemedi",
  "Failed to register domain": "Domain kaydedilemedi",
  "Failed to revoke access": "Erişim iptal edilemedi",
  "Failed to save": "Kaydedilemedi",
  "Failed to update status": "Durum güncellenemedi",
  "Fallback offer": "Yedek teklif",
  "Filter junk traffic, block malicious IPs and review suspicious activity in one place.": "Gereksiz trafiği filtreleyin, zararlı IP'leri engelleyin ve şüpheli aktiviteleri tek bir yerden inceleyin.",
  "From (ISO-8601)": "Başlangıç (ISO-8601)",
  "GDPR: pseudonymize visitor IPs (hash before storage)": "GDPR: ziyaretçi IP'lerini anonimleştir (depolamadan önce hashle)",
  "Generate a key to call the public REST API.": "Genel REST API'yi çağırmak için bir anahtar oluşturun.",
  "Go back": "Geri dön",
  "Go to Workspace": "Çalışma Alanına git",
  "Group (optional)": "Grup (isteğe bağlı)",
  "Group by:": "Gruplandırma ölçütü:",
  "Healthy": "Sağlıklı",
  "Hide xpnsr branding": "xpnsr markasını gizle",
  "Hosted pages and uploads": "Barındırılan sayfalar ve yüklemeler",
  "Hostname": "Hostname",
  "Install": "Kur",
  "Install failed.": "Kurulum başarısız.",
  "Invalid 2FA code": "Geçersiz 2FA kodu",
  "Invalid SSO session": "Geçersiz SSO oturumu",
  "Invitation accepted!": "Davet kabul edildi!",
  "JS redirect (location.replace)": "JS yönlendirme (location.replace)",
  "Keyboard shortcuts": "Klavye kısayolları",
  "Keyboard shortcuts (?)": "Klavye kısayolları (?)",
  "Keyword exclude": "Anahtar kelime hariç tut",
  "Keyword include": "Anahtar kelime dahil et",
  "Label (operator-only)": "Etiket (yalnızca operatör)",
  "Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.": "Bu workspace'teki son 200 onay kaydı. DSAR / düzenleyici kurum sorguları için denetim izi olarak kullanılır.",
  "Last viewed": "Son görüntülenen",
  "Layout": "Düzen",
  "Layout & retention": "Düzen ve saklama",
  "Live": "Canlı",
  "Live KPIs and breakdowns across campaigns, geos, devices.": "Kampanyalar, GEO'lar ve cihazlar genelinde canlı KPI'lar ve dağılımlar.",
  "Loading marketplace…": "Marketplace yükleniyor…",
  "Loading...": "Yükleniyor...",
  "Login page subtitle": "Giriş sayfası alt başlığı",
  "Logo URL": "Logo URL",
  "London (UTC+0)": "Londra (UTC+0)",
  "Lookback (days)": "Lookback (gün)",
  "Los Angeles (UTC-8)": "Los Angeles (UTC-8)",
  "Make sure your tracking URLs include {key}=... parameter": "Takip URL'lerinizin {key}=... parametresini içerdiğinden emin olun",
  "Manage profile, preferences, notifications and system configuration.": "Profil, tercihler, bildirimler ve sistem yapılandırmasını yönetin.",
  "Manage your offers and creatives": "Teklif ve materyallerinizi yönetin",
  "Manual entry secret": "Manuel giriş için gizli anahtar",
  "Mark all read": "Tümünü okundu işaretle",
  "Mark read": "Okundu işaretle",
  "Marketplace": "Marketplace",
  "Match if referrer/params contain a keyword": "Referrer/parametreler bir anahtar kelime içeriyorsa eşleştir",
  "Meta refresh": "Meta refresh",
  "Metric": "Metrik",
  "Min clicks per stream": "Akış başına min. tıklama",
  "Minimum ROI (%)": "Minimum ROI (%)",
  "Missing SSO session token": "SSO oturum token'ı eksik",
  "Missing invite token": "Davet token'ı eksik",
  "Most clicks": "En fazla tıklama",
  "Most revenue": "En fazla gelir",
  "Mumbai (UTC+5:30)": "Mumbai (UTC+5:30)",
  "Must be an https:// URL. Leave blank to fall back to the xpnsr logo.": "https:// ile başlayan bir URL olmalıdır. Varsayılan xpnsr logosunu kullanmak için boş bırakın.",
  "Name A→Z": "Ad A→Z",
  "Name Z→A": "Ad Z→A",
  "Name and target URL are required": "Ad ve hedef URL zorunludur",
  "Name is required.": "Ad zorunludur.",
  "New": "Yeni",
  "New pre-landing": "Yeni pre-landing",
  "New public dashboard link": "Yeni genel panel bağlantısı",
  "Newest first": "Önce en yeni",
  "Next": "İleri",
  "No active streams to optimize.": "Optimize edilecek aktif akış yok.",
  "No clicks match these filters.": "Bu filtrelere uyan tıklama yok.",
  "No cohort data": "Kohort verisi yok",
  "No consent records yet.": "Henüz onay kaydı yok.",
  "No conversions yet": "Henüz dönüşüm yok",
  "No data found for {key}": "{key} için veri bulunamadı",
  "No data yet.": "Henüz veri yok.",
  "No description provided.": "Açıklama girilmedi.",
  "No internet connection": "İnternet bağlantısı yok",
  "No notifications yet": "Henüz bildirim yok",
  "No performance data yet": "Henüz performans verisi yok",
  "No pre-landings yet. Create one to start chaining traffic.": "Henüz pre-landing yok. Trafiği zincirlemeye başlamak için bir tane oluşturun.",
  "No public links yet. Create one to share read-only stats with advertisers.": "Henüz genel bağlantı yok. Reklamverenlere salt okunur istatistik paylaşmak için bir tane oluşturun.",
  "No results.": "Sonuç yok.",
  "No templates match these filters.": "Bu filtrelere uyan şablon yok.",
  "No vendors disclosed.": "Hiçbir tedarikçi açıklanmadı.",
  "No verified custom domains. Add one in Domains → Settings.": "Doğrulanmış özel domain yok. Domains → Settings bölümünden ekleyin.",
  "None": "Yok",
  "Notify only": "Yalnızca bildir",
  "Oldest first": "Önce en eski",
  "Onboarding complete!": "Onboarding tamamlandı!",
  "Only match if referrer contains one of these": "Yalnızca referrer şunlardan birini içeriyorsa eşleştir",
  "Open Campaigns": "Kampanyaları Aç",
  "Open Domains page": "Domains sayfasını aç",
  "Open command palette": "Komut paletini aç",
  "Open landing pages": "Landing page'leri aç",
  "Open my tracking link": "Takip bağlantımı aç",
  "Operators host the static page; the tracker just routes clicks here first.": "Operatörler statik sayfayı barındırır; tracker yalnızca tıklamaları önce buraya yönlendirir.",
  "Optimization": "Optimizasyon",
  "Optional": "İsteğe bağlı",
  "Pages library": "Sayfa kütüphanesi",
  "Parameter name, e.g. sub1": "Parametre adı, örn. sub1",
  "Pause": "Duraklat",
  "Performance": "Performans",
  "Performance overview": "Performans özeti",
  "Permanently discard this dead-letter entry? This cannot be undone.": "Bu dead-letter kaydını kalıcı olarak sil? Bu işlem geri alınamaz.",
  "Please sign in first, then open the invite link again.": "Lütfen önce giriş yapın, ardından davet bağlantısını tekrar açın.",
  "Please wait…": "Lütfen bekleyin…",
  "Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.": "Bu hostname'i DNS üzerinden tracker'a yönlendirin. Ziyaretçiler giriş yapmadan önce markanızı görecek.",
  "Pool name": "Havuz adı",
  "Postback IP whitelist": "Postback IP beyaz listesi",
  "Pre-Landings": "Pre-landing page'ler",
  "Pre-landing created": "Pre-landing page oluşturuldu",
  "Pre-landing deleted": "Pre-landing page silindi",
  "Pre-landing updated": "Pre-landing page güncellendi",
  "Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.": "Pre-landing page'ler, ziyaretçileri teklife göndermeden önce daha hızlı ve uyumlu bir giriş sayfası sunar. İstediğiniz zaman ekleyebilirsiniz.",
  "Preview": "Önizleme",
  "Previous": "Önceki",
  "Primary colour": "Ana renk",
  "Privacy policy URL": "Gizlilik politikası URL",
  "Products": "Ürünler",
  "Proposed": "Önerilen",
  "Proposed drift": "Önerilen kayma",
  "Proposed weights": "Önerilen ağırlıklar",
  "Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.": "Hesabınızı bir kimlik doğrulama uygulamasından TOTP koduyla koruyun. Yedek kodlar, cihazınızı kaybetmeniz durumunda giriş yapmanızı sağlar.",
  "Public link created — copy it now, it won't be shown again.": "Genel bağlantı oluşturuldu — şimdi kopyalayın, bir daha gösterilmeyecek.",
  "Public link revoked.": "Genel bağlantı iptal edildi.",
  "Public read-only links": "Genel salt okunur bağlantılar",
  "Publish": "Yayınla",
  "Publishing…": "Yayınlanıyor…",
  "Pull out of rotation": "Rotasyondan çıkar",
  "Purpose (e.g. Analytics)": "Amaç (ör. Analytics)",
  "Quick start from template": "Şablondan hızlı başlat",
  "Quiz / review / bonus pages that intercept the click before the final landing or offer.": "Son landing page veya teklife geçmeden önce tıklamayı yakalayan quiz / inceleme / bonus sayfaları.",
  "ROI": "ROI",
  "ROI alert": "ROI uyarısı",
  "Random seed (optional)": "Rastgele tohum (isteğe bağlı)",
  "Read-only public view — generated by xpnsr-tracker.": "Salt okunur genel görünüm — xpnsr-tracker tarafından oluşturuldu.",
  "Rebalance stream weights based on historical conversion rate using a multi-armed bandit.": "Multi-armed bandit kullanarak geçmiş dönüşüm oranına göre akış ağırlıklarını yeniden dengeleyin.",
  "Recent decisions": "Son kararlar",
  "Record retention (days)": "Kayıt saklama süresi (gün)",
  "Redirect method": "Yönlendirme yöntemi",
  "Redirect mode": "Yönlendirme modu",
  "Referrer / Keyword filters": "Referrer / Anahtar kelime filtreleri",
  "Referrer exclude": "Referrer hariç tut",
  "Referrer include": "Referrer dahil et",
  "Region preset": "Bölge ön ayarı",
  "Region scope": "Bölge kapsamı",
  "Register a custom hostname so your tracking links resolve under your own brand.": "Takip bağlantılarınızın kendi markanız altında çalışması için özel bir hostname kaydedin.",
  "Register hostname": "Hostname kaydet",
  "Reject button label": "Reddet butonu etiketi",
  "Rejected": "Reddedildi",
  "Remove": "Kaldır",
  "Remove template": "Şablonu kaldır",
  "Remove this template? This cannot be undone.": "Bu şablon kaldırılsın mı? Bu işlem geri alınamaz.",
  "Reset branding": "Markalaşmayı sıfırla",
  "Reset to defaults": "Varsayılanlara sıfırla",
  "Resetting…": "Sıfırlanıyor…",
  "Restore": "Geri yükle",
  "Restore to rotation": "Rotasyona geri yükle",
  "Return on investment": "Yatırım getirisi",
  "Rev.": "Gel.",
  "Revenue comparison": "Gelir karşılaştırması",
  "Revoke": "İptal et",
  "Revoke failed": "İptal başarısız oldu",
  "Revoke public link": "Genel bağlantıyı iptal et",
  "Risk score threshold (0.0 – 1.0)": "Risk skoru eşiği (0.0 – 1.0)",
  "Round robin": "Round robin",
  "Routing": "Routing",
  "Row-level drill-down into incoming clicks: country, device, stream, and variant.": "Gelen tıklamalara satır bazlı detay görünümü: ülke, cihaz, akış ve varyant.",
  "Run a preview to see proposed weights.": "Önerilen ağırlıkları görmek için önizleme çalıştırın.",
  "SSO failed": "SSO başarısız oldu",
  "SSO is not configured": "SSO yapılandırılmamış",
  "SSO sign-in failed": "SSO ile giriş başarısız oldu",
  "Save branding": "Markalaşmayı kaydet",
  "Scan the QR code with your authenticator app": "QR kodu kimlik doğrulama uygulamanızla tarayın",
  "Search": "Ara",
  "Search by name, description, or slug. Filter by type or tag.": "Ad, açıklama veya slug ile arayın. Tür veya etikete göre filtreleyin.",
  "Search…": "Ara…",
  "Secondary colour": "İkincil renk",
  "Select all": "Tümünü seç",
  "Select at least 2 campaigns": "En az 2 kampanya seçin",
  "Select campaigns (2–10)": "Kampanya seçin (2–10)",
  "Sending…": "Gönderiliyor…",
  "Set up rules, notifications and triggered actions for your campaigns.": "Kampanyalarınız için kurallar, bildirimler ve tetikleyici aksiyonlar ayarlayın.",
  "Set up your tracker": "Tracker'ınızı yapılandırın",
  "Setup failed": "Kurulum başarısız oldu",
  "Share a token-gated dashboard URL with advertisers without giving them an account.": "Reklamverenlere hesap açmadan, token korumalı bir panel URL'si paylaşın.",
  "Shareable URL": "Paylaşılabilir URL",
  "Shared dashboard": "Paylaşılan panel",
  "Side-by-side metrics for selected campaigns": "Seçili kampanyalar için yan yana metrikler",
  "Sign in with Google": "Google ile giriş yap",
  "Sign in with Microsoft": "Microsoft ile giriş yap",
  "Singapore (UTC+8)": "Singapur (UTC+8)",
  "Size": "Boyut",
  "Skip for now": "Şimdilik atla",
  "Skip if referrer contains one of these": "Referrer şunlardan birini içeriyorsa atla",
  "Skip if referrer/params contain a keyword": "Referrer/parametreler bir anahtar kelime içeriyorsa atla",
  "Skip this step until you have a campaign — you can finish setup from the Campaigns page.": "Bir kampanyanız olana kadar bu adımı atlayın — kurulumu Kampanyalar sayfasından tamamlayabilirsiniz.",
  "Skipped (below min_clicks_per_stream)": "Atlandı (min_clicks_per_stream altında)",
  "Smoothed CR": "Düzleştirilmiş CR",
  "Sort by": "Sıralama ölçütü",
  "Split traffic across variants to find what converts best.": "En iyi dönüşümü bulmak için trafiği varyantlar arasında böl.",
  "Step {step} of {total}": "{step}. adım / {total}",
  "Sticky (per-visitor)": "Yapışkan (ziyaretçi bazlı)",
  "Stream": "Akış",
  "Stream ID": "Akış ID",
  "Stream configured": "Akış yapılandırıldı",
  "Streams decide which offer each visitor lands on. Configure your default stream and you\\'ll have a working tracking link.": "Akışlar, her ziyaretçinin hangi teklife yönlendirileceğini belirler. Varsayılan akışı yapılandırın; çalışan bir takip bağlantısına sahip olursunuz.",
  "Sub-ID drill-down": "Sub ID detay görünümü",
  "Submission failed.": "Gönderim başarısız oldu.",
  "Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.": "Gönderimler otomatik yayınlanır. Slug, isimden türetilir; mevcut bir şablonla çakışırsa sonuna sayısal bir ek eklenir.",
  "Submit a template": "Şablon gönder",
  "Submit template": "Şablon gönder",
  "Sydney (UTC+11)": "Sydney (UTC+11)",
  "São Paulo (UTC-3)": "São Paulo (UTC-3)",
  "TLS fingerprint (JA3 / JA4)": "TLS parmak izi (JA3 / JA4)",
  "Tags (comma-separated)": "Etiketler (virgülle ayrılmış)",
  "Tags:": "Etiketler:",
  "Template": "Şablon",
  "Template body copied to clipboard.": "Şablon içeriği panoya kopyalandı.",
  "Template installed. Body shown in detail dialog.": "Şablon yüklendi. İçerik detay penceresinde görüntüleniyor.",
  "Template marketplace": "Şablon marketi",
  "Template published as {slug}.": "Şablon {slug} olarak yayınlandı.",
  "Template removed.": "Şablon silindi.",
  "The token will only be shown once after creation — copy it immediately.": "Token oluşturulduktan sonra yalnızca bir kez gösterilecektir — hemen kopyalayın.",
  "Third-party processors disclosed to the visitor (max 50).": "Ziyaretçiye açıklanan üçüncü taraf işlemciler (maks. 50).",
  "This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.": "Bu bağlantı kimlik doğrulaması gerektirmez. Bağlantıya sahip olan herkes, süresi dolana veya iptal edilene kadar seçili metrikleri görüntüleyebilir.",
  "This member will lose access to this workspace immediately.": "Bu üye, çalışma alanına erişimini hemen kaybedecektir.",
  "This shared link has expired or been revoked.": "Bu paylaşım bağlantısının süresi dolmuş veya iptal edilmiş.",
  "This shared link is not valid.": "Bu paylaşım bağlantısı geçerli değil.",
  "This will permanently delete \"{name}\" and all associated clicks, conversions and postback events. This cannot be undone.": "Bu işlem \"{name}\" ile ilişkili tüm tıklamalar, dönüşümler ve postback olaylarını kalıcı olarak silecektir. Bu işlem geri alınamaz.",
  "This will permanently delete \"{name}\" and all its variants.": "Bu işlem \"{name}\" ve tüm varyantlarını kalıcı olarak silecektir.",
  "This will permanently delete \"{name}\" and remove it from all campaigns.": "Bu işlem \"{name}\" öğesini kalıcı olarak silecek ve tüm kampanyalardan kaldıracaktır.",
  "This will permanently delete \"{name}\".": "Bu işlem \"{name}\" öğesini kalıcı olarak silecektir.",
  "This will permanently delete \"{name}\". Campaigns using this domain will fall back to the default domain.": "Bu işlem \"{name}\" öğesini kalıcı olarak silecektir. Bu domaini kullanan kampanyalar varsayılan domaine geçecektir.",
  "This will permanently delete \"{name}\". Campaigns using this source will lose their tracking parameters.": "Bu işlem \"{name}\" öğesini kalıcı olarak silecektir. Bu trafik kaynağını kullanan kampanyalar takip parametrelerini kaybedecektir.",
  "This will permanently delete pool \"{name}\".": "Bu işlem \"{name}\" havuzunu kalıcı olarak silecektir.",
  "This will permanently delete rule \"{name}\".": "Bu işlem \"{name}\" kuralını kalıcı olarak silecektir.",
  "This will permanently delete stream \"{name}\".": "Bu işlem \"{name}\" akışını kalıcı olarak silecektir.",
  "This will permanently delete this ad account connection. Cost syncing will stop.": "Bu işlem bu reklam hesabı bağlantısını kalıcı olarak silecek. Maliyet senkronizasyonu duracak.",
  "This will permanently delete this conversion forwarder.": "Bu işlem bu dönüşüm forwarder'ını kalıcı olarak silecek.",
  "This will permanently delete webhook \"{name}\". Events will no longer be forwarded.": "Bu işlem \"{name}\" webhook'unu kalıcı olarak silecek. Olaylar artık iletilmeyecek.",
  "This will permanently revoke this API key. Any integrations using it will stop working.": "Bu işlem bu API anahtarını kalıcı olarak iptal edecek. Onu kullanan tüm entegrasyonlar çalışmayı durduracak.",
  "This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.": "Bu işlem tüm marka ayarlarını varsayılana sıfırlayacak. Logo, renkler ve özel domain kaldırılacak.",
  "This will reset two-factor authentication for this member. They will need to re-enrol.": "Bu işlem bu üye için 2FA'yı sıfırlayacak. Üyenin yeniden kaydolması gerekecek.",
  "Title": "Başlık",
  "Title, body, and button labels shown to the visitor.": "Ziyaretçiye gösterilen başlık, içerik ve buton etiketleri.",
  "To (ISO-8601)": "Bitiş (ISO-8601)",
  "Toggle navigation": "Navigasyonu aç/kapat",
  "Tokyo (UTC+9)": "Tokyo (UTC+9)",
  "Too many requests — please retry in a moment.": "Çok fazla istek — lütfen bir süre sonra tekrar deneyin.",
  "Track click usage and switch plans. Billing renews monthly.": "Tıklama kullanımını takip edin ve planları değiştirin. Faturalandırma aylık yenilenir.",
  "Tracking domain": "Tracking domain",
  "Tracking link copied to clipboard": "Tracking linki panoya kopyalandı",
  "Tune the bandit before running a preview. Apply only writes weights to active streams.": "Önizleme çalıştırmadan önce banditi ayarlayın. Uygula yalnızca aktif akışlara ağırlık yazar.",
  "Two-factor authentication": "İki faktörlü kimlik doğrulama (2FA)",
  "Two-factor code": "2FA kodu",
  "Type": "Tür",
  "Type a command or search…": "Komut girin veya arayın…",
  "Ungrouped": "Grupsuz",
  "Unlimited": "Sınırsız",
  "Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.": "Bir landing page paketi (.zip) yükleyin veya kütüphaneden barındırılan bir pre-lander şablonu seçin.",
  "Upload, organize and reuse landing pages across your campaigns.": "Landing page'lerinizi yükleyin, düzenleyin ve kampanyalarınızda yeniden kullanın.",
  "Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.": "Temel listeyi (Python requests, Go net/http, curl, headless Chrome) ve workspace'e özgü geçersiz kılmalarınızı kullanır.",
  "Vendor list": "Vendor listesi",
  "Vendor name (e.g. Google Analytics)": "Vendor adı (ör. Google Analytics)",
  "Verify now": "Şimdi doğrula",
  "Verifying…": "Doğrulanıyor…",
  "View": "Görüntüle",
  "Views": "Görüntülemeler",
  "Visible metrics": "Görünür metrikler",
  "Visitor": "Ziyaretçi",
  "Visual identity": "Görsel kimlik",
  "Weight floor (%)": "Minimum ağırlık (%)",
  "Weighted": "Ağırlıklı",
  "Welcome to ACME Tracker — sign in to continue": "ACME Tracker'a hoş geldiniz — devam etmek için giriş yapın",
  "When disabled, the public widget responds with required:false so landing pages skip rendering entirely.": "Devre dışı bırakıldığında, public widget required:false döndürür; böylece landing page render işlemini tamamen atlar.",
  "When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.": "Ayarlandığında, tracker yönlendirme URL'lerine otomatik olarak ?<param>=<click_id> ekler. Devre dışı bırakmak için boş bırakın. Tam kontrol için hedef URL'de {click_id} kullanın.",
  "Workflows": "İş akışları",
  "Workspace default domain": "Workspace varsayılan domain'i",
  "Your tracking link": "Tracking linkiniz",
  "clear tag": "etiketi temizle",
  "clicks": "tıklamalar",
  "connections": "bağlantılar",
  "domains": "alan adları",
  "e.g. 185.45.12.1, 91.108.0.0": "örn. 185.45.12.1, 91.108.0.0",
  "e.g. Facebook, Google, Tier 1": "örn. Facebook, Google, Tier 1",
  "e.g. MaxBounty CPA": "örn. MaxBounty CPA",
  "e.g. adcombo, cpa, status": "örn. adcombo, cpa, status",
  "group.<key>": "group.<key>",
  "installs": "kurulumlar",
  "live": "canlı",
  "logo": "logo",
  "max change": "maks. değişim",
  "no": "hayır",
  "or continue with": "veya şununla devam et",
  "revoked": "iptal edildi",
  "rows": "satırlar",
  "to close": "kapatmak için",
  "to navigate": "gezinmek için",
  "to select": "seçmek için",
  "weight units": "ağırlık birimleri",
  "yes": "evet",
  "{count} conversions": "{count} dönüşüm",
  "{key} breakdown": "{key} dağılımı",
  "{n} selected": "{n} seçildi",
  "Δ": "Δ",
  "Sub-ID reports": "Sub-ID raporları",
  "Ad accounts": "Reklam hesapları",
  "API docs": "API dokümantasyonu",
  "Drill-down by sub1–sub15: clicks, conversions, CR": "sub1–sub15'e göre detay: tıklamalar, dönüşümler, CR",
  "Side-by-side metrics for multiple campaigns": "Birden fazla kampanya için yan yana metrikler",
  "Step-by-step user guide for every feature": "Her özellik için adım adım kullanım kılavuzu",
  "Switch to dark theme": "Koyu temaya geç",
  "Switch to light theme": "Açık temaya geç",
  "Page not found": "Sayfa bulunamadı",
  "The page you are looking for does not exist or has been moved.": "Aradığınız sayfa mevcut değil veya taşınmış.",
  "Access denied": "Erişim reddedildi",
  "You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.": "Bu sayfayı görüntüleme izniniz yok. Bunun bir hata olduğunu düşünüyorsanız çalışma alanı yöneticinizle iletişime geçin.",
  "Server error": "Sunucu hatası",
  "Something went wrong on our end. Please try again later or contact support.": "Bizim tarafımızda bir şeyler ters gitti. Lütfen daha sonra tekrar deneyin veya destek ekibiyle iletişime geçin.",
  "View campaigns": "Kampanyaları görüntüle",
  "List and open campaigns and their stats.": "Kampanyaları ve istatistiklerini listele ve aç.",
  "Create campaigns": "Kampanya oluştur",
  "Add new campaigns and their default streams.": "Yeni kampanyalar ve varsayılan akışlarını ekle.",
  "Edit campaigns": "Kampanyaları düzenle",
  "Change campaign settings, target URL, status.": "Kampanya ayarlarını, hedef URL'yi ve durumu değiştir.",
  "Permanently remove a campaign and its history.": "Bir kampanyayı ve geçmişini kalıcı olarak sil.",
  "View landings": "Landing page'leri görüntüle",
  "Browse the landing-page library.": "Landing page kütüphanesine göz at.",
  "Edit landings": "Landing page'leri düzenle",
  "Upload, edit, and delete landings.": "Landing page yükle, düzenle ve sil.",
  "View offers": "Offer'ları görüntüle",
  "Browse the offer library.": "Offer kütüphanesine göz at.",
  "Edit offers": "Offer'ları düzenle",
  "Create, edit, and delete offers.": "Offer oluştur, düzenle ve sil.",
  "View anti-fraud": "Anti-fraud'u görüntüle",
  "Read filter list, blocked samples, audit feed.": "Filtre listesini, engellenen örnekleri ve denetim akışını görüntüle.",
  "Edit anti-fraud filters": "Anti-fraud filtrelerini düzenle",
  "Create / update / delete fraud filters and IP lists.": "Fraud filtreleri ve IP listelerini oluştur / güncelle / sil.",
  "Manage TLS fingerprint overrides": "TLS parmak izi geçersiz kılmalarını yönet",
  "Pin JA3 / JA4 hashes per-workspace (overrides the seed list).": "JA3 / JA4 hash'lerini workspace bazında sabitle (seed listesini geçersiz kılar).",
  "View reports": "Raporları görüntüle",
  "Open the analytics dashboard and saved reports.": "Analitik paneli ve kayıtlı raporları aç.",
  "Export reports": "Raporları dışa aktar",
  "Download CSV / JSON report exports.": "CSV / JSON rapor dışa aktarmalarını indir.",
  "View automation rules": "Otomasyon kurallarını görüntüle",
  "Read the rules engine and execution history.": "Kural motorunu ve çalıştırma geçmişini görüntüle.",
  "Edit automation rules": "Otomasyon kurallarını düzenle",
  "Create / update / delete automation rules.": "Otomasyon kurallarını oluştur / güncelle / sil.",
  "View integrations": "Entegrasyonları görüntüle",
  "Browse integration configurations.": "Entegrasyon yapılandırmalarına göz at.",
  "Edit integrations": "Entegrasyonları düzenle",
  "Connect / disconnect ad accounts and webhooks.": "Reklam hesaplarını ve webhook'ları bağla / bağlantısını kes.",
  "View postbacks": "Postback'leri görüntüle",
  "Browse postbacks and the CAPI dead-letter queue.": "Postback'lere ve CAPI dead-letter kuyruğuna göz at.",
  "Edit postbacks": "Postback'leri düzenle",
  "Configure postbacks, replay / discard CAPI DLQ entries.": "Postback'leri yapılandır, CAPI DLQ girişlerini yeniden gönder / iptal et.",
  "Invite members": "Üye davet et",
  "Send invite links to new teammates.": "Yeni takım üyelerine davet bağlantısı gönder.",
  "Change member role": "Üye rolünü değiştir",
  "Promote / demote existing members.": "Mevcut üyeleri yükselt / düşür.",
  "Remove members": "Üyeleri kaldır",
  "Revoke a teammate's access.": "Bir takım üyesinin erişimini iptal et.",
  "Edit workspace settings": "Workspace ayarlarını düzenle",
  "Change workspace currency, timezone, branding.": "Workspace para birimini, saat dilimini ve markalamasını değiştir.",
  "Edit permission matrix": "İzin matrisini düzenle",
  "Override the default permission matrix for this workspace.": "Bu workspace için varsayılan izin matrisini geçersiz kıl.",
  "View billing": "Faturalandırmayı görüntüle",
  "See plan, invoices, payment method.": "Planı, faturaları ve ödeme yöntemini görüntüle.",
  "Change plan, update payment method.": "Planı değiştir, ödeme yöntemini güncelle.",
  "View audit log": "Denetim günlüğünü görüntüle",
  "Read the workspace audit feed.": "Çalışma alanı denetim akışını okuyun.",
  "View tracking domains": "Takip domainlerini görüntüle",
  "Browse the tracking-domain list.": "Takip domain listesine göz atın.",
  "Edit tracking domains": "Takip domainlerini düzenle",
  "Add / remove tracking domains.": "Takip domaini ekle / kaldır.",
  "View API keys": "API anahtarlarını görüntüle",
  "List existing API keys (does not reveal the secret).": "Mevcut API anahtarlarını listele (gizli anahtarı göstermez).",
  "Manage API keys": "API anahtarlarını yönet",
  "Create / revoke API keys.": "API anahtarı oluştur / iptal et.",
  "Cloaking — send bots to a safe page": "Cloaking — botları güvenli sayfaya yönlendir",
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": "Kendi sunucunuzda cloaking. Botlar, reklam ağı moderatörleri, datacenter/proxy IP'leri ve arama motoru tarayıcıları güvenli (white) sayfayı görür; gerçek kullanıcılar asıl teklife yönlendirilir. Sınıflandırma, tracker'ın kendi bot / IP / tarayıcı-DNS kontrolleriyle yapılır — üçüncü taraf servis kullanılmaz.",
  "Safe page URL": "Güvenli sayfa URL'si",
  "The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.": "Botlara/tarayıcılara gösterilen uyumlu sayfa. Mutlaka mutlak bir http(s) URL'si olmalıdır. SEO modunda bu, doğrulanmış arama motoru tarayıcılarının indekslediği sayfadır.",
  "Bots & spoofed crawlers": "Botlar ve sahte tarayıcılar",
  "Verified search crawlers": "Doğrulanmış arama motoru tarayıcıları",
  "Datacenter / Tor IPs": "Datacenter / Tor IP'leri",
  "Proxy / VPN IPs": "Proxy / VPN IP'leri",
  "Enter a valid http(s) Safe page URL for cloaking": "Cloaking için geçerli bir http(s) güvenli sayfa URL'si girin",
  "Cloaked": "Cloaklanmış",
  "All traffic": "Tüm trafik",
  "Cloaked only": "Yalnızca cloaklanmış",
  "Real only": "Yalnızca gerçek",
  "Cloaking": "Cloaking",
  "Bots and crawlers sent to the safe page vs humans to the offer": "Botlar ve tarayıcılar güvenli sayfaya, gerçek kullanıcılar teklife yönlendiriliyor",
  "last {n} days": "son {n} gün",
  "Cloaked → safe page": "Cloaklanmış → güvenli sayfa",
  "Real → offer": "Gerçek → teklif",
  "Cloak rate": "Cloak oranı",
  "Spoofed crawlers": "Sahte tarayıcılar",
  "Verified crawlers": "Doğrulanmış tarayıcılar",
  "Datacenter / Tor": "Datacenter / Tor",
  "SEO split (crawlers → index, humans → funnel)": "SEO split (tarayıcılar → indeks, kullanıcılar → funnel)",
  "SEO crawler split on: verified crawlers index the page, humans go to the funnel": "SEO tarayıcı split'i açık: doğrulanmış tarayıcılar sayfayı indeksliyor, kullanıcılar funnel'a yönlendiriliyor",
  "SEO crawler split off": "SEO tarayıcı split'i kapalı",
  "When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.": "Açık olduğunda, DNS ile doğrulanmış arama motoru tarayıcıları indeks sayfasını alır (sıralama için), kullanıcılar ise bağlı kampanya funnel'ına yönlendirilir. Bir indeks sayfası + bu domaine bağlı bir kampanya gerektirir.",
  "Fallback robots/sitemap": "Fallback robots/sitemap",
  "Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.": "Yüklediğiniz pakette robots.txt / sitemap.xml yoksa YALNIZCA o zaman domain kökünde otomatik oluşturulmuş robots.txt / sitemap.xml sun. Kendi SEO dosyalarınız her zaman önceliklidir.",
  "Fallback robots.txt/sitemap.xml on (only when your bundle has none)": "Fallback robots.txt/sitemap.xml açık (yalnızca paketinizde yoksa)",
  "Fallback robots.txt/sitemap.xml off": "Fallback robots.txt/sitemap.xml kapalı",
  "Root: stable index": "Root: kararlı indeks",
  "Root: SEO split": "Root: SEO split",
  "Root: funnel": "Root: funnel",
  "Root: 404": "Root: 404",
  "own": "kendi",
  "fallback": "fallback",
  "none": "yok",
  "indexable": "indekslenebilir",
  "no-index": "no-index",
  "Registration": "Kayıt",
  "Deposit": "Depozit",
  "Trash": "Çöp Kutusu",
  "Hide": "Gizle",
  "Show": "Göster",
  "Import from source": "Kaynaktan içe aktar",
  "Postback token": "Postback token",
  "Require postback token": "Postback token zorunlu",
  "Network macros": "Ağ makroları",
  "FTD · Deposit (sale)": "FTD · Depozit (satış)",
  "Chargeback (reject)": "Chargeback (red)",
  "This campaign has no source with parameters": "Bu kampanyanın parametreli kaynağı yok",
  "Macros imported from the source — click Save": "Makrolar kaynaktan içe aktarıldı — Kaydet'e tıklayın",
  "Save the campaign once to generate the token.": "Token oluşturmak için kampanyayı bir kez kaydedin.",
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": "AÇIK olduğunda, gelen postback'ler bu kampanyanın token'ını taşımalıdır; aksi hâlde reddedilir (401). Ağ (ör. TrackBox) tüm kampanyalar için TEK bir ortak postback gönderiyorsa kapatın: &token=… kısmını bu URL'den kaldırın; dönüşümler click_id ile eşleştirilir.",
  "Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).": "Token kontrolü devre dışı — postback'ler token olmadan click_id ile kabul edilir (ağınızdaki URL'den &token=… kısmını kaldırın).",
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": "TrackBox: click_id'nizi teklif linkinin Affclickid parametresine ekleyin; böylece {affclickid} bu kampanyaya geri döner. Yöntem: GET.",
  "Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.": "Generic: click_id'nizi teklif linkine ekleyin; böylece {click_id} olarak bu kampanyaya geri döner. Yöntem: GET.",
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": "Subid: click_id'nizi teklif linkinin subid parametresine ekleyin; böylece {subid} bu kampanyaya geri döner. Yöntem: GET.",
  "Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.": "Bot token'ını ve chat_id'yi girin — hazır mesajlı (Kampanya, Sub1..4, Kaynak, Payout) Lead ve Deposit postback'leri eklenecektir. Ardından Kaydet'e basın.",
  "What is XPNSR Tracker": "XPNSR Tracker nedir",
  "Links & aliases": "Linkler ve takma adlar",
  "Postbacks": "Postback'ler",
  "Macros": "Makrolar",
  "Redirect modes": "Yönlendirme modları",
  "A/B tests": "A/B testleri",
  "Glossary": "Sözlük",
  "Partners & lead forms": "Partnerler ve lead formları",
  "Google Ads & conversions": "Google Ads ve dönüşümler",
  "Reports (Report Builder)": "Raporlar (Report Builder)",
  "Failed to copy": "Kopyalanamadı",
  "Domain opened for indexing": "Domain indekslemeye açıldı",
  "Domain closed from indexing": "Domain indekslemeye kapatıldı",
  "Index page set": "Index sayfası ayarlandı",
  "Index page cleared": "Index sayfası temizlendi",
  "Server migration (admin only)": "Sunucu migrasyonu (yalnızca admin)",
  "Current server IP:": "Mevcut sunucu IP:",
  "Step 1. Provision a new server": "Adım 1. Yeni sunucuyu hazırlayın",
  "Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.": "AWS'de bir EC2 instance oluşturun (Ubuntu, 80 ve 443 portları açık), SSH ile bağlanın ve bu komutu olduğu gibi yapıştırın. Sonunda yeni sunucunun IP'si görüntülenir.",
  "Step 2. Enter the new IP": "Adım 2. Yeni IP'yi girin",
  "Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.": "Adım 1'deki IP'yi yapıştırın ve Kaydet'e tıklayın. Her istemci A kaydı için yeni IP'yi anında alır — yeniden başlatmaya gerek yoktur.",
  "Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.": "İpucu: AWS'de eski Elastic IP'yi yeni sunucuya atarsanız burada hiçbir şeyi değiştirmenize gerek kalmaz — istemciler için de.",
  "Open for search engines — click to close": "Arama motorlarına açık — kapatmak için tıklayın",
  "Closed from search engines — click to open": "Arama motorlarına kapalı — açmak için tıklayın",
  "Indexable": "İndekslenebilir",
  "No-index": "No-index",
  "Index page (SEO, served at the root with 200):": "Index sayfası (SEO, kök dizinde 200 koduyla sunulur):",
  "— none (root opens the funnel) —": "— yok (kök dizin funnel'ı açar) —",
  "Custom API (any CRM)": "Custom API (herhangi bir CRM)",
  "TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.": "TrackBox hesap bilgileri (dashboard → API Testing). Hesap başına bir kez yapılandırın — offer'lar bu partnere başvuracaktır.",
  "Username": "Kullanıcı adı",
  "Signup path": "Kayıt yolu",
  "Pull path": "Pull yolu",
  "Pull type": "Pull türü",
  "Auto pull-sync": "Otomatik pull-sync",
  "Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.": "Herhangi bir partner CRM'i için evrensel entegrasyon. Lead kayıt API isteğini tanımlayın — tracker form verilerini oraya gönderir ve yanıttaki bağlantıya yönlendirir.",
  "API URL (base)": "API URL (temel)",
  "Body format": "Body formatı",
  "Headers": "Headers",
  "(one \"Key: value\" per line, macros allowed)": "(satır başına bir \"Anahtar: değer\", makrolar kullanılabilir)",
  "Body template (JSON)": "Body şablonu (JSON)",
  "(values are macros in curly braces)": "(değerler süslü parantez içindeki makrolardır)",
  "Redirect field": "Yönlendirme alanı",
  "Success field (optional)": "Başarı alanı (isteğe bağlı)",
  "Success value (optional)": "Başarı değeri (isteğe bağlı)",
  "plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.": "artı tüm form alanları ve offer parametreleri. Yönlendirme alanı JSON yanıtındaki bir yoldur (örn. data.url); boş bırakılırsa yanıtta bulunan ilk http(s) bağlantısı kullanılır.",
  "Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.": "Partner/CRM'i burada bir kez yapılandırın, offer'lar ona başvursun. TrackBox / Tigloo hazır adaptördür; Custom API diğer tüm CRM'lerle uyumludur. Offer formlarından gelen lead'ler seçilen partnere iletilir.",
  "Affiliate routing (form offers)": "Affiliate yönlendirme (formlu offer'lar)",
  "Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.": "Bu offer'ı ağırlıklarla bir veya birden fazla partnere yönlendirin (split/rotasyon). Pasif partnerler atlanır (örn. koşullar belirlenmeden önce). Lead ağırlığa göre gider; reddedilirse bir sonraki partnere düşer.",
  "Telegram lead alerts": "Telegram lead bildirimleri",
  "(sent on EVERY submit — even test/error)": "(HER göndermede iletilir — test/hata dahil)",
  "Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.": "Formlu offer'larınızın topladığı her lead buraya düşer — kabul edilmiş, reddedilmiş ve test. Filtreleyin, CSV olarak dışa aktarın ve yeniden satın. Durumlar postback ve pull sync ile güncellenir.",
  "Hint": "İpucu",
  "Cycle language": "Dili değiştir",
  "Switch to {lang}": "{lang} diline geç",
  "Current language: {lang}": "Geçerli dil: {lang}",
  "Scroll to top": "Başa dön",
  "Something went wrong": "Bir şeyler ters gitti",
  "An unexpected error occurred.": "Beklenmedik bir hata oluştu.",
  "Reload page": "Sayfayı yenile",
  "My first campaign": "İlk kampanyam",
  "CPA Network": "CPA Ağı",
  "Main FB pixel": "Ana FB piksel",
  "zapier integration": "zapier entegrasyonu",
  "Bot token": "Bot token",
  "Chat ID": "Chat ID",
  "(no match)": "(eşleşme yok)",
  "+ Upload": "+ Yükle",
  "A custom conversion type with its own reporting rules and status transitions.": "Kendi raporlama kuralları ve durum geçişleri olan özel bir dönüşüm türü.",
  "A formula over base metrics rendered as a report column.": "Rapor sütunu olarak gösterilen temel metrikler üzerindeki formül.",
  "A/B testing": "A/B testi",
  "Add a manual cost, or connect an ad account to sync spend automatically.": "Manuel maliyet ekleyin veya harcamaları otomatik senkronize etmek için bir reklam hesabı bağlayın.",
  "Add cost": "Maliyet ekle",
  "Add from preset": "Önayardan ekle",
  "Add manual cost": "Manuel maliyet ekle",
  "Add partner route": "Partner rotası ekle",
  "Add range": "Aralık ekle",
  "Add value": "Değer ekle",
  "Added to blacklist": "Kara listeye eklendi",
  "Added to whitelist": "Beyaz listeye eklendi",
  "Adjust the period or campaign filter.": "Dönemi veya kampanya filtresini ayarlayın.",
  "Affiliate CRM — push leads via API": "Affiliate CRM — API üzerinden lead gönderimi",
  "Affiliate network postback": "Affiliate ağı postback",
  "All offers": "Tüm teklifler",
  "All rows": "Tüm satırlar",
  "Allowed next statuses": "İzin verilen sonraki durumlar",
  "Amount": "Tutar",
  "Any date": "Herhangi bir tarih",
  "Any status": "Herhangi bir durum",
  "Arithmetic over base metrics. Supported: + - * / ( ) and numbers.": "Temel metrikler üzerinde aritmetik işlemler. Desteklenenler: + - * / ( ) ve sayılar.",
  "Back to streams": "Akışlara geri dön",
  "Base metrics": "Temel metrikler",
  "Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.": "Takip linklerini gizlemek için kendi alan adınızı bağlayın. Takip sunucunuza bir A kaydı yönlendirin ve TXT kaydı ile sahipliği doğrulayın.",
  "Black": "Siyah",
  "Black / white lists": "Kara / beyaz listeler",
  "Blacklist": "Kara liste",
  "Blacklisted": "Kara listede",
  "Blank referrer (JS)": "Boş referrer (JS)",
  "Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.": "Kampanyaya harcama kaydedin. ROI ve panolar tarafından kullanılan kampanya maliyetine dahil edilir.",
  "Bot": "Bot",
  "Bot IP addresses": "Bot IP adresleri",
  "Bot User-Agent signatures": "Bot User-Agent imzaları",
  "Bot lists": "Bot listeleri",
  "Bot lists saved": "Bot listeleri kaydedildi",
  "Breakdown": "Döküm",
  "Bucket": "Bucket",
  "Built-in statuses": "Yerleşik durumlar",
  "By destination": "Hedefe göre",
  "By stream": "Akışa göre",
  "CPS (per sale)": "CPS (satış başına)",
  "CPuC (per unique click)": "CPuC (tekil tıklama başına)",
  "CRM": "CRM",
  "CRM response": "CRM yanıtı",
  "Cadence": "Kadans",
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Akışın aktif olduğu takvim tarihleri (hesap sahibi saat dilimi). Açık uçlu aralık için başlangıç veya bitiş boş bırakılabilir. 'Değil' seçeneği aralığı tersine çevirir.",
  "California, Bavaria, Moscow Oblast": "Kaliforniya, Bavyera, Moskova Oblastı",
  "Canonical status stored on each conversion. Auto-generated from the name if left blank.": "Her dönüşümde saklanan standart durum. Boş bırakılırsa isimden otomatik oluşturulur.",
  "Click API (server-to-server)": "Click API (server-to-server)",
  "Code (slug)": "Kod (slug)",
  "Column key in reports. Auto-generated from the name if left blank.": "Raporlardaki sütun anahtarı. Boş bırakılırsa isimden otomatik oluşturulur.",
  "Comma-separated email addresses.": "Virgülle ayrılmış e-posta adresleri.",
  "Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).": "Kaynak ile tracker arasında kaybedilen trafik maliyetini telafi eder: gerçek maliyet = taban / (1 − kayıp%/100).",
  "Configure any partner CRM lead API": "Herhangi bir partner CRM lead API'sini yapılandırın",
  "Conversion date": "Dönüşüm tarihi",
  "Conversion statuses": "Dönüşüm durumları",
  "Conversion type created": "Dönüşüm tipi oluşturuldu",
  "Conversion type deleted": "Dönüşüm tipi silindi",
  "Conversion type updated": "Dönüşüm tipi güncellendi",
  "Conversion types": "Dönüşüm tipleri",
  "Cookie (default)": "Cookie (varsayılan)",
  "Copy blacklist": "Kara listeyi kopyala",
  "Copy list": "Listeyi kopyala",
  "Copy whitelist": "Beyaz listeyi kopyala",
  "Cost entries": "Maliyet girişleri",
  "Cost entry added": "Maliyet girişi eklendi",
  "Cost entry deleted": "Maliyet girişi silindi",
  "Count conversions of this type toward the offer daily cap.": "Bu tipteki dönüşümleri offer günlük cap'ine dahil et.",
  "Counts against offer cap": "Offer cap'ine sayılır",
  "Counts in conversions": "Dönüşümlere sayılır",
  "Counts in revenue": "Gelire sayılır",
  "Counts vs cap": "Sayaç vs cap",
  "Create conversion type": "Dönüşüm tipi oluştur",
  "Create custom metric": "Özel metrik oluştur",
  "Create metric": "Metrik oluştur",
  "Create one like uCR = conversions / unique_clicks * 100.": "uCR = conversions / unique_clicks * 100 gibi bir metrik oluşturun.",
  "Create one to export campaign performance on demand.": "Kampanya performansını isteğe bağlı dışa aktarmak için bir tane oluşturun.",
  "Create one to map partner statuses like FTD or second deposit.": "FTD veya ikinci depozit gibi partner durumlarını eşleştirmek için bir tane oluşturun.",
  "Create one to receive recurring reports by email.": "E-posta ile düzenli rapor almak için bir tane oluşturun.",
  "Create type": "Tip oluştur",
  "Custom bot IPs/CIDRs and UA signatures for the bot-detection filter": "Bot tespiti filtresi için özel bot IP/CIDR'leri ve UA imzaları",
  "Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.": "Bot tespiti fraud filtresi tarafından kullanılan özel bot IP/CIDR'leri ve User-Agent imzaları.",
  "Custom conversion types: map network statuses, reporting flags and transition rules": "Özel dönüşüm tipleri: network durumlarını, raporlama bayraklarını ve geçiş kurallarını eşleştirin",
  "Custom metric created": "Özel metrik oluşturuldu",
  "Custom metric deleted": "Özel metrik silindi",
  "Custom metric updated": "Özel metrik güncellendi",
  "Custom metrics": "Özel metrikler",
  "DSAR erasure completed": "DSAR veri silme işlemi tamamlandı",
  "DSAR export ready": "DSAR dışa aktarımı hazır",
  "Daily": "Günlük",
  "Data subject": "Veri sahibi",
  "Data-subject access (Article 15) and erasure (Article 17) by identifier.": "Tanımlayıcıya göre veri sahibi erişimi (Madde 15) ve silme (Madde 17).",
  "Data-subject export (Art. 15) and erasure (Art. 17) by identifier": "Tanımlayıcıya göre veri sahibi dışa aktarımı (Mad. 15) ve silme (Mad. 17)",
  "Date": "Tarih",
  "Date range": "Tarih aralığı",
  "Day": "Gün",
  "Day of month (1-31)": "Ayın günü (1-31)",
  "Day of week": "Haftanın günü",
  "Decimals": "Ondalık basamaklar",
  "Define a reusable report and its grouping/metrics.": "Yeniden kullanılabilir bir rapor ile gruplama/metriklerini tanımlayın.",
  "Define custom conversion types, map network statuses and control reporting semantics.": "Özel dönüşüm türleri tanımlayın, ağ durumlarını eşleyin ve raporlama semantiğini kontrol edin.",
  "Define formula-based report columns over base metrics (CR, EPC, ROI variants).": "Temel metrikler üzerinde formül tabanlı rapor sütunları tanımlayın (CR, EPC, ROI varyantları).",
  "Delete conversion type": "Dönüşüm türünü sil",
  "Delete cost entry": "Maliyet girişini sil",
  "Delete custom metric": "Özel metriği sil",
  "Delete file": "Dosyayı sil",
  "Delete report": "Raporu sil",
  "Delete schedule": "Zamanlamayı sil",
  "Delete this file?": "Bu dosya silinsin mi?",
  "Desktop, Mobile, Tablet": "Desktop, Mobile, Tablet",
  "Destination": "Hedef",
  "Distribution": "Dağılım",
  "Double meta (hide referrer)": "Çift meta (referrer gizle)",
  "Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.": "Akış mantığını ve filtreleri test etmek için bu kampanya üzerinden test tıklamaları çalıştırın — gerçek trafik kaydedilmez.",
  "EPC (sensitive)": "EPC (hassas)",
  "Edge server updated": "Edge sunucu güncellendi",
  "Edit conversion type": "Dönüşüm türünü düzenle",
  "Edit custom metric": "Özel metriği düzenle",
  "Enter a valid amount": "Geçerli bir tutar girin",
  "Enter at least one identifier": "En az bir tanımlayıcı girin",
  "Enter bot token and chat id": "Bot token ve chat id girin",
  "Enter the text to find": "Aranacak metni girin",
  "Equalize weights": "Ağırlıkları eşitle",
  "Erase": "Sil",
  "Erase data": "Verileri sil",
  "Erase subject data?": "Veri sahibinin verileri silinsin mi?",
  "Erased": "Silindi",
  "Erasure is a hard delete and cannot be undone. It requires an admin role.": "Silme işlemi kalıcıdır ve geri alınamaz. Yönetici rolü gerektirir.",
  "Error creating conversion type": "Dönüşüm türü oluşturulurken hata",
  "Error creating cost entry": "Maliyet girişi oluşturulurken hata",
  "Error creating custom metric": "Özel metrik oluşturulurken hata",
  "Error creating report": "Rapor oluşturulurken hata",
  "Error creating schedule": "Zamanlama oluşturulurken hata",
  "Error deleting conversion type": "Dönüşüm türü silinirken hata oluştu",
  "Error deleting cost entry": "Maliyet girişi silinirken hata oluştu",
  "Error deleting custom metric": "Özel metrik silinirken hata oluştu",
  "Error deleting file": "Dosya silinirken hata oluştu",
  "Error deleting report": "Rapor silinirken hata oluştu",
  "Error deleting schedule": "Zamanlama silinirken hata oluştu",
  "Error loading bot lists": "Bot listeleri yüklenirken hata oluştu",
  "Error loading conversion types": "Dönüşüm türleri yüklenirken hata oluştu",
  "Error loading cost entries": "Maliyet girişleri yüklenirken hata oluştu",
  "Error loading custom metrics": "Özel metrikler yüklenirken hata oluştu",
  "Error loading reports": "Raporlar yüklenirken hata oluştu",
  "Error loading scheduled reports": "Zamanlanmış raporlar yüklenirken hata oluştu",
  "Error saving bot lists": "Bot listeleri kaydedilirken hata oluştu",
  "Error updating conversion type": "Dönüşüm türü güncellenirken hata oluştu",
  "Error updating custom metric": "Özel metrik güncellenirken hata oluştu",
  "Error uploading file": "Dosya yüklenirken hata oluştu",
  "Every submitted lead is stored here: filter, export (CSV) and resell": "Gönderilen her lead burada saklanır: filtreleyin, dışa aktarın (CSV) ve yeniden satın",
  "Export data": "Veriyi dışa aktar",
  "Export flows": "Akışları dışa aktar",
  "Exported": "Dışa aktarıldı",
  "Failed to clone stream": "Akış klonlanamadı",
  "Failed to equalize weights": "Ağırlıklar eşitlenemedi",
  "Failed to erase DSAR": "DSAR silinemedi",
  "Failed to export DSAR": "DSAR dışa aktarılamadı",
  "Failed to export flows": "Akışlar dışa aktarılamadı",
  "Failed to export list": "Liste dışa aktarılamadı",
  "Failed to export report": "Rapor dışa aktarılamadı",
  "Failed to import flows": "Akışlar içe aktarılamadı",
  "Failed to insert flow": "Akış eklenemedi",
  "Failed to load leads": "Lead'ler yüklenemedi",
  "Failed to remove": "Kaldırılamadı",
  "Failed to replace URLs": "URL'ler değiştirilemedi",
  "Failed to run report": "Rapor çalıştırılamadı",
  "Failed to update": "Güncellenemedi",
  "Failed to update list": "Liste güncellenemedi",
  "Failed to update schedule": "Zamanlama güncellenemedi",
  "Favourite": "Favori",
  "Favourite flows": "Favori akışlar",
  "Favourites": "Favoriler",
  "Fetched": "Alındı",
  "File deleted": "Dosya silindi",
  "File uploaded": "Dosya yüklendi",
  "Filter rule": "Filtre kuralı",
  "Find": "Bul",
  "Find and replace a substring in flow redirect URLs (never landing/offer URLs).": "Akış yönlendirme URL'lerindeki bir alt dizeyi bulun ve değiştirin (landing page/offer URL'leri dahil değil).",
  "Fire on statuses": "Durumlarda tetikle",
  "First 25 simulated clicks and how each was routed.": "İlk 25 simüle edilmiş tıklama ve her birinin nasıl yönlendirildiği.",
  "Flag clicks that arrive with no User-Agent header.": "User-Agent başlığı olmadan gelen tıklamaları işaretle.",
  "Flow tools": "Akış araçları",
  "Form submit (POST)": "Form gönderimi (POST)",
  "Format": "Format",
  "Formula": "Formül",
  "Formula is required": "Formül zorunludur",
  "Formula-based report columns over base metrics (CR, EPC, ROI variants)": "Temel metrikler üzerinden formül tabanlı rapor sütunları (CR, EPC, ROI varyantları)",
  "Friday": "Cuma",
  "From": "Kimden",
  "GDPR / DSAR": "GDPR / DSAR",
  "Group by": "Gruplandır",
  "Has label": "Etiketi var",
  "Headless click registration and the JS adapter for landing pages.": "Headless tıklama kaydı ve landing page'ler için JS adaptörü.",
  "Hour": "Saat",
  "Hour (0-23)": "Saat (0-23)",
  "How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.": "Tekil tıklama tespiti için geri dönen ziyaretçiler nasıl tanımlanır: Cookie (varsayılan), IP, IP+UA veya Parametre — GET parametresiyle tanımlama (örn. external_id), böylece aynı kullanıcı IP/cookie değişikliklerinde de tanınır.",
  "IP + User-Agent": "IP + User-Agent",
  "IP of your tracking server": "Tracking sunucunuzun IP'si",
  "IPs": "IP'ler",
  "ISP / carrier": "ISP / operatör",
  "Import flows": "Akışları içe aktar",
  "Imported": "İçe aktarıldı",
  "In conversions": "Dönüşümlerde",
  "In revenue": "Gelirde",
  "Include this type in the conversions column.": "Bu türü dönüşümler sütununa dahil et.",
  "Include this type in the revenue column.": "Bu türü gelir sütununa dahil et.",
  "Insert": "Ekle",
  "Integration": "Entegrasyon",
  "JS adapter snippet": "JS adaptör kodu parçacığı",
  "Key (e.g. price)": "Anahtar (örn. price)",
  "Key metrics over time buckets. Toggle to attribute conversions to their arrival date.": "Zaman dilimlerine göre temel metrikler. Dönüşümleri geliş tarihine göre ilişkilendirmek için değiştir.",
  "Keys": "Anahtarlar",
  "Label color": "Etiket rengi",
  "Last run": "Son çalışma",
  "Lead export failed": "Lead dışa aktarımı başarısız oldu",
  "Lead storage": "Lead depolama",
  "Leads": "Lead'ler",
  "Leads exported": "Lead'ler dışa aktarıldı",
  "Leave empty to count every conversion.": "Her dönüşümü saymak için boş bırakın.",
  "Leave the period blank to record spend as of now.": "Harcamayı şu andan itibaren kaydetmek için dönemi boş bırakın.",
  "Lists": "Listeler",
  "Manager": "Yönetici",
  "Manual": "Manuel",
  "Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.": "Reklam hesabı senkronizasyonunun göremediği kampanya harcamalarını manuel olarak kaydedin — sabit ücretler, çevrimdışı medya, düzeltmeler.",
  "Manually record campaign spend — flat fees, offline media, corrections": "Kampanya harcamalarını manuel kaydet — sabit ücretler, çevrimdışı medya, düzeltmeler",
  "Marked values are reusable as report filters and copyable for ad networks.": "İşaretli değerler rapor filtresi olarak yeniden kullanılabilir ve reklam ağları için kopyalanabilir.",
  "Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.": "Webview / uygulama içi tarayıcı tespiti için X-Requested-With başlığını eşleştirin. Alt dize eşleşmesi — örn. com.android, Android webview'larını hedefler; @empty, başlığı olmayan tıklamaları hedefler.",
  "Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.": "se / se_referrer parametrelerinden veya referrer host'undan türetilen arama motorunu eşleştirin — örn. google, bing, yandex.",
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": "Ziyaretçinin ISP / ASN kuruluş adını eşleştirin (çevrimdışı IP-intel tablosundan). Maske, /regex/ ve @empty desteklenir — örn. AMAZON*, *Comcast*.",
  "Matched": "Eşleşti",
  "Metrics": "Metrikler",
  "Metrics over time buckets (hour/day/weekday/month) + conversion-date view": "Zaman dilimlerine göre metrikler (saat/gün/haftanın günü/ay) + dönüşüm tarihine göre görünüm",
  "Monday": "Pazartesi",
  "Monthly": "Aylık",
  "Moscow, New York": "Moskova, New York",
  "Moscow, New York, London": "Moskova, New York, Londra",
  "Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.": "Landing page/offer/postback URL'lerine {offer_value:NAME} makrosu aracılığıyla eklenen adlandırılmış anahtar/değer çiftleri.",
  "Network preset…": "Ağ ön ayarı…",
  "Network status values": "Ağ durum değerleri",
  "New report": "Yeni rapor",
  "New saved report": "Yeni kayıtlı rapor",
  "New schedule": "Yeni zamanlama",
  "New scheduled report": "Yeni zamanlanmış rapor",
  "No cost entries yet": "Henüz maliyet girişi yok",
  "No custom conversion types yet": "Henüz özel dönüşüm türü yok",
  "No custom metrics yet": "Henüz özel metrik yok",
  "No data for this period": "Bu dönem için veri yok",
  "No favourite flows yet. Star a flow to reuse it here.": "Henüz favori akış yok. Burada yeniden kullanmak için bir akışı yıldızlayın.",
  "No label": "Etiket yok",
  "No leads yet": "Henüz lead yok",
  "No list entries yet. Use the thumbs buttons on report rows.": "Henüz liste girişi yok. Rapor satırlarındaki beğeni düğmelerini kullanın.",
  "No match": "Eşleşme yok",
  "No offer values. Add a key like price, then use {offer_value:price} in URLs.": "Offer değeri yok. price gibi bir anahtar ekleyin, ardından URL'lerde {offer_value:price} kullanın.",
  "No partner routes — this is a plain redirect/upload offer.": "Partner rotası yok — bu düz bir yönlendirme/yükleme offer'ıdır.",
  "No recipients set": "Alıcı ayarlanmamış",
  "No saved reports yet": "Henüz kayıtlı rapor yok",
  "No scheduled reports yet": "Henüz zamanlanmış rapor yok",
  "No status values added": "Durum değeri eklenmemiş",
  "Not accepted": "Kabul edilmedi",
  "Note": "Not",
  "Offer": "Offer",
  "Offer values": "Offer değerleri",
  "One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).": "Satır başına bir IP adresi veya CIDR bloğu (örn. 203.0.113.7 veya 10.0.0.0/8).",
  "One per line: substring, mask (*) or /regex/.": "Satır başına bir: alt dize, maske (*) veya /regex/.",
  "One value per line (or comma-separated). Each simulated query samples one value from each list.": "Satır başına bir değer (veya virgülle ayrılmış). Her simüle edilen sorgu, her listeden bir değer örnekler.",
  "Only these conversion statuses are sent to the ad platform. Default: sale.": "Yalnızca bu dönüşüm durumları reklam platformuna gönderilir. Varsayılan: sale.",
  "Open Domains": "Açık Domainler",
  "Overrides": "Geçersiz Kılmalar",
  "Owner": "Sahip",
  "POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.": "POST /v1/click ile API anahtarı (yazma kapsamı). Tarayıcı yönlendirmesi olmadan yönlendirme kararını döndürür.",
  "Parameter name, e.g. external_id": "Parametre adı, örn. external_id",
  "Parameters": "Parametreler",
  "Paste on a landing page to auto-append the click id and forward the visitor.": "Click ID'yi otomatik eklemek ve ziyaretçiyi yönlendirmek için landing page'e yapıştırın.",
  "Per-query trace": "Sorgu başına iz",
  "Period": "Dönem",
  "Period end": "Dönem sonu",
  "Period start": "Dönem başlangıcı",
  "Phone": "Telefon",
  "Pick a report, cadence and recipients.": "Bir rapor, sıklık ve alıcılar seçin.",
  "Postback added from preset": "Postback önayardan eklendi",
  "Postback macro": "Postback makrosu",
  "Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.": "En az bir tanımlayıcı girin. Erişilebilir tüm workspace'lerinizdeki eşleşen tıklamalar ve dönüşümler etkilenir.",
  "Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.": "TrackBox'tan lead durumlarını ve depozitoları çekin (son 7 gün) ve kayıtlı lead'leri güncelleyin. Önce entegrasyonda Pull x-api-key ayarını yapın.",
  "Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.": "Entegrasyonda belirlenen gün sayısı için OpenAFF'tan lead durumlarını çekin ve kayıtlı lead'leri güncelleyin. Önce entegrasyonda durum API token'ını ayarlayın.",
  "Pull sync": "Pull senkronizasyonu",
  "Pull sync (statuses/deposits)": "Pull senkronizasyonu (durumlar/depozitolar)",
  "Pull sync done": "Pull senkronizasyonu tamamlandı",
  "Queries": "Sorgular",
  "ROI %": "ROI %",
  "ROI (sensitive)": "ROI (hassas)",
  "Raw status strings partner networks send that should map to this type (case-insensitive).": "Partner ağlarının gönderdiği ve bu türe eşlenmesi gereken ham durum dizeleri (büyük/küçük harf duyarsız).",
  "Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.": "TRASH olarak işlenecek ham durumlar (kaydedilir ancak ödemelerden hariç tutulur). Örn. trash, invalid.",
  "Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.": "DEPOSIT olarak işlenecek ham durumlar (birincil dönüşüm türü). Örn. dep, ftd, deposit.",
  "Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.": "REGISTRATION olarak işlenecek ham durumlar (birincil dönüşüm türü). Örn. reg, signup.",
  "Read-only — only the workspace owner can edit the matrix": "Salt okunur — matrisi yalnızca workspace sahibi düzenleyebilir",
  "Recipients": "Alıcılar",
  "Recurring reports emailed on a daily/weekly/monthly cadence": "Günlük/haftalık/aylık sıklıkta e-posta ile gönderilen periyodik raporlar",
  "Recurring reports emailed to recipients on a daily/weekly/monthly cadence.": "Günlük/haftalık/aylık sıklıkta alıcılara e-posta ile gönderilen periyodik raporlar.",
  "Removed": "Kaldırıldı",
  "Replace": "Değiştir",
  "Replace URL": "URL'yi Değiştir",
  "Replace with": "Şununla değiştir",
  "Report deleted": "Rapor silindi",
  "Report queued": "Rapor kuyruğa alındı",
  "Report saved": "Rapor kaydedildi",
  "Report type": "Rapor türü",
  "Request": "İstek",
  "Response sample": "Örnek yanıt",
  "Reusable partner networks: postback, offer params, inbound URL": "Yeniden kullanılabilir partner ağları: postback, teklif parametreleri, gelen URL",
  "Reusable report definitions you can export to CSV or XLSX on demand.": "İsteğe bağlı CSV veya XLSX olarak dışa aktarabileceğiniz yeniden kullanılabilir rapor tanımları.",
  "Reusable report definitions, exportable to CSV/XLSX on demand": "Yeniden kullanılabilir rapor tanımları, isteğe bağlı CSV/XLSX olarak dışa aktarılabilir",
  "RevShare (% of payout)": "RevShare (ödemenin %'si)",
  "Revenue (sensitive)": "Gelir (hassas)",
  "Routing record (A record)": "Yönlendirme kaydı (A kaydı)",
  "Run now": "Şimdi çalıştır",
  "Run pull sync": "Pull senkronizasyonunu çalıştır",
  "Run simulation": "Simülasyonu çalıştır",
  "Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.": "Son 7 günlük kayan senkronizasyonu çalıştırır. Otomatik pull-sync'i etkinleştirmeden önce yanıtı doğrulamak için kullanın.",
  "Sample datasets": "Örnek veri setleri",
  "Saturday": "Cumartesi",
  "Saved reports": "Kaydedilen raporlar",
  "Schedule created": "Zamanlama oluşturuldu",
  "Schedule deleted": "Zamanlama silindi",
  "Scheduled reports": "Zamanlanmış raporlar",
  "Search conversion types": "Dönüşüm türlerini ara",
  "Search custom metrics": "Özel metrikleri ara",
  "Search engines": "Arama motorları",
  "Search presets": "Ön ayarları ara",
  "Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.": "CRM'e sentetik bir lead gönderin ve yanıtı inceleyin. Aşağıda geçersiz kılmadığınız sürece tek kullanımlık bir e-posta/telefon kullanılır.",
  "Send test lead": "Test lead'i gönder",
  "Set another entry page first": "Önce başka bir giriş sayfası belirleyin",
  "Show shortcuts": "Kısayolları göster",
  "Simulate": "Simüle et",
  "Simulating…": "Simüle ediliyor…",
  "Simulation failed": "Simülasyon başarısız oldu",
  "Source": "Kaynak",
  "Starred flows from any campaign. Insert a copy into this campaign.": "Herhangi bir kampanyadan yıldızlanmış akışlar. Bu kampanyaya bir kopyasını ekleyin.",
  "Stored form leads: name/email/phone/geo/status, filter + CSV export for resale": "Kaydedilen form lead'leri: ad/e-posta/telefon/GEO/durum, filtre + yeniden satış için CSV dışa aktarma",
  "Stream cloned": "Akış klonlandı",
  "Streams changed": "Akışlar değiştirildi",
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": "Akışlar, her ziyaretçinin hangi teklife yönlendirileceğine karar verir. Varsayılan akışı yapılandırın; çalışan bir takip bağlantısına sahip olursunuz.",
  "Submitted leads from your offer forms will appear here.": "Teklif formlarınızdan gönderilen lead'ler burada görünecek.",
  "Sunday": "Pazar",
  "Synced": "Senkronize edildi",
  "Telegram postbacks added — press Save to apply": "Telegram postback'leri eklendi — uygulamak için Kaydet'e basın",
  "Google Ads postbacks added — press Save to apply": "Google Ads postback'leri eklendi — uygulamak için Kaydet'e basın",
  "Google Ads preset applied — press Save to apply": "Google Ads ön ayarı uygulandı — uygulamak için Kaydet'e basın",
  "Also add the standard Google Ads parameters (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) as defaults": "Standart Google Ads parametrelerini de (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) varsayılan olarak ekle",
  "Google Ads postbacks added + click-time gtag turned off — press Save to apply": "Google Ads postback'leri eklendi + tıklama anındaki gtag kapatıldı — uygulamak için Kaydet'e basın",
  "Adding these also turns OFF the click-time gtag (fire on redirect) for this campaign, so the same Google conversion is not counted twice.": "Bunları eklemek, bu kampanya için tıklama anındaki gtag'i (yönlendirmede tetiklenen) de KAPATIYOR; böylece aynı Google dönüşümü iki kez sayılmıyor.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "Takip parametreleri (campaignid, adgroupid, keyword, tm, tml, sub1–3) Google Ads trafik kaynağında bir kez tanımlanır — bunları bir kampanyaya eklemek için \"Kaynaktan içe aktar\" seçeneğini kullanın.",
  "Google Ads conversions": "Google Ads dönüşümleri",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Yalnızca giden: bu HTTP çağrıları, XPNSR bir dönüşüm kaydettikten sonra başka bir sistemi bilgilendirir. Affiliate ağı ön ayarları ve gelen URL'ler Affiliate ağları sayfasına aittir ve partner paneline yapıştırılmalıdır — bunlar yönlendirme kuralları değildir.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Gelen partner kurulumu: click ID teklif parametreleri, durum eşleştirmesi ve partner paneline yapıştırılacak postback URL'si. Bu, CRM'e lead göndermez ve kampanya S2S yönlendirmesi değildir.",
  "Inbound postback URL template": "Gelen postback URL şablonu",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "Partner ağının lead, satış, red veya başka bir durum bildirirken çağırdığı gelen URL. Bunu partner paneline kopyalayın; XPNSR bu URL'yi giden kampanya postback'i olarak çağırmaz.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Hazır bir gelen postback şablonu seçin ya da partner sözleşmesini sıfırdan yapılandırın. Formdan CRM'e lead iletimi için bunun yerine bir Entegrasyon oluşturun ve teklife bağlayın.",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Google Ads depozit postback'i eklendi + tıklama anındaki gtag kapalı tutuldu — uygulamak için Kaydet'e basın",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Eski tıklama anı dönüşümü: kayıt veya depozit gerçekleşmeden önce /r/ üzerinde tetiklenir. Lead/depozit optimizasyonu için bunu devre dışı bırakın. Gerçek lead'ler, başarılı bir /api/lead yanıtının ardından barındırılan landing page'lerden otomatik olarak gönderilir.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Gerçek dönüşüm optimizasyonu için bunu KAPALI tutun. Lead'ler, yalnızca /api/lead başarılı olduktan sonra barındırılan landing page'den online olarak iletilir; depozitler aşağıda broker satış postback'i üzerinden S2S ile yönlendirilebilir. Bunu etkinleştirmek Google'ın tıklamalar üzerinden optimize etmesine yol açar ve dönüşümlerin çift sayılmasına neden olabilir.",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Yalnızca depozit/Purchase S2S postback'i ekler. Broker satış postback'inde tetiklenir ve Google tıklamasını {gclid} ile eşleştirir. Hesap ID'si ve depozit etiketi, reklamın Final URL son ekindeki tıklama başına {tm} etiketinden (AW-<account>/<deposit-label>) alınır.",
  "Deposit → Purchase (with payout value) — fires on sale": "Depozit → Purchase (ödeme değeriyle birlikte) — satışta tetiklenir",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "Lead S2S kasıtlı olarak eklenmez: barındırılan landing page, CRM /api/lead'i kabul ettikten sonra Lead dönüşümünü istemci tarafı gtag aracılığıyla zaten online olarak gönderir. Lead için S2S kuralı eklemek aynı lead'in çift sayılması riskini doğurur.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Online lead'ler için her reklam hesabının Final URL son ekine tml=AW-<account>/<lead-label> parametresini ekleyin. \"Yönlendirmede Google Ads gtag'ini tetikle\" seçeneğini KAPALI tutun: tracker, barındırılan landing page'lere ayrı bir lead gtag'i enjekte eder ve bunu yalnızca başarılı bir lead gönderimi sonrasında tetikler. Lead'ler üzerinden teklif verirken Lead'i Primary olarak ayarlayın; depozit raporlaması doğrulanana kadar Purchase'ı secondary tutun, ardından hedefleri teklif stratejinize göre düzenleyin.",
  "Sends the Google Ads conversion server-side on the broker postback, matched by {gclid} — no gtag on the landing and no API. Account id and label are read from the {tm} tag (AW-<account>/<label>) you already put in the ad Final URL suffix.": "Google Ads dönüşümünü broker postback'inde sunucu tarafında gönderir, {gclid} ile eşleştirilir — landing page'de gtag veya API gerekmez. Hesap ID'si ve etiket, reklam Final URL son ekine zaten eklediğiniz {tm} etiketinden (AW-<account>/<label>) okunur.",
  "Deposit → Purchase (primary, with value) — fires on sale": "Depozit → Purchase (primary, değerle birlikte) — satışta tetiklenir",
  "Registration → Lead (secondary) — fires on lead": "Kayıt → Lead (secondary) — lead'de tetiklenir",
  "For the Lead tag add its label to the ad Final URL suffix as tml=<label> (same AW account). If tml is empty the Lead beacon is skipped automatically. Keep Lead as Secondary in Google so optimization stays on deposits.": "Lead etiketi için, etiketini reklam Final URL son ekine tml=<label> olarak ekleyin (aynı AW hesabı). tml boşsa Lead beacon'ı otomatik olarak atlanır. Optimizasyonun depozitler üzerinde kalması için Google'da Lead'i Secondary olarak tutun.",
  "Test integration": "Entegrasyonu test et",
  "Test lead accepted": "Test lead'i kabul edildi",
  "Test lead not accepted": "Test lead'i kabul edilmedi",
  "This permanently deletes all matching clicks and conversions. This cannot be undone.": "Bu işlem eşleşen tüm tıklamaları ve dönüşümleri kalıcı olarak siler. Bu işlem geri alınamaz.",
  "This permanently deletes the conversion type. Existing conversions keep their stored status.": "Bu işlem dönüşüm türünü kalıcı olarak siler. Mevcut dönüşümler kayıtlı durumlarını korur.",
  "This permanently deletes the metric column from reports.": "Bu işlem metrik sütununu raporlardan kalıcı olarak siler.",
  "This permanently deletes the saved report definition.": "Bu işlem kaydedilmiş rapor tanımını kalıcı olarak siler.",
  "This permanently deletes the scheduled report.": "Bu işlem zamanlanmış raporu kalıcı olarak siler.",
  "This removes the manual cost and reverses its contribution to the campaign spend.": "Bu işlem manuel maliyeti kaldırır ve kampanya harcamasına olan katkısını geri alır.",
  "Thursday": "Perşembe",
  "To": "Kime",
  "Total leads": "Toplam lead",
  "Tracking domains are managed on the Domains page — add and verify a custom domain there.": "Takip domainleri, Domainler sayfasında yönetilir — özel bir domain ekleyip doğrulamak için oraya gidin.",
  "Traffic Simulation": "Trafik Simülasyonu",
  "Traffic loss %": "Trafik kaybı %",
  "Traffic trends": "Trafik trendleri",
  "Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.": "Geçiş kuralları: bu türdeki bir dönüşümün geçebileceği durumlar. Herhangi bir geçişe izin vermek için tümünü işaretsiz bırakın.",
  "Treat empty User-Agent as bot": "Boş User-Agent'ı bot olarak değerlendir",
  "Trends": "Trendler",
  "Tuesday": "Salı",
  "US, CA, GB": "US, CA, GB",
  "US, CA, GB, RU": "US, CA, GB, RU",
  "US, GB, DE": "US, GB, DE",
  "US,RU,DE": "US,RU,DE",
  "Uniqueness method": "Teklik yöntemi",
  "Update reporting semantics and status transitions.": "Raporlama semantiğini ve durum geçişlerini güncelle.",
  "Update the formula, format or decimals.": "Formülü, formatı veya ondalık basamak sayısını güncelle.",
  "Use a negative amount to book a correction.": "Düzeltme kaydetmek için negatif bir tutar kullanın.",
  "Viewer": "Görüntüleyici",
  "Visitor ID": "Ziyaretçi ID",
  "Wednesday": "Çarşamba",
  "Weekly": "Haftalık",
  "Weights equalized": "Ağırlıklar eşitlendi",
  "White": "Beyaz",
  "Whitelist": "Whitelist",
  "Whitelisted": "Whitelist'te",
  "X-Requested-With": "X-Requested-With",
  "analyst": "analist",
  "box/goal id": "box/goal id",
  "buy, cheap, discount": "satın al, ucuz, indirim",
  "cpa, nutra, en": "cpa, nutra, en",
  "day": "gün",
  "days": "gün",
  "e.g. Q3 influencer flat fee": "örn. Q3 influencer sabit ücret",
  "e.g. Second deposit": "örn. İkinci depozit",
  "e.g. Unique CR": "örn. Unique CR",
  "e.g. Weekly digest": "örn. Haftalık özet",
  "e.g. Weekly performance": "örn. Haftalık performans",
  "email / phone / name": "email / telefon / isim",
  "free, demo": "ücretsiz, demo",
  "redirect": "redirect",
  "statuses on schedule": "programa göre durumlar",
  "Remove variant": "Varyantı kaldır",
  "Start test": "Testi başlat",
  "Pause test": "Testi duraklat",
  "View test results": "Test sonuçlarını görüntüle",
  "Remove parameter": "Parametreyi kaldır",
  "Remove status mapping": "Durum eşlemesini kaldır",
  "Copy postback URL template": "Postback URL şablonunu kopyala",
  "Copy inbound postback URL": "Gelen postback URL'sini kopyala",
  "Remove IP from blacklist": "IP'yi kara listeden kaldır",
  "Remove IP from whitelist": "IP'yi beyaz listeden kaldır",
  "Copy curl command": "Curl komutunu kopyala",
  "Copy JS snippet": "JS snippet'ini kopyala",
  "Copy snippet": "Kod parçacığını kopyala",
  "Remove postback": "Postback'i kaldır",
  "Campaign actions": "Kampanya işlemleri",
  "Remove vendor": "Satıcıyı kaldır",
  "Remove campaign": "Kampanyayı kaldır",
  "Remove value": "Değeri kaldır",
  "Remove field": "Alanı kaldır",
  "Copy webhook URL": "Webhook URL'sini kopyala",
  "Copy landing page URL": "Landing page URL'sini kopyala",
  "Open landing page": "Landing page'i aç",
  "Remove partner route": "Partner rotasını kaldır",
  "Copy lead-form URL": "Lead form URL'sini kopyala",
  "Copy offer URL": "Teklif URL'sini kopyala",
  "Delete list entry": "Liste girişini sil",
  "Copy secret": "Secret'ı kopyala",
  "Remove time range": "Zaman aralığını kaldır",
  "Remove date range": "Tarih aralığını kaldır",
  "Pause stream": "Akışı duraklat",
  "Resume stream": "Akışı devam ettir",
  "Open redirect URL": "Yönlendirme URL'sini aç",
  "Open offer URL": "Teklif URL'sini aç",
  "Copy postback URL": "Postback URL'sini kopyala",
  "Delete rule": "Kuralı sil",
  "Delete filter": "Filtreyi sil",
  "Delete traffic rule": "Trafik kuralını sil",
  "This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.": "Bu işlem trafik kuralını kalıcı olarak siler. Trafik, kalan kurallara veya kampanya varsayılanına yönlendirilir.",
  "Delete fraud filter": "Fraud filtresini sil",
  "This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.": "Bu işlem fraud filtresini kalıcı olarak siler. Şu anda engellediği veya puanladığı trafik artık bu kural tarafından değerlendirilmez.",
  "Action (no page — hand off to the offer)": "Action (sayfa yok — doğrudan teklife yönlendir)",
  "After click (at redirect)": "Tıklama sonrası (yönlendirmede)",
  "Before click (at landing — enables offer macros)": "Tıklama öncesi (landing page'de — teklif makrolarını etkinleştirir)",
  "Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.": "Mobil operatörü edge X-Carrier başlığından eşleştir. Maskeler, /regex/ ve @empty desteklenir — örn. Vodafone*, /^T-Mobile/.",
  "Mobile operator / carrier": "Mobil operatör / carrier",
  "Offer selection moment": "Teklif seçim anı",
  "Preload (serve the page from the tracker domain)": "Preload (sayfayı tracker alan adından sun)",
  "Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.": "Preload, sayfayı sunucu tarafında çeker ve tracker alan adınız altında sunar; Action hiçbir şey göstermez ve akışın bir teklif seçmesine izin verir.",
  "QR code": "QR kodu",
  "Redirect (send visitor to the URL)": "Redirect (ziyaretçiyi URL'ye gönder)",
  "Remote rotator (fetch target)": "Uzak rotator (hedefi çeker)",
  "Scan to open the tracking link on a device.": "Takip bağlantısını bir cihazda açmak için tarayın.",
  "Transparent (server-side fetch)": "Şeffaf (sunucu tarafı çekme)",
  "When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.": "Bu akış için teklifin ne zaman seçileceği. Sonra (varsayılan): yönlendirme anında. Önce: landing page sunulma anında; böylece {offer_name} / {offer_value:*} makroları landing page üzerinde işlenir.",
  "Added to favourites": "Favorilere eklendi",
  "Credentials and settings for this partner. Fields marked * are required.": "Bu partnere ait kimlik bilgileri ve ayarlar. * ile işaretli alanlar zorunludur.",
  "Key created": "Anahtar oluşturuldu",
  "Removed from favourites": "Favorilerden kaldırıldı",
  "Affiliate network archived": "Affiliate ağı arşivlendi",
  "Archive affiliate network": "Affiliate ağını arşivle",
  "Archive landing page": "Landing page'i arşivle",
  "Archive offer": "Teklifi arşivle",
  "Archive stream": "Akışı arşivle",
  "Archive traffic source": "Trafik kaynağını arşivle",
  "Archived at": "Arşivlenme tarihi",
  "Archived items are hidden from your lists. Restore them or delete them permanently.": "Arşivlenen öğeler listelerinizde gizlenir. Bunları geri yükleyin veya kalıcı olarak silin.",
  "Delete permanently": "Kalıcı olarak sil",
  "Deleted permanently": "Kalıcı olarak silindi",
  "Error loading archive": "Arşiv yüklenirken hata oluştu",
  "Error restoring": "Geri yükleme hatası",
  "Landing page archived": "Landing page arşivlendi",
  "No archived items": "Arşivlenmiş öğe yok",
  "Offer archived": "Teklif arşivlendi",
  "Restored": "Geri yüklendi",
  "Stream archived": "Akış arşivlendi",
  "This will move \"{name}\" to the archive. You can restore it or delete it permanently from the Archive page.": "Bu işlem \"{name}\" öğesini arşive taşıyacak. Arşiv sayfasından geri yükleyebilir veya kalıcı olarak silebilirsiniz.",
  "This will permanently delete \"{name}\". This action cannot be undone.": "Bu işlem \"{name}\" öğesini kalıcı olarak silecek. Bu işlem geri alınamaz.",
  "Traffic source archived": "Trafik kaynağı arşivlendi",
  "View archived": "Arşivlenenleri görüntüle",
  "Start date is required": "Başlangıç tarihi zorunludur",
  "Enter a valid cost": "Geçerli bir maliyet girin",
  "Updated {n} clicks": "{n} tıklama güncellendi",
  "Failed to update costs": "Maliyetler güncellenemedi",
  "Statistics deleted": "İstatistikler silindi",
  "Failed to delete statistics": "İstatistikler silinemedi",
  "Maintenance & costs": "Bakım ve maliyetler",
  "Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.": "Tıklama maliyetlerini geriye dönük olarak yeniden yazın, istatistikleri sıfırlayın veya alternatif bir takip bağlantısı alın.",
  "Update costs": "Maliyetleri güncelle",
  "Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.": "Belirli bir zaman aralığındaki tıklamalar için tıklama başı maliyeti geriye dönük olarak (yeniden) yazın. Toplam modu tutarı eşleşen tıklamalara dağıtır; tıklama başı modu her birine ayrı ayrı uygular.",
  "Start date": "Başlangıç tarihi",
  "End date": "Bitiş tarihi",
  "Total (spread across clicks)": "Toplam (klikler arasında dağıtılmış)",
  "Per click": "Klik başına",
  "Only unique clicks": "Yalnızca tekil klikler",
  "Skip bot clicks": "Bot klikleri atla",
  "Clean statistics": "İstatistikleri temizle",
  "Alternative link prefixes": "Alternatif link önekleri",
  "Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.": "Bu yol öneklerinin her biri aynı tracking ID'ye yönlendirir — kara listelerden kaçınmak için bunları kaynaklar arasında döndürün.",
  "Delete statistics": "İstatistikleri sil",
  "This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.": "Bu işlem, kampanyaya ait tüm klik ve dönüşümleri kalıcı olarak siler. Kampanya yapılandırması korunur. Bu işlem geri alınamaz.",
  "Error loading S2S log": "S2S log yüklenirken hata oluştu",
  "S2S postback log": "S2S postback log",
  "Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.": "Tüm kampanyalarınızdan gönderilen her dönüşüm postback'i — kampanya, durum veya sonuca göre filtreleyin.",
  "Any result": "Herhangi bir sonuç",
  "Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.": "Kampanyalarınız dönüşüm iletmeye başladığında gönderilen postback'ler burada görünecektir.",
  "Result": "Sonuç",
  "HTTP": "HTTP",
  "Error loading system status": "Sistem durumu yüklenirken hata oluştu",
  "Paste the Tor exit list first": "Önce Tor çıkış listesini yapıştırın",
  "Tor exit list updated": "Tor çıkış listesi güncellendi",
  "Failed to update Tor exit list": "Tor çıkış listesi güncellenemedi",
  "Process uptime, database size, data-processing queue and host metrics.": "Süreç çalışma süresi, veritabanı boyutu, veri işleme kuyruğu ve host metrikleri.",
  "Process": "Süreç",
  "Uptime": "Çalışma süresi",
  "Started": "Başlatıldı",
  "Python": "Python",
  "Platform": "Platform",
  "Database": "Veritabanı",
  "Total documents": "Toplam belge sayısı",
  "Data processing": "Veri işleme",
  "Analytics backend": "Analitik backend",
  "Ingest mode": "Veri alım modu",
  "Queue depth": "Kuyruk derinliği",
  "Click uniqueness": "Klik tekil sayımı",
  "Redis ping": "Redis ping",
  "Host": "Host",
  "Load average": "Ortalama yük",
  "Disk used": "Kullanılan disk",
  "Disk free": "Boş disk",
  "Cron": "Cron",
  "Last cost sync": "Son maliyet senkronizasyonu",
  "FX rates": "Döviz kurları",
  "No FX rates cached.": "Önbellekte döviz kuru yok.",
  "Tor exit list": "Tor çıkış listesi",
  "Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.": "Bellek içi engel listesini yenilemek için satır sonuyla ayrılmış bir Tor çıkış düğümü listesi yapıştırın (örn. torbulkexitlist kaynağından).",
  "Replace list": "Listeyi değiştir",
  "Error loading fingerprints": "Parmak izi yüklenirken hata",
  "Fingerprint updated": "Parmak izi güncellendi",
  "Failed to update fingerprint": "Parmak izi güncellenemedi",
  "JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.": "JA3 / JA4 parmak izi geçersiz kılmaları — bot tespitini yönlendirmek için bir parmak izini iyi veya kötü olarak işaretleyin.",
  "All classifications": "Tüm sınıflandırmalar",
  "All kinds": "Tüm türler",
  "No fingerprint overrides yet": "Henüz parmak izi geçersiz kılması yok",
  "As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.": "Trafik geldikçe JA3/JA4 parmak izleri burada görünür; bilinen iyi veya kötü istemcileri işaretleyebilirsiniz.",
  "Fingerprint": "Parmak izi",
  "Kind": "Tür",
  "Label": "Etiket",
  "Hits": "İsabet",
  "Last seen": "Son görülme",
  "Classification": "Sınıflandırma",
  "Telegram alerts": "Telegram bildirimleri",
  "Deploy + server-error notifications for the operator.": "Operatör için dağıtım ve sunucu hatası bildirimleri.",
  "Configured": "Yapılandırıldı",
  "Not configured": "Yapılandırılmadı",
  "Topic": "Konu",
  "Topic ID (optional)": "Konu ID (isteğe bağlı)",
  "Leave the token empty to keep the saved one.": "Kaydedilen token'ı korumak için token alanını boş bırakın.",
  "Save & send test": "Kaydet ve test gönder",
  "Test message delivered": "Test mesajı iletildi",
  "Send failed": "Gönderme başarısız",
  "Chat ID is required": "Chat ID zorunludur",
  "Nightly DB backups": "Gecelik DB yedekleri",
  "A full copy of the database every night, kept on the persistent volume.": "Her gece veritabanının tam kopyası, kalıcı birimde saklanır.",
  "Daily at": "Her gün saat",
  "Copies kept": "Saklanan kopya sayısı",
  "Stored": "Depolandı",
  "Latest": "En son",
  "No backups yet": "Henüz yedek yok",
  "Run backup now": "Şimdi yedekle",
  "Backup started — the result will arrive in the monitoring topic.": "Yedekleme başlatıldı — sonuç izleme konusunda görünecek.",
  "Platform admin": "Platform yöneticisi",
  "Operator": "Operatör",
  "Cross-tenant back-office: accounts, access and platform health.": "Tüm hesaplar için back-office: erişimler, hesaplar ve platform durumu.",
  "Accounts": "Hesaplar",
  "New sign-ups": "Yeni kayıtlar",
  "Last 30 days": "Son 30 gün",
  "Clicks (24h)": "Tıklamalar (24s)",
  "Clicks (30d)": "Tıklamalar (30g)",
  "Conversions (30d)": "Dönüşümler (30g)",
  "Platform state": "Platform durumu",
  "Self-signup": "Kendi kendine kayıt",
  "Open": "Açık",
  "Closed": "Kapalı",
  "Controlled by the DISABLE_REGISTRATION variable on Railway.": "Railway'deki DISABLE_REGISTRATION değişkeni tarafından kontrol edilir.",
  "Root admins": "Root adminler",
  "From PLATFORM_ADMIN_EMAILS — manage the list on Railway.": "PLATFORM_ADMIN_EMAILS'den — listeyi Railway'de yönetin.",
  "Granted admins": "Yetkilendirilmiş adminler",
  "Every registered account. Block access or grant platform admin.": "Tüm kayıtlı hesaplar. Erişimi engelleyin veya platform admin yetkisi verin.",
  "Search by email or name…": "E-posta veya ada göre ara…",
  "Plan": "Plan",
  "Last click": "Son tıklama",
  "No accounts found": "Hesap bulunamadı",
  "Root admin": "Root admin",
  "Client": "Müşteri",
  "Managed on Railway": "Railway'de yönetilir",
  "Grant platform admin": "Platform admin yetkisi ver",
  "Grant platform admin?": "Platform admin yetkisi verilsin mi?",
  "Make admin": "Admin yap",
  "Revoke platform admin": "Platform admin yetkisini kaldır",
  "Revoke platform admin?": "Platform admin yetkisi kaldırılsın mı?",
  "Revoke admin": "Yetkiyi kaldır",
  "Block account": "Hesabı engelle",
  "Block this account?": "Bu hesap engellensin mi?",
  "The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.": "Kullanıcı erişimini hemen kaybeder — siz engelini kaldırana kadar her oturum reddedilir. Kullanıcının kampanyaları ve takip linkleri trafiği sunmaya devam eder.",
  "Reason (optional)": "Neden (isteğe bağlı)",
  "Visible to admins only": "Yalnızca adminlere görünür",
  "Unblock": "Engeli kaldır",
  "Unblock account": "Hesabın engelini kaldır",
  "Unblock this account?": "Bu hesabın engeli kaldırılsın mı?",
  "The user will be able to sign in again immediately.": "Kullanıcı hemen tekrar giriş yapabilecek.",
  "This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.": "Bu kullanıcı operatör erişimi kazanır: platform back-office, tüm hesaplar ve platform ayarları. Yetkilendirme denetim günlüğüne kaydedilir.",
  "The user keeps their account but loses operator access.": "Kullanıcı hesabını korur ancak operatör erişimini kaybeder.",
  "Account blocked": "Hesap engellendi",
  "Account unblocked": "Hesabın engeli kaldırıldı",
  "Platform admin granted": "Platform admin yetkisi verildi",
  "Platform admin revoked": "Platform admin yetkisi kaldırıldı",
  "Failed to load platform overview": "Platform genel bakışı yüklenemedi",
  "Failed to load users": "Kullanıcılar yüklenemedi",
  "{count} accounts": "{count} hesap",
  "Page {page} of {total}": "{page} / {total} sayfa",
  "Change plan": "Planı değiştir",
  "Plan updated": "Plan güncellendi",
  "Sets the edition directly (status \"active\", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.": "Sürümü doğrudan ayarlar (durum \"active\", deneme süresi yok) — manuel ve ücretsiz hesaplar için. Aktif Stripe aboneliği olan hesapların planı Stripe üzerinden değiştirilmelidir.",
  "Account deleted": "Hesap silindi",
  "Delete account": "Hesabı sil",
  "Delete this account permanently?": "Bu hesap kalıcı olarak silinsin mi?",
  "This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.": "Bu işlem hesabı ve TÜM verilerini siler — kampanyalar, tıklamalar, dönüşümler, offer'lar, landing page'ler, domainler, raporlar. Bu işlem geri alınamaz.",
  "We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.": "{email} adresine bir onay bağlantısı gönderdik. Hesabınızı etkinleştirmek için bağlantıyı açın — bağlantı 24 saat geçerlidir.",
  "Check your spam folder if it doesn't arrive within a minute.": "Bir dakika içinde gelmezse spam klasörünüzü kontrol edin.",
  "Resend the email": "E-postayı yeniden gönder",
  "Sent — check your inbox": "Gönderildi — gelen kutunuzu kontrol edin",
  "Could not resend the email — try again.": "E-posta yeniden gönderilemedi — tekrar deneyin.",
  "Back to sign in": "Girişe geri dön",
  "Confirming your email…": "E-postanız doğrulanıyor…",
  "This takes a second.": "Bu bir saniye sürer.",
  "Email confirmed — welcome aboard!": "E-posta doğrulandı — hoş geldiniz!",
  "Taking you to your dashboard…": "Kontrol panelinize yönlendiriliyorsunuz…",
  "Verification failed — the link may have expired.": "Doğrulama başarısız — bağlantının süresi dolmuş olabilir.",
  "The verification link is incomplete — open the link from the email again.": "Doğrulama bağlantısı eksik — e-postadaki bağlantıyı tekrar açın.",
  "Use 8–128 characters; long passphrases are recommended": "8–128 karakter kullanın; uzun parola öbekleri önerilir",
  "Users": "Kullanıcılar",
  "Error": "Hata",
  "Failed to load documentation.": "Dokümantasyon yüklenemedi.",
  "Production readiness": "Üretime hazırlık",
  "Ready": "Hazır",
  "Attention required": "Dikkat gerekiyor",
  "Secret-free checks for runtime configuration and isolation controls.": "Çalışma zamanı yapılandırması ve izolasyon kontrolleri için gizli bilgi içermeyen denetimler.",
  "Environment": "Ortam",
  "production": "production",
  "development": "geliştirme",
  "Rate limiter": "Rate limiter",
  "Access token TTL": "Access token TTL",
  "Backend root": "Backend root",
  "Blocking checks": "Engelleyici denetimler",
  "Failed to load integrity status": "Bütünlük durumu yüklenemedi",
  "Traffic suspended": "Trafik askıya alındı",
  "Traffic resumed": "Trafik devam ettirildi",
  "Data integrity": "Veri bütünlüğü",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Zorunlu benzersiz indeksler tıklama attribution'ını, dönüşümleri ve faturalama idempotency'sini korur.",
  "All mandatory indexes are present and unique.": "Tüm zorunlu indeksler mevcut ve benzersiz.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Bu uyarıyı görmezden gelmeyin. İndeksleri değiştirmeden önce backend başlangıç loglarını inceleyin.",
  "Missing": "Eksik",
  "Not unique": "Benzersiz değil",
  "Resume campaign traffic": "Kampanya trafiğini devam ettir",
  "Resume traffic": "Trafiği devam ettir",
  "Suspend campaign traffic": "Kampanya trafiğini askıya al",
  "Suspend traffic": "Trafiği askıya al",
  "Suspend all campaign traffic for this account?": "Bu hesaptaki tüm kampanya trafiği askıya alınsın mı?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Herkese açık takip bağlantıları, pasif kampanya yanıtı döndürmeye başlar. Kampanya ayarları değişmez ve trafik anında devam ettirilebilir.",
  "Resume campaign traffic for this account?": "Bu hesaptaki kampanya trafiği devam ettirilsin mi?",
  "Existing active campaigns and tracking links will start serving again.": "Mevcut aktif kampanyalar ve takip bağlantıları yeniden çalışmaya başlar.",
  "Password changed — other devices have been signed out": "Şifre değiştirildi — diğer cihazlardaki oturumlar kapatıldı",
  "Sign out of every device, including this one? You will need to sign in again.": "Bu cihaz dahil tüm cihazlardan çıkış yapılsın mı? Tekrar giriş yapmanız gerekecek.",
  "All sessions signed out": "Tüm oturumlar kapatıldı",
  "Error signing out sessions": "Oturumlar kapatılırken hata oluştu",
  "Changing your password also signs out every other device.": "Şifrenizi değiştirmek diğer tüm cihazlardaki oturumları da kapatır.",
  "Active sessions": "Aktif oturumlar",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Dizüstü bilgisayarınızı mı kaybettiniz ya da şifrenizin başkasının eline geçtiğini mi düşünüyorsunuz? Tüm oturumları tek seferde sonlandırın.",
  "This signs out every device, including this one. Signing back in takes one password.": "Bu cihaz dahil tüm cihazlardaki oturumlar kapatılır. Geri dönmek için şifreniz yeterli.",
  "Sign out everywhere": "Her yerden çıkış yap",
  "Pages": "Sayfalar",
  "Copy path": "Yolu kopyala",
  "Choose your plan": "Planınızı seçin",
  "Every plan includes the whole tracker.": "Her plan tam tracker içerir.",
  "{n} days free": "{n} gün ücretsiz",
  "Billed today": "Bugün faturalandırılır",
  "Continue": "Devam et",
  "Start and Pro: {n} days free, card required. Charged automatically on day {next} unless you cancel. One free trial per account.": "Start ve Pro: {n} gün ücretsiz, kart gereklidir. {next}. günde otomatik olarak ücretlendirilirsiniz, iptal etmezseniz. Hesap başına bir ücretsiz deneme.",
  "Could not load plans.": "Planlar yüklenemedi.",
  "Try again": "Tekrar dene",
  "Opening secure payment…": "Güvenli ödeme açılıyor…",
  "Could not open the payment page. Choose a plan to continue.": "Ödeme sayfası açılamadı. Devam etmek için bir plan seçin.",
  "Start and Pro come with {n} days free. A card is required up front: Stripe checks it but charges nothing until day {next}, then the plan renews automatically. Cancel any time before the trial ends and you pay nothing. Team and Network are billed on the day you subscribe. One free trial per account.": "Start ve Pro {n} günlük ücretsiz denemeyle gelir. Kart baştan gereklidir: Stripe doğrular ancak {next}. güne kadar hiçbir şey tahsil etmez, ardından plan otomatik olarak yenilenir. Deneme süresi dolmadan istediğiniz zaman iptal edin, hiçbir şey ödemezsiniz. Team ve Network, abone olduğunuz gün faturalandırılır. Hesap başına bir ücretsiz deneme.",
  "Choose a plan to open your workspace.": "Çalışma alanınızı açmak için bir plan seçin.",
  "Payment was not completed. Choose a plan to continue.": "Ödeme tamamlanamadı. Devam etmek için bir plan seçin.",
  "Confirming your payment…": "Ödemeniz onaylanıyor…",
  "Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.": "Ödeme alındı, ancak onay beklenenden uzun sürüyor. Bu sayfayı bir dakika sonra yenileyin.",
  "Payment confirmed. Welcome aboard!": "Ödeme onaylandı. Hoş geldiniz!",
  "Free trial until {date}. Your card will be charged automatically on that day — nothing to do. Cancel before then in Manage billing and you pay nothing.": "{date} tarihine kadar ücretsiz deneme. O gün kartınız otomatik olarak ücretlendirilir — yapmanız gereken bir şey yok. Öncesinde Faturalamayı yönet bölümünden iptal ederseniz hiçbir şey ödemezsiniz.",
  "Start {n}-day free trial": "{n} günlük ücretsiz denemeyi başlat",
  "Subscribe": "Abone ol",
  "Your free trial has already been used, so this plan is billed today.": "Ücretsiz denemeniz zaten kullanıldı, bu nedenle bu plan bugün faturalandırılır.",
  "To switch plans, contact support — we move you without losing paid days.": "Plan değiştirmek için destek ekibiyle iletişime geçin — ödenen günleri kaybetmeden sizi aktarırız.",
  "Everything in Network, on your own server or cloud, installed with one command. Unlimited users, domains and history.": "Network'teki her şey, kendi sunucunuzda veya bulutunuzda, tek komutla kurulur. Sınırsız kullanıcı, domain ve geçmiş.",
  "After payment you issue your licence key on the page Self-hosted and install the tracker yourself with one command, following the step-by-step guide. If you prefer, we set it up for you or move you off your old tracker. The hosting is billed to you by your provider.": "Ödemenin ardından Self-hosted sayfasında lisans anahtarınızı oluşturur ve adım adım kılavuzu izleyerek tracker'ı tek komutla kendiniz kurarsınız. Tercih ederseniz kurulumu sizin için yapar ya da eski tracker'ınızdan geçişinizi sağlarız. Hosting ücreti doğrudan sağlayıcınız tarafından faturalandırılır.",
  "Install on your own server": "Kendi sunucunuza kurun",
  "Or we set it up for you, on request": "Ya da talep üzerine sizin için kurarız",
  "Your own server or a dedicated cloud, with a licence key.": "Lisans anahtarıyla kendi sunucunuz veya özel bulutunuz.",
  "Monthly or 12 months": "Aylık veya 12 ay",
  "Cannot reach the server. Check your connection and try again.": "Sunucuya ulaşılamıyor. Bağlantınızı kontrol edip tekrar deneyin.",
  "Clicks are never counted": "Tıklamalar hiçbir zaman sayılmaz",
  "However much traffic you send, the invoice does not move.": "Ne kadar trafik gönderirseniz gönderin, fatura değişmez.",
  "Bots filtered on arrival": "Botlar gelişte filtrelenir",
  "Datacenter, VPN and proxy traffic is handled before a page loads.": "Datacenter, VPN ve proxy trafiği sayfa yüklenmeden önce işlenir.",
  "First link in five minutes": "Beş dakikada ilk link",
  "Add a source, create a campaign, copy the link.": "Trafik kaynağı ekle, kampanya oluştur, linki kopyala.",
  "Your workspace": "Çalışma alanınız",
  "Everything is already running": "Her şey zaten çalışıyor",
  "Your workspace, your campaigns, your numbers.": "Çalışma alanınız, kampanyalarınız, rakamlarınız.",
  "Confirm your email": "E-postanızı onaylayın",
  "Open the link we sent and your workspace is ready.": "Gönderdiğimiz bağlantıyı açın, çalışma alanınız hazır olsun.",
  "Enter your code": "Kodunuzu girin",
  "Six digits from your authenticator app.": "Kimlik doğrulama uygulamanızdaki altı rakam.",
  "Create your account": "Hesabınızı oluşturun",
  "Two fields and a password. Tracking is live in minutes.": "İki alan ve bir şifre. Tracking dakikalar içinde başlar.",
  "We sent a confirmation link to": "Onay bağlantısını şu adrese gönderdik:",
  "Check spam if it is not there within a minute. The link lasts 24 hours.": "Bir dakika içinde gelmezse spam klasörünü kontrol edin. Bağlantı 24 saat geçerlidir.",
  "Sent again. Give it a moment.": "Tekrar gönderildi. Bir an bekleyin.",
  "Sending": "Gönderiliyor",
  "Use a different account": "Farklı bir hesap kullanın",
  "Verification code": "Doğrulama kodu",
  "Checking": "Kontrol ediliyor",
  "Signing in": "Giriş yapılıyor",
  "Your name": "Adınız",
  "At least 8 characters.": "En az 8 karakter.",
  "Creating": "Oluşturuluyor",
  "Continue with": "Şununla devam edin:",
  "No account yet?": "Henüz hesabınız yok mu?",
  "Create one": "Oluşturun",
  "New accounts are closed at the moment.": "Şu an yeni hesap açılmıyor.",
  "Terms": "Kullanım Koşulları",
  "and": "ve",
  "Privacy": "Gizlilik",
  "History kept forever": "Geçmiş sonsuza kadar saklanır",
  "Light theme": "Açık tema",
  "Dark theme": "Koyu tema",
  "Match system": "Sisteme göre",
  "Theme": "Tema",
  "Navigate": "Gezin",
  "Not included on your plan. Open Billing to upgrade.": "Planınıza dahil değil. Yükseltmek için Faturalandırma'yı açın.",
  "Talk to us": "Bizimle iletişime geçin",
  "Automatic flow optimiser": "Otomatik akış optimizörü",
  "Learning bot detection": "Öğrenen bot tespiti",
  "Lead forms into a CRM": "Lead formlarını CRM'e aktar",
  "Roles and 31 permissions": "Roller ve 31 izin",
  "Single sign on": "Tek oturum açma (SSO)",
  "We move you off your old tracker": "Sizi eski tracker'ınızdan taşıyoruz",
  "90 days of history": "90 günlük geçmiş",
  "1 year of history": "1 yıllık geçmiş",
  "2 years of history": "2 yıllık geçmiş",
  "History kept": "Saklanan geçmiş",
  "Your first campaigns, with nothing to set up.": "İlk kampanyalarınız, hiçbir şey ayarlamadan.",
  "Everything that makes the work run itself.": "İşi kendiliğinden yürüten her şey.",
  "A team, with roles and a paper trail.": "Roller ve değişiklik geçmişiyle birlikte bir ekip.",
  "A network, under your own brand.": "Kendi markanız altında bir ağ.",
  "Run the tracker on your own server or in a dedicated cloud. Your licence key activates one production server and one test server.": "Tracker'ı kendi sunucunuzda veya özel bir bulutta çalıştırın. Lisans anahtarınız bir üretim sunucusunu ve bir test sunucusunu etkinleştirir.",
  "Self-hosted installs come with the Enterprise plan. Servers activated earlier stop once their current licence runs out.": "Kendi sunucusuna kurulum Enterprise planıyla birlikte gelir. Daha önce etkinleştirilen sunucular, mevcut lisansları sona erdiğinde durur.",
  "This is the only time the key is shown. Store it somewhere safe: you enter it when you install the tracker.": "Anahtar yalnızca bu sefer gösterilir. Güvenli bir yerde saklayın: tracker'ı kurarken girmeniz gerekecek.",
  "A new key replaces the current one at once. Servers that still use the old key cannot renew their licence and stop within {days} days unless you enter the new key on them.": "Yeni bir anahtar mevcut olanın yerini hemen alır. Eski anahtarı kullanmaya devam eden sunucular lisanslarını yenileyemez ve yeni anahtarı girmediğiniz takdirde {days} gün içinde durur.",
  "The server loses its slot right away and stops within {days} days. Use this when you move the tracker to another server.": "Sunucu slotunu hemen kaybeder ve {days} gün içinde durur. Tracker'ı başka bir sunucuya taşırken bunu kullanın.",
  "Each server checks in with us once a day and receives a licence valid for {days} days. If it cannot check in, or the subscription ends, it keeps working until that licence runs out and then stops. A test server is limited to {clicks} clicks a day. Only technical data is sent: licence, server id and version, never data about your traffic or your clients.": "Her sunucu günde bir kez bizimle iletişime geçer ve {days} günlük geçerli bir lisans alır. İletişim kurulamazsa veya abonelik sona ererse, lisans dolana kadar çalışmaya devam eder ve ardından durur. Test sunucusu günlük {clicks} tıklamayla sınırlıdır. Yalnızca teknik veriler gönderilir: lisans, sunucu ID'si ve sürüm; trafiğiniz veya müşterileriniz hakkındaki veriler asla gönderilmez.",
  "Run this command as root on a fresh server. In about ten minutes it installs everything (Kubernetes, HTTPS certificates, the database and the tracker). Running it again upgrades the install and keeps the data.": "Bu komutu temiz bir sunucuda root olarak çalıştırın. Yaklaşık on dakika içinde her şeyi kurar (Kubernetes, HTTPS sertifikaları, veritabanı ve tracker). Tekrar çalıştırmak kurulumu günceller ve verileri korur.",
  "Self-hosted": "Self-hosted",
  "Enterprise": "Enterprise",
  "Licence key": "Lisans anahtarı",
  "Issue licence key": "Lisans anahtarı oluştur",
  "Rotate key": "Anahtarı yenile",
  "Rotate licence key?": "Lisans anahtarı yenilensin mi?",
  "Licence key issued": "Lisans anahtarı oluşturuldu",
  "Server deactivated": "Sunucu devre dışı bırakıldı",
  "Deactivate this server?": "Bu sunucu devre dışı bırakılsın mı?",
  "Servers": "Sunucular",
  "Production": "Üretim",
  "Revoked": "İptal edildi",
  "Deactivated": "Devre dışı",
  "Deactivate": "Devre dışı bırak",
  "Issued": "Oluşturuldu",
  "Version": "Sürüm",
  "See plans": "Planları gör",
  "No servers activated yet.": "Henüz etkinleştirilmiş sunucu yok.",
  "Transfers left (30 days)": "Kalan transferler (30 gün)",
  "Could not load this page.": "Bu sayfa yüklenemedi.",
  "Licensing is temporarily unavailable. Try again later.": "Lisanslama geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.",
  "Your server: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu or Debian (x86-64). The tracker installs with one command.": "Sunucunuz: 4 CPU çekirdeği, 8 GB RAM, 50 GB SSD, Ubuntu veya Debian (x86-64). Tracker tek bir komutla kurulur.",
  "Put your licence key in place of the X: it is shown once, when you issue or rotate it.": "X yerine lisans anahtarınızı girin: anahtar yalnızca oluşturulduğunda veya yenilendiğinde bir kez gösterilir.",
  "The first account signed up with this email gets administrator rights on the server.": "Bu e-posta ile kaydolan ilk hesap sunucuda yönetici haklarına sahip olur.",
  "Without --domain the tracker starts on an address like 1-2-3-4.sslip.io. For your own domain, first point tracker.example.com and api.tracker.example.com at the server, then add --domain tracker.example.com.": "--domain olmadan tracker, 1-2-3-4.sslip.io gibi bir adreste başlar. Kendi alan adınız için önce tracker.example.com ve api.tracker.example.com'u sunucuya yönlendirin, ardından --domain tracker.example.com ekleyin.",
  "Install on your server": "Sunucunuza kurulum",
  "Server requirements": "Sunucu gereksinimleri",
  "Production server": "Üretim sunucusu",
  "Test server": "Test sunucusu",
  "Operating system": "İşletim sistemi",
  "Disk space": "Disk alanı",
  "Connection": "Bağlantı",
  "Ubuntu 22.04 / 24.04 or Debian 12, x86-64": "Ubuntu 22.04 / 24.04 veya Debian 12, x86-64",
  "4 cores (2 at least)": "4 çekirdek (en az 2)",
  "8 GB (4 GB at least)": "8 GB (en az 4 GB)",
  "50 GB SSD (30 GB free at least)": "50 GB SSD (en az 30 GB boş alan)",
  "Public IP address, ports 80 and 443 open": "Genel IP adresi, 80 ve 443 numaralı portlar açık",
  "After the install": "Kurulumdan sonra",
  "Server state and licence": "Sunucu durumu ve lisans",
  "Upgrade to the newest signed release": "En yeni imzalı sürüme güncelle",
  "Back up the database to /var/backups/xpnsr": "Veritabanını /var/backups/xpnsr konumuna yedekle",
  "Copy command": "Komutu kopyala",
  "Install the tracker on your own server in about 15 minutes. You do not need to know Kubernetes or Linux: you copy one command and the installer does the rest.": "Tracker'ı kendi sunucunuza yaklaşık 15 dakikada kurun. Kubernetes veya Linux bilmenize gerek yok: tek bir komutu kopyalarsınız, gerisini yükleyici halleder.",
  "Install guide": "Kurulum kılavuzu",
  "Step-by-step guide": "Adım adım kılavuz",
  "Back to Self-hosted": "Self-hosted'a geri dön",
  "Step": "Adım",
  "Get a server": "Sunucu edinin",
  "Optional: your own domain": "İsteğe bağlı: kendi alan adınız",
  "Issue your licence key": "Lisans anahtarı oluştur",
  "Connect to the server": "Sunucuya bağlan",
  "Run the install command": "Kurulum komutunu çalıştır",
  "Open your tracker": "Tracker'ınızı açın",
  "Keep it running": "Çalışır durumda tutma",
  "Rent a VPS or cloud server from any provider, for example Hetzner, DigitalOcean, OVH, Vultr or AWS Lightsail: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). It usually costs 15–60 USD a month, billed to you by the provider.": "Herhangi bir sağlayıcıdan VPS veya bulut sunucu kiralayın; örneğin Hetzner, DigitalOcean, OVH, Vultr veya AWS Lightsail: 4 CPU çekirdeği, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). Genellikle aylık 15–60 USD'ye mal olur ve faturayı sağlayıcı keser.",
  "Take a fresh server with nothing else installed, and make sure ports 80 and 443 are open in the provider's firewall.": "Üzerinde başka hiçbir şey kurulu olmayan temiz bir sunucu alın ve sağlayıcının güvenlik duvarında 80 ile 443 numaralı portların açık olduğundan emin olun.",
  "Note the server's IP address and the root password or SSH key from the provider's panel.": "Sunucunun IP adresini ve sağlayıcının panelinden root şifresini ya da SSH anahtarını not edin.",
  "For your own address, create two DNS records of type A that point at the server's IP address, for example tracker.example.com and api.tracker.example.com. Skip this to start on a free address like 1-2-3-4.sslip.io; you can switch later.": "Kendi adresiniz için, sunucunun IP adresine işaret eden A türünde iki DNS kaydı oluşturun; örneğin tracker.example.com ve api.tracker.example.com. Bunu atlayarak 1-2-3-4.sslip.io gibi ücretsiz bir adresle başlayabilirsiniz; daha sonra değiştirebilirsiniz.",
  "On the page Self-hosted click Issue licence key and save the key somewhere safe: it is shown only once.": "Self-hosted sayfasında Lisans anahtarı oluştur'a tıklayın ve anahtarı güvenli bir yere kaydedin: yalnızca bir kez gösterilir.",
  "On Mac or Linux open Terminal, on Windows open PowerShell, and type the command below with your server's IP address. Answer yes to the first question and enter the password.": "Mac veya Linux'ta Terminal'i, Windows'ta PowerShell'i açın ve aşağıdaki komutu sunucunuzun IP adresiyle birlikte yazın. İlk soruya yes yanıtını verin ve şifreyi girin.",
  "Copy the command from the page Self-hosted (your key and email are already in it), paste it into the terminal and press Enter. For your own domain add --domain tracker.example.com to it.": "Self-hosted sayfasından komutu kopyalayın (anahtarınız ve e-posta adresiniz zaten içinde yer alır), terminale yapıştırın ve Enter'a basın. Kendi alan adınız için komuta --domain tracker.example.com ekleyin.",
  "The install takes about 10 minutes. If the connection drops, the install keeps going: reconnect and follow it with the command below.": "Kurulum yaklaşık 10 dakika sürer. Bağlantı kesilirse kurulum devam eder: yeniden bağlanın ve aşağıdaki komutla süreci takip edin.",
  "At the end the installer prints the address of your workspace. Open it and sign up with the administrator email from the command: that account gets administrator rights. The licence activates on its own.": "Kurulumun sonunda yükleyici workspace adresinizi ekrana yazdırır. Adresi açın ve komutta belirttiğiniz yönetici e-posta adresiyle kayıt olun: bu hesap yönetici yetkisi alır. Lisans otomatik olarak etkinleşir.",
  "To check everything, run the command below: the licence line should say \"state\":\"active\".": "Her şeyi kontrol etmek için aşağıdaki komutu çalıştırın: lisans satırında \"state\":\"active\" yazıyor olmalıdır.",
  "Updates: the command below installs the newest signed release and keeps your data.": "Güncellemeler: aşağıdaki komut en yeni imzalı sürümü kurar ve verilerinizi korur.",
  "Backups: the command below saves the database to /var/backups/xpnsr. Copy it off the server regularly and turn on your provider's snapshots.": "Yedekler: aşağıdaki komut veritabanını /var/backups/xpnsr konumuna kaydeder. Düzenli olarak sunucu dışına kopyalayın ve sağlayıcınızın snapshot özelliğini etkinleştirin.",
  "Test server: install a second server the same way, choosing Test server on the page Self-hosted.": "Test sunucusu: Self-hosted sayfasında Test sunucusu seçeneğini belirleyerek aynı şekilde ikinci bir sunucu kurun.",
  "If something goes wrong": "Bir şeyler ters giderse",
  "ports 80/443 are already in use": "80/443 portları zaten kullanımda",
  "Another web server runs on this machine. Use a fresh server or stop that web server, then run the command again.": "Bu makinede başka bir web sunucusu çalışıyor. Temiz bir sunucu kullanın ya da mevcut web sunucusunu durdurup komutu tekrar çalıştırın.",
  "The browser says the connection is not private": "Tarayıcı bağlantının güvenli olmadığını söylüyor",
  "The HTTPS certificate is issued a few minutes after DNS points at the server. Wait five minutes; the command below should show READY True.": "HTTPS sertifikası, DNS sunucuyu göstermeye başladıktan birkaç dakika sonra düzenlenir. Beş dakika bekleyin; aşağıdaki komut READY True göstermelidir.",
  "The licence says the slot is in use": "Lisans slotun kullanımda olduğunu söylüyor",
  "The key is already active on another server. Deactivate that server on the page Self-hosted, then enter the key on the licence screen of your workspace, or wait up to an hour.": "Anahtar başka bir sunucuda zaten aktif. Self-hosted sayfasında o sunucuyu devre dışı bırakın, ardından anahtarı çalışma alanınızın lisans ekranına girin ya da bir saate kadar bekleyin.",
  "licence key not recognised": "lisans anahtarı tanınmadı",
  "Paste the key again exactly as saved, or rotate it on the page Self-hosted and use the new one.": "Anahtarı kaydettiğiniz şekilde tekrar yapıştırın ya da Self-hosted sayfasında yeni bir anahtar oluşturup onu kullanın.",
  "Anything else": "Başka bir sorun",
  "Run the install command again: it is always safe and continues where it stopped. If that does not help, send us the last lines of /var/log/xpnsr-install.log and the output of xpnsr status.": "Kurulum komutunu tekrar çalıştırın: her zaman güvenlidir ve kaldığı yerden devam eder. Bu da işe yaramazsa /var/log/xpnsr-install.log dosyasının son satırlarını ve xpnsr status çıktısını bize gönderin.",
  "Prefer that we do it?": "Bunu sizin için yapmamızı ister misiniz?",
  "We install the tracker for you, or move you off your old tracker with your campaigns. You open the server in your own hosting account and give us temporary access; it is included in Enterprise.": "Tracker'ı sizin için kuruyoruz ya da kampanyalarınızla birlikte eski tracker'ınızdan geçişinizi sağlıyoruz. Kendi hosting hesabınızda sunucuyu açıp bize geçici erişim vermeniz yeterli; bu Enterprise planına dahildir.",
  "Write to us": "Bize yazın",
  "Fallback rules": "Yedek kurallar",
  "Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.": "Yalnızca bir tıklama kampanyanın hiçbir akışıyla eşleşmediğinde kullanılır. Yönlendirmeyi akışlarda ayarlayın; burayı nadir genel yakalama durumları için bırakın.",
  "Add the banner to your landing page": "Baneri landing page'inize ekleyin",
  "Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.": "Bu satırı kampanyanın her landing page'inin <head> bölümüne yapıştırın. Baner yalnızca yukarıda etkinleştirildiğinde ve yalnızca seçilen bölgelerden gelen ziyaretçilere gösterilir.",
  "Copy code": "Kodu kopyala",
  "No campaigns yet": "Henüz kampanya yok",
  "Audience": "Kitle",
  "Updated at {time}": "{time} itibarıyla güncellendi",
  "Download ZIP": "ZIP indir",
  "Download failed": "İndirme başarısız oldu",
  "Enter the licence key from your account (page Self-hosted). It activates this server, which then renews its licence once a day on its own.": "Hesabınızdaki lisans anahtarını girin (Self-hosted sayfası). Bu sunucuyu etkinleştirir; sunucu daha sonra lisansını günde bir kez otomatik olarak yeniler.",
  "The licence of this installation has run out or is no longer valid, so the tracker is stopped. Check the Enterprise subscription and the key, then activate again.": "Bu kurulumun lisansı sona erdi veya artık geçerli değil, bu nedenle tracker durduruldu. Enterprise aboneliğini ve anahtarı kontrol edip tekrar etkinleştirin.",
  "The licence could not be renewed. The tracker keeps working until {date} and then stops unless a renewal succeeds.": "Lisans yenilenemedi. Tracker {date} tarihine kadar çalışmaya devam eder; yenileme başarısız olursa durur.",
  "Test server: limited to {n} clicks a day.": "Test sunucusu: günlük {n} tıklama ile sınırlıdır.",
  "This installation is not licensed. Ask the administrator to activate it.": "Bu kurulumun lisansı yok. Etkinleştirmesi için yöneticiye başvurun.",
  "Licence activated": "Lisans etkinleştirildi",
  "Licence expired": "Lisans süresi doldu",
  "Activate this installation": "Bu kurulumu etkinleştir",
  "Licensed to {who} · licence {id}": "{who} lisanslı · lisans {id}",
  "Live clicks": "Canlı tıklamalar",
  "Open clicks log": "Tıklama logunu aç",
  "Could not load clicks": "Tıklamalar yüklenemedi",
  "No clicks yet": "Henüz tıklama yok",
  "Send traffic to a tracking link and every click shows up here as it happens.": "Bir tracking linkine trafik gönderin; her tıklama gerçek zamanlı olarak burada görünür.",
  "cloaked": "cloaked",
  "proxy": "proxy",
  "human": "insan",
  "{n}s ago": "{n} sn önce",
  "Trend": "Trend",
  "Clicks, last 14 days": "Tıklamalar, son 14 gün",
  "Add level": "Seviye ekle",
  "Remove level": "Seviye kaldır",
  "Last {n} days": "Son {n} gün",
  "All time": "Tüm zamanlar",
  "JA3 / JA4 fingerprint overrides for bot detection": "Bot tespiti için JA3 / JA4 parmak izi geçersiz kılmaları",
  "Uptime, DB size, data-processing queue and host metrics": "Uptime, DB boyutu, veri işleme kuyruğu ve sunucu metrikleri",
  "Outbound conversion postbacks fired across your campaigns": "Kampanyalarınızdan gönderilen çıkış dönüşüm postback'leri",
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normal — filtreli standart bir akış. Catch (yakalama) — Normal akışlardan önce kontrol edilir ve eşleşen tıklamayı önce alır; örn. botlar veya test GEO'su. Fallback — son akış; başka hiçbir akışla eşleşmeyen trafiği alır.",
  "Interface: search, shortcuts and language": "Arayüz: arama, kısayollar ve dil",
  "CAPI": "CAPI",
  "FAQ": "FAQ",
  "Cost, integrations & ops": "Maliyet, entegrasyonlar ve operasyonlar",
  "New campaign": "Yeni kampanya",
  "Command palette": "Komut paleti",
  "Pre-landing page": "Pre-landing page",
  "good": "iyi",
  "bad": "kötü",
  "unknown": "bilinmiyor",
  "Error reports": "Hata raporları",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Sunucu ve tarayıcı hataları nedene göre gruplandırılmıştır. Çözüldü olarak işaretle, hata tekrar oluşana kadar raporu gizler; Yoksay ise raporu sessiz tutar.",
  "Unresolved": "Çözülmemiş",
  "Ignored": "Yoksayılan",
  "All": "Tümü",
  "All sources": "Tüm kaynaklar",
  "Server": "Sunucu",
  "Search by error text": "Hata metnine göre ara",
  "Count": "Sayı",
  "First seen": "İlk görülme",
  "No error reports": "Hata raporu yok",
  "Could not load error reports": "Hata raporları yüklenemedi",
  "Could not load the report": "Rapor yüklenemedi",
  "Report updated": "Rapor güncellendi",
  "Could not update the report": "Rapor güncellenemedi",
  "Seen {n} times": "{n} kez görüldü",
  "Mark resolved": "Çözüldü olarak işaretle",
  "Reopen": "Yeniden aç",
  "Datacenter / hosting VPN / Tor IPs": "Datacenter / hosting VPN / Tor IP'leri",
  "Visitors from cloud and hosting networks, VPNs that run on them, and Tor exits get the safe page. Residential proxies cannot be recognised without a paid IP database.": "Bulut ve hosting ağlarından, bunlar üzerinde çalışan VPN'lerden ve Tor çıkış düğümlerinden gelen ziyaretçiler white page'i görür. Konut proxy'leri ücretli bir IP veritabanı olmadan tanınamaz.",
  "Offer only with a Google Ads click ID": "Yalnızca Google Ads click ID ile teklif",
  "Real Google Ads clicks always carry gclid, gbraid or wbraid; reviewers and link checkers open the link without one. Visitors without a valid click ID get the safe page. Leave off if auto-tagging is disabled or the campaign gets other traffic.": "Gerçek Google Ads tıklamaları her zaman gclid, gbraid veya wbraid içerir; inceleyiciler ve bağlantı denetleyicileri linki bunlar olmadan açar. Geçerli bir click ID'si olmayan ziyaretçiler white page'i görür. Otomatik etiketleme devre dışıysa veya kampanya başka trafik alıyorsa kapalı bırakın.",
  "Show white page": "White page göster",
  "Shows the campaign white page (the page bots get) instead of an offer. Put it in a Default stream with no filters to send visitors that no other stream accepts to the white page instead of the target URL.": "Kampanyanın white page'ini (botların gördüğü sayfayı) teklif yerine gösterir. Başka hiçbir akışın kabul etmediği ziyaretçileri hedef URL yerine white page'e yönlendirmek için bunu filtresiz bir Default akışa yerleştirin.",
  "Transparent mode fetches the page from our server, so the visitor IP and cookies never reach it. Use it only for your own landing pages, not for affiliate offer links, or conversions may not be counted.": "Şeffaf mod sayfayı sunucumuzdan çeker; bu nedenle ziyaretçinin IP'si ve çerezleri hiçbir zaman hedefe ulaşmaz. Yalnızca kendi landing page'leriniz için kullanın; affiliate teklif linkleri için kullanmayın, aksi takdirde dönüşümler sayılmayabilir.",
  "Check failed": "Kontrol başarısız oldu",
  "Can be shown in iframe mode": "iframe modunda gösterilebilir",
  "Blocked: visitors will see an empty screen in iframe mode": "Engellendi: iframe modunda ziyaretçiler boş bir ekran görecek",
  "Could not confirm: test it on a real phone before launch": "Doğrulanamadı: yayına almadan önce gerçek bir telefonda test edin",
  "Check that the page allows framing. Paste the final offer or landing URL your streams send visitors to.": "Sayfanın çerçevelemeye izin verdiğini kontrol edin. Akışlarınızın ziyaretçileri yönlendirdiği nihai teklif veya landing page URL'sini yapıştırın.",
  "Checking…": "Kontrol ediliyor…",
  "Check framing": "Çerçevelemeyi kontrol et",
};

export default tr;
